(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// packages/alpinejs/src/scheduler.js
var $f111f945f972b324$var$flushPending = false;
var $f111f945f972b324$var$flushing = false;
var $f111f945f972b324$var$queue = [];
var $f111f945f972b324$var$lastFlushedIndex = -1;
function $f111f945f972b324$var$scheduler(callback) {
    $f111f945f972b324$var$queueJob(callback);
}
function $f111f945f972b324$var$queueJob(job) {
    if (!$f111f945f972b324$var$queue.includes(job)) $f111f945f972b324$var$queue.push(job);
    $f111f945f972b324$var$queueFlush();
}
function $f111f945f972b324$var$dequeueJob(job) {
    let index = $f111f945f972b324$var$queue.indexOf(job);
    if (index !== -1 && index > $f111f945f972b324$var$lastFlushedIndex) $f111f945f972b324$var$queue.splice(index, 1);
}
function $f111f945f972b324$var$queueFlush() {
    if (!$f111f945f972b324$var$flushing && !$f111f945f972b324$var$flushPending) {
        $f111f945f972b324$var$flushPending = true;
        queueMicrotask($f111f945f972b324$var$flushJobs);
    }
}
function $f111f945f972b324$var$flushJobs() {
    $f111f945f972b324$var$flushPending = false;
    $f111f945f972b324$var$flushing = true;
    for(let i = 0; i < $f111f945f972b324$var$queue.length; i++){
        $f111f945f972b324$var$queue[i]();
        $f111f945f972b324$var$lastFlushedIndex = i;
    }
    $f111f945f972b324$var$queue.length = 0;
    $f111f945f972b324$var$lastFlushedIndex = -1;
    $f111f945f972b324$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $f111f945f972b324$var$reactive;
var $f111f945f972b324$var$effect;
var $f111f945f972b324$var$release;
var $f111f945f972b324$var$raw;
var $f111f945f972b324$var$shouldSchedule = true;
function $f111f945f972b324$var$disableEffectScheduling(callback) {
    $f111f945f972b324$var$shouldSchedule = false;
    callback();
    $f111f945f972b324$var$shouldSchedule = true;
}
function $f111f945f972b324$var$setReactivityEngine(engine) {
    $f111f945f972b324$var$reactive = engine.reactive;
    $f111f945f972b324$var$release = engine.release;
    $f111f945f972b324$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($f111f945f972b324$var$shouldSchedule) $f111f945f972b324$var$scheduler(task);
                else task();
            }
        });
    $f111f945f972b324$var$raw = engine.raw;
}
function $f111f945f972b324$var$overrideEffect(override) {
    $f111f945f972b324$var$effect = override;
}
function $f111f945f972b324$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $f111f945f972b324$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $f111f945f972b324$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
// packages/alpinejs/src/utils/dispatch.js
function $f111f945f972b324$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $f111f945f972b324$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$f111f945f972b324$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $f111f945f972b324$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $f111f945f972b324$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $f111f945f972b324$var$started = false;
function $f111f945f972b324$var$start() {
    if ($f111f945f972b324$var$started) $f111f945f972b324$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $f111f945f972b324$var$started = true;
    if (!document.body) $f111f945f972b324$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $f111f945f972b324$var$dispatch(document, "alpine:init");
    $f111f945f972b324$var$dispatch(document, "alpine:initializing");
    $f111f945f972b324$var$startObservingMutations();
    $f111f945f972b324$var$onElAdded((el)=>$f111f945f972b324$var$initTree(el, $f111f945f972b324$var$walk));
    $f111f945f972b324$var$onElRemoved((el)=>$f111f945f972b324$var$destroyTree(el));
    $f111f945f972b324$var$onAttributesAdded((el, attrs)=>{
        $f111f945f972b324$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$f111f945f972b324$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($f111f945f972b324$var$allSelectors())).filter(outNestedComponents).forEach((el)=>{
        $f111f945f972b324$var$initTree(el);
    });
    $f111f945f972b324$var$dispatch(document, "alpine:initialized");
}
var $f111f945f972b324$var$rootSelectorCallbacks = [];
var $f111f945f972b324$var$initSelectorCallbacks = [];
function $f111f945f972b324$var$rootSelectors() {
    return $f111f945f972b324$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $f111f945f972b324$var$allSelectors() {
    return $f111f945f972b324$var$rootSelectorCallbacks.concat($f111f945f972b324$var$initSelectorCallbacks).map((fn)=>fn());
}
function $f111f945f972b324$var$addRootSelector(selectorCallback) {
    $f111f945f972b324$var$rootSelectorCallbacks.push(selectorCallback);
}
function $f111f945f972b324$var$addInitSelector(selectorCallback) {
    $f111f945f972b324$var$initSelectorCallbacks.push(selectorCallback);
}
function $f111f945f972b324$var$closestRoot(el, includeInitSelectors = false) {
    return $f111f945f972b324$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $f111f945f972b324$var$allSelectors() : $f111f945f972b324$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $f111f945f972b324$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $f111f945f972b324$var$findClosest(el.parentElement, callback);
}
function $f111f945f972b324$var$isRoot(el) {
    return $f111f945f972b324$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $f111f945f972b324$var$initInterceptors = [];
function $f111f945f972b324$var$interceptInit(callback) {
    $f111f945f972b324$var$initInterceptors.push(callback);
}
function $f111f945f972b324$var$initTree(el, walker = $f111f945f972b324$var$walk, intercept = ()=>{}) {
    $f111f945f972b324$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $f111f945f972b324$var$initInterceptors.forEach((i)=>i(el2, skip));
            $f111f945f972b324$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $f111f945f972b324$var$destroyTree(root) {
    $f111f945f972b324$var$walk(root, (el)=>{
        $f111f945f972b324$var$cleanupAttributes(el);
        $f111f945f972b324$var$cleanupElement(el);
    });
}
// packages/alpinejs/src/mutation.js
var $f111f945f972b324$var$onAttributeAddeds = [];
var $f111f945f972b324$var$onElRemoveds = [];
var $f111f945f972b324$var$onElAddeds = [];
function $f111f945f972b324$var$onElAdded(callback) {
    $f111f945f972b324$var$onElAddeds.push(callback);
}
function $f111f945f972b324$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $f111f945f972b324$var$onElRemoveds.push(callback);
    }
}
function $f111f945f972b324$var$onAttributesAdded(callback) {
    $f111f945f972b324$var$onAttributeAddeds.push(callback);
}
function $f111f945f972b324$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $f111f945f972b324$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $f111f945f972b324$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $f111f945f972b324$var$observer = new MutationObserver($f111f945f972b324$var$onMutate);
var $f111f945f972b324$var$currentlyObserving = false;
function $f111f945f972b324$var$startObservingMutations() {
    $f111f945f972b324$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $f111f945f972b324$var$currentlyObserving = true;
}
function $f111f945f972b324$var$stopObservingMutations() {
    $f111f945f972b324$var$flushObserver();
    $f111f945f972b324$var$observer.disconnect();
    $f111f945f972b324$var$currentlyObserving = false;
}
var $f111f945f972b324$var$recordQueue = [];
var $f111f945f972b324$var$willProcessRecordQueue = false;
function $f111f945f972b324$var$flushObserver() {
    $f111f945f972b324$var$recordQueue = $f111f945f972b324$var$recordQueue.concat($f111f945f972b324$var$observer.takeRecords());
    if ($f111f945f972b324$var$recordQueue.length && !$f111f945f972b324$var$willProcessRecordQueue) {
        $f111f945f972b324$var$willProcessRecordQueue = true;
        queueMicrotask(()=>{
            $f111f945f972b324$var$processRecordQueue();
            $f111f945f972b324$var$willProcessRecordQueue = false;
        });
    }
}
function $f111f945f972b324$var$processRecordQueue() {
    $f111f945f972b324$var$onMutate($f111f945f972b324$var$recordQueue);
    $f111f945f972b324$var$recordQueue.length = 0;
}
function $f111f945f972b324$var$mutateDom(callback) {
    if (!$f111f945f972b324$var$currentlyObserving) return callback();
    $f111f945f972b324$var$stopObservingMutations();
    let result = callback();
    $f111f945f972b324$var$startObservingMutations();
    return result;
}
var $f111f945f972b324$var$isCollecting = false;
var $f111f945f972b324$var$deferredMutations = [];
function $f111f945f972b324$var$deferMutations() {
    $f111f945f972b324$var$isCollecting = true;
}
function $f111f945f972b324$var$flushAndStopDeferringMutations() {
    $f111f945f972b324$var$isCollecting = false;
    $f111f945f972b324$var$onMutate($f111f945f972b324$var$deferredMutations);
    $f111f945f972b324$var$deferredMutations = [];
}
function $f111f945f972b324$var$onMutate(mutations) {
    if ($f111f945f972b324$var$isCollecting) {
        $f111f945f972b324$var$deferredMutations = $f111f945f972b324$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = [];
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.push(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.push(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $f111f945f972b324$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $f111f945f972b324$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.includes(node)) continue;
        $f111f945f972b324$var$onElRemoveds.forEach((i)=>i(node));
        $f111f945f972b324$var$destroyTree(node);
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.includes(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $f111f945f972b324$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $f111f945f972b324$var$scope(node) {
    return $f111f945f972b324$var$mergeProxies($f111f945f972b324$var$closestDataStack(node));
}
function $f111f945f972b324$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$f111f945f972b324$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $f111f945f972b324$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $f111f945f972b324$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $f111f945f972b324$var$closestDataStack(node.parentNode);
}
function $f111f945f972b324$var$mergeProxies(objects) {
    let thisProxy = new Proxy({}, {
        ownKeys: ()=>{
            return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
        },
        has: (target, name)=>{
            return objects.some((obj)=>obj.hasOwnProperty(name));
        },
        get: (target, name)=>{
            return (objects.find((obj)=>{
                if (obj.hasOwnProperty(name)) {
                    let descriptor = Object.getOwnPropertyDescriptor(obj, name);
                    if (descriptor.get && descriptor.get._x_alreadyBound || descriptor.set && descriptor.set._x_alreadyBound) return true;
                    if ((descriptor.get || descriptor.set) && descriptor.enumerable) {
                        let getter = descriptor.get;
                        let setter = descriptor.set;
                        let property = descriptor;
                        getter = getter && getter.bind(thisProxy);
                        setter = setter && setter.bind(thisProxy);
                        if (getter) getter._x_alreadyBound = true;
                        if (setter) setter._x_alreadyBound = true;
                        Object.defineProperty(obj, name, {
                            ...property,
                            get: getter,
                            set: setter
                        });
                    }
                    return true;
                }
                return false;
            }) || {})[name];
        },
        set: (target, name, value)=>{
            let closestObjectWithKey = objects.find((obj)=>obj.hasOwnProperty(name));
            if (closestObjectWithKey) closestObjectWithKey[name] = value;
            else objects[objects.length - 1][name] = value;
            return true;
        }
    });
    return thisProxy;
}
// packages/alpinejs/src/interceptor.js
function $f111f945f972b324$var$initInterceptors2(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $f111f945f972b324$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$f111f945f972b324$var$get(data2, path), (value)=>$f111f945f972b324$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $f111f945f972b324$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $f111f945f972b324$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $f111f945f972b324$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $f111f945f972b324$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $f111f945f972b324$var$magics = {};
function $f111f945f972b324$var$magic(name, callback) {
    $f111f945f972b324$var$magics[name] = callback;
}
function $f111f945f972b324$var$injectMagics(obj, el) {
    Object.entries($f111f945f972b324$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $f111f945f972b324$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $f111f945f972b324$var$interceptor,
                    ...utilities
                };
                $f111f945f972b324$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $f111f945f972b324$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $f111f945f972b324$var$handleError(e, el, expression);
    }
}
function $f111f945f972b324$var$handleError(error2, el, expression) {
    Object.assign(error2, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $f111f945f972b324$var$shouldAutoEvaluateFunctions = true;
function $f111f945f972b324$var$dontAutoEvaluateFunctions(callback) {
    let cache = $f111f945f972b324$var$shouldAutoEvaluateFunctions;
    $f111f945f972b324$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $f111f945f972b324$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $f111f945f972b324$var$evaluate(el, expression, extras = {}) {
    let result;
    $f111f945f972b324$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $f111f945f972b324$var$evaluateLater(...args) {
    return $f111f945f972b324$var$theEvaluatorFunction(...args);
}
var $f111f945f972b324$var$theEvaluatorFunction = $f111f945f972b324$var$normalEvaluator;
function $f111f945f972b324$var$setEvaluator(newEvaluator) {
    $f111f945f972b324$var$theEvaluatorFunction = newEvaluator;
}
function $f111f945f972b324$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $f111f945f972b324$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$f111f945f972b324$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $f111f945f972b324$var$generateEvaluatorFromFunction(dataStack, expression) : $f111f945f972b324$var$generateEvaluatorFromString(dataStack, expression, el);
    return $f111f945f972b324$var$tryCatch.bind(null, el, expression, evaluator);
}
function $f111f945f972b324$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($f111f945f972b324$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $f111f945f972b324$var$runIfTypeOfFunction(receiver, result);
    };
}
var $f111f945f972b324$var$evaluatorMemo = {};
function $f111f945f972b324$var$generateFunctionFromString(expression, el) {
    if ($f111f945f972b324$var$evaluatorMemo[expression]) return $f111f945f972b324$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            return new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
        } catch (error2) {
            $f111f945f972b324$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $f111f945f972b324$var$evaluatorMemo[expression] = func;
    return func;
}
function $f111f945f972b324$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $f111f945f972b324$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $f111f945f972b324$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$f111f945f972b324$var$handleError(error2, el, expression));
            if (func.finished) {
                $f111f945f972b324$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $f111f945f972b324$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$f111f945f972b324$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $f111f945f972b324$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($f111f945f972b324$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$f111f945f972b324$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$f111f945f972b324$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $f111f945f972b324$var$prefixAsString = "x-";
function $f111f945f972b324$var$prefix(subject = "") {
    return $f111f945f972b324$var$prefixAsString + subject;
}
function $f111f945f972b324$var$setPrefix(newPrefix) {
    $f111f945f972b324$var$prefixAsString = newPrefix;
}
var $f111f945f972b324$var$directiveHandlers = {};
function $f111f945f972b324$var$directive(name, callback) {
    $f111f945f972b324$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$f111f945f972b324$var$directiveHandlers[directive2]) {
                console.warn("Cannot find directive `${directive}`. `${name}` will use the default order of execution");
                return;
            }
            const pos = $f111f945f972b324$var$directiveOrder.indexOf(directive2);
            $f111f945f972b324$var$directiveOrder.splice(pos >= 0 ? pos : $f111f945f972b324$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $f111f945f972b324$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $f111f945f972b324$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($f111f945f972b324$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($f111f945f972b324$var$outNonAlpineAttributes).map($f111f945f972b324$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($f111f945f972b324$var$byPriority);
    return directives2.map((directive2)=>{
        return $f111f945f972b324$var$getDirectiveHandler(el, directive2);
    });
}
function $f111f945f972b324$var$attributesOnly(attributes) {
    return Array.from(attributes).map($f111f945f972b324$var$toTransformedAttributes()).filter((attr)=>!$f111f945f972b324$var$outNonAlpineAttributes(attr));
}
var $f111f945f972b324$var$isDeferringHandlers = false;
var $f111f945f972b324$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $f111f945f972b324$var$currentHandlerStackKey = Symbol();
function $f111f945f972b324$var$deferHandlingDirectives(callback) {
    $f111f945f972b324$var$isDeferringHandlers = true;
    let key = Symbol();
    $f111f945f972b324$var$currentHandlerStackKey = key;
    $f111f945f972b324$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($f111f945f972b324$var$directiveHandlerStacks.get(key).length)$f111f945f972b324$var$directiveHandlerStacks.get(key).shift()();
        $f111f945f972b324$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $f111f945f972b324$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $f111f945f972b324$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $f111f945f972b324$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $f111f945f972b324$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $f111f945f972b324$var$evaluateLater.bind($f111f945f972b324$var$evaluateLater, el),
        evaluate: $f111f945f972b324$var$evaluate.bind($f111f945f972b324$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $f111f945f972b324$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $f111f945f972b324$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $f111f945f972b324$var$getElementBoundUtilities(el);
    $f111f945f972b324$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $f111f945f972b324$var$isDeferringHandlers ? $f111f945f972b324$var$directiveHandlerStacks.get($f111f945f972b324$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $f111f945f972b324$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $f111f945f972b324$var$into = (i)=>i;
function $f111f945f972b324$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $f111f945f972b324$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $f111f945f972b324$var$attributeTransformers = [];
function $f111f945f972b324$var$mapAttributes(callback) {
    $f111f945f972b324$var$attributeTransformers.push(callback);
}
function $f111f945f972b324$var$outNonAlpineAttributes({ name: name }) {
    return $f111f945f972b324$var$alpineAttributeRegex().test(name);
}
var $f111f945f972b324$var$alpineAttributeRegex = ()=>new RegExp(`^${$f111f945f972b324$var$prefixAsString}([^:^.]+)\\b`);
function $f111f945f972b324$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($f111f945f972b324$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $f111f945f972b324$var$DEFAULT = "DEFAULT";
var $f111f945f972b324$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $f111f945f972b324$var$DEFAULT,
    "teleport"
];
function $f111f945f972b324$var$byPriority(a, b) {
    let typeA = $f111f945f972b324$var$directiveOrder.indexOf(a.type) === -1 ? $f111f945f972b324$var$DEFAULT : a.type;
    let typeB = $f111f945f972b324$var$directiveOrder.indexOf(b.type) === -1 ? $f111f945f972b324$var$DEFAULT : b.type;
    return $f111f945f972b324$var$directiveOrder.indexOf(typeA) - $f111f945f972b324$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/nextTick.js
var $f111f945f972b324$var$tickStack = [];
var $f111f945f972b324$var$isHolding = false;
function $f111f945f972b324$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $f111f945f972b324$var$isHolding || setTimeout(()=>{
            $f111f945f972b324$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $f111f945f972b324$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $f111f945f972b324$var$releaseNextTicks() {
    $f111f945f972b324$var$isHolding = false;
    while($f111f945f972b324$var$tickStack.length)$f111f945f972b324$var$tickStack.shift()();
}
function $f111f945f972b324$var$holdNextTicks() {
    $f111f945f972b324$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $f111f945f972b324$var$setClasses(el, value) {
    if (Array.isArray(value)) return $f111f945f972b324$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $f111f945f972b324$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $f111f945f972b324$var$setClasses(el, value());
    return $f111f945f972b324$var$setClassesFromString(el, value);
}
function $f111f945f972b324$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $f111f945f972b324$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $f111f945f972b324$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $f111f945f972b324$var$setStylesFromObject(el, value);
    return $f111f945f972b324$var$setStylesFromString(el, value);
}
function $f111f945f972b324$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $f111f945f972b324$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $f111f945f972b324$var$setStyles(el, previousStyles);
    };
}
function $f111f945f972b324$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $f111f945f972b324$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $f111f945f972b324$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$f111f945f972b324$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $f111f945f972b324$var$registerTransitionsFromHelper(el, modifiers, value);
    else $f111f945f972b324$var$registerTransitionsFromClassString(el, expression, value);
});
function $f111f945f972b324$var$registerTransitionsFromClassString(el, classString, stage) {
    $f111f945f972b324$var$registerTransitionObject(el, $f111f945f972b324$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $f111f945f972b324$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $f111f945f972b324$var$registerTransitionObject(el, $f111f945f972b324$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $f111f945f972b324$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $f111f945f972b324$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $f111f945f972b324$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $f111f945f972b324$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $f111f945f972b324$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $f111f945f972b324$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $f111f945f972b324$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $f111f945f972b324$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $f111f945f972b324$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $f111f945f972b324$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $f111f945f972b324$var$closestHide(parent);
}
function $f111f945f972b324$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $f111f945f972b324$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $f111f945f972b324$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $f111f945f972b324$var$once(()=>{
        $f111f945f972b324$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $f111f945f972b324$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $f111f945f972b324$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $f111f945f972b324$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $f111f945f972b324$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $f111f945f972b324$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $f111f945f972b324$var$mutateDom(()=>{
                stages.end();
            });
            $f111f945f972b324$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $f111f945f972b324$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $f111f945f972b324$var$isCloning = false;
function $f111f945f972b324$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$f111f945f972b324$var$isCloning ? fallback(...args) : callback(...args);
}
function $f111f945f972b324$var$onlyDuringClone(callback) {
    return (...args)=>$f111f945f972b324$var$isCloning && callback(...args);
}
function $f111f945f972b324$var$cloneNode(from, to) {
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
    $f111f945f972b324$var$isCloning = true;
    $f111f945f972b324$var$dontRegisterReactiveSideEffects(()=>{
        $f111f945f972b324$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $f111f945f972b324$var$isCloning = false;
}
var $f111f945f972b324$var$isCloningLegacy = false;
function $f111f945f972b324$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $f111f945f972b324$var$isCloning = true;
    $f111f945f972b324$var$isCloningLegacy = true;
    $f111f945f972b324$var$dontRegisterReactiveSideEffects(()=>{
        $f111f945f972b324$var$cloneTree(newEl);
    });
    $f111f945f972b324$var$isCloning = false;
    $f111f945f972b324$var$isCloningLegacy = false;
}
function $f111f945f972b324$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $f111f945f972b324$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $f111f945f972b324$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $f111f945f972b324$var$initTree(el, shallowWalker);
}
function $f111f945f972b324$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $f111f945f972b324$var$effect;
    $f111f945f972b324$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $f111f945f972b324$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $f111f945f972b324$var$overrideEffect(cache);
}
function $f111f945f972b324$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$f111f945f972b324$var$isCloning) return false;
    if ($f111f945f972b324$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/utils/bind.js
function $f111f945f972b324$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $f111f945f972b324$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $f111f945f972b324$var$camelCase(name) : name;
    switch(name){
        case "value":
            $f111f945f972b324$var$bindInputValue(el, value);
            break;
        case "style":
            $f111f945f972b324$var$bindStyles(el, value);
            break;
        case "class":
            $f111f945f972b324$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $f111f945f972b324$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $f111f945f972b324$var$bindAttribute(el, name, value);
            break;
    }
}
function $f111f945f972b324$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) el.checked = $f111f945f972b324$var$checkedAttrLooseCompare(el.value, value);
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$f111f945f972b324$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $f111f945f972b324$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $f111f945f972b324$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $f111f945f972b324$var$setClasses(el, value);
}
function $f111f945f972b324$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $f111f945f972b324$var$setStyles(el, value);
}
function $f111f945f972b324$var$bindAttributeAndProperty(el, name, value) {
    $f111f945f972b324$var$bindAttribute(el, name, value);
    $f111f945f972b324$var$setPropertyIfChanged(el, name, value);
}
function $f111f945f972b324$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $f111f945f972b324$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($f111f945f972b324$var$isBooleanAttr(name)) value = name;
        $f111f945f972b324$var$setIfChanged(el, name, value);
    }
}
function $f111f945f972b324$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $f111f945f972b324$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $f111f945f972b324$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $f111f945f972b324$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f111f945f972b324$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $f111f945f972b324$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $f111f945f972b324$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $f111f945f972b324$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $f111f945f972b324$var$getAttributeBinding(el, name, fallback);
}
function $f111f945f972b324$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $f111f945f972b324$var$dontAutoEvaluateFunctions(()=>{
            return $f111f945f972b324$var$evaluate(el, binding.expression);
        });
    }
    return $f111f945f972b324$var$getAttributeBinding(el, name, fallback);
}
function $f111f945f972b324$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($f111f945f972b324$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $f111f945f972b324$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $f111f945f972b324$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $f111f945f972b324$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash, innerHash, outerHashLatest, innerHashLatest;
    let reference = $f111f945f972b324$var$effect(()=>{
        let outer, inner;
        if (firstRun) {
            outer = outerGet();
            innerSet(JSON.parse(JSON.stringify(outer)));
            inner = innerGet();
            firstRun = false;
        } else {
            outer = outerGet();
            inner = innerGet();
            outerHashLatest = JSON.stringify(outer);
            innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) {
                inner = innerGet();
                innerSet(outer);
                inner = outer;
            } else {
                outerSet(JSON.parse(innerHashLatest ?? null));
                outer = inner;
            }
        }
        outerHash = JSON.stringify(outer);
        innerHash = JSON.stringify(inner);
    });
    return ()=>{
        $f111f945f972b324$var$release(reference);
    };
}
// packages/alpinejs/src/plugin.js
function $f111f945f972b324$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($f111f945f972b324$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $f111f945f972b324$var$stores = {};
var $f111f945f972b324$var$isReactive = false;
function $f111f945f972b324$var$store(name, value) {
    if (!$f111f945f972b324$var$isReactive) {
        $f111f945f972b324$var$stores = $f111f945f972b324$var$reactive($f111f945f972b324$var$stores);
        $f111f945f972b324$var$isReactive = true;
    }
    if (value === void 0) return $f111f945f972b324$var$stores[name];
    $f111f945f972b324$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $f111f945f972b324$var$stores[name].init();
    $f111f945f972b324$var$initInterceptors2($f111f945f972b324$var$stores[name]);
}
function $f111f945f972b324$var$getStores() {
    return $f111f945f972b324$var$stores;
}
// packages/alpinejs/src/binds.js
var $f111f945f972b324$var$binds = {};
function $f111f945f972b324$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $f111f945f972b324$var$applyBindingsObject(name, getBindings());
    else $f111f945f972b324$var$binds[name] = getBindings;
    return ()=>{};
}
function $f111f945f972b324$var$injectBindingProviders(obj) {
    Object.entries($f111f945f972b324$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $f111f945f972b324$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $f111f945f972b324$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $f111f945f972b324$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $f111f945f972b324$var$datas = {};
function $f111f945f972b324$var$data(name, callback) {
    $f111f945f972b324$var$datas[name] = callback;
}
function $f111f945f972b324$var$injectDataProviders(obj, context) {
    Object.entries($f111f945f972b324$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $f111f945f972b324$var$Alpine = {
    get reactive () {
        return $f111f945f972b324$var$reactive;
    },
    get release () {
        return $f111f945f972b324$var$release;
    },
    get effect () {
        return $f111f945f972b324$var$effect;
    },
    get raw () {
        return $f111f945f972b324$var$raw;
    },
    version: "3.13.0",
    flushAndStopDeferringMutations: $f111f945f972b324$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $f111f945f972b324$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $f111f945f972b324$var$disableEffectScheduling,
    startObservingMutations: $f111f945f972b324$var$startObservingMutations,
    stopObservingMutations: $f111f945f972b324$var$stopObservingMutations,
    setReactivityEngine: $f111f945f972b324$var$setReactivityEngine,
    onAttributeRemoved: $f111f945f972b324$var$onAttributeRemoved,
    onAttributesAdded: $f111f945f972b324$var$onAttributesAdded,
    closestDataStack: $f111f945f972b324$var$closestDataStack,
    skipDuringClone: $f111f945f972b324$var$skipDuringClone,
    onlyDuringClone: $f111f945f972b324$var$onlyDuringClone,
    addRootSelector: $f111f945f972b324$var$addRootSelector,
    addInitSelector: $f111f945f972b324$var$addInitSelector,
    addScopeToNode: $f111f945f972b324$var$addScopeToNode,
    deferMutations: $f111f945f972b324$var$deferMutations,
    mapAttributes: $f111f945f972b324$var$mapAttributes,
    evaluateLater: $f111f945f972b324$var$evaluateLater,
    interceptInit: $f111f945f972b324$var$interceptInit,
    setEvaluator: $f111f945f972b324$var$setEvaluator,
    mergeProxies: $f111f945f972b324$var$mergeProxies,
    extractProp: $f111f945f972b324$var$extractProp,
    findClosest: $f111f945f972b324$var$findClosest,
    onElRemoved: $f111f945f972b324$var$onElRemoved,
    closestRoot: $f111f945f972b324$var$closestRoot,
    destroyTree: $f111f945f972b324$var$destroyTree,
    interceptor: $f111f945f972b324$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $f111f945f972b324$var$transition,
    setStyles: // INTERNAL
    $f111f945f972b324$var$setStyles,
    mutateDom: // INTERNAL
    $f111f945f972b324$var$mutateDom,
    directive: $f111f945f972b324$var$directive,
    entangle: $f111f945f972b324$var$entangle,
    throttle: $f111f945f972b324$var$throttle,
    debounce: $f111f945f972b324$var$debounce,
    evaluate: $f111f945f972b324$var$evaluate,
    initTree: $f111f945f972b324$var$initTree,
    nextTick: $f111f945f972b324$var$nextTick,
    prefixed: $f111f945f972b324$var$prefix,
    prefix: $f111f945f972b324$var$setPrefix,
    plugin: $f111f945f972b324$var$plugin,
    magic: $f111f945f972b324$var$magic,
    store: $f111f945f972b324$var$store,
    start: $f111f945f972b324$var$start,
    clone: $f111f945f972b324$var$clone,
    cloneNode: // INTERNAL
    $f111f945f972b324$var$cloneNode,
    // INTERNAL
    bound: $f111f945f972b324$var$getBinding,
    $data: $f111f945f972b324$var$scope,
    walk: $f111f945f972b324$var$walk,
    data: $f111f945f972b324$var$data,
    bind: $f111f945f972b324$var$bind2
};
var $f111f945f972b324$var$alpine_default = $f111f945f972b324$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $f111f945f972b324$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $f111f945f972b324$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $f111f945f972b324$var$isBooleanAttr2 = /* @__PURE__ */ $f111f945f972b324$var$makeMap($f111f945f972b324$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $f111f945f972b324$var$EMPTY_OBJ = Object.freeze({});
var $f111f945f972b324$var$EMPTY_ARR = Object.freeze([]);
var $f111f945f972b324$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f111f945f972b324$var$hasOwn = (val, key)=>$f111f945f972b324$var$hasOwnProperty.call(val, key);
var $f111f945f972b324$var$isArray = Array.isArray;
var $f111f945f972b324$var$isMap = (val)=>$f111f945f972b324$var$toTypeString(val) === "[object Map]";
var $f111f945f972b324$var$isString = (val)=>typeof val === "string";
var $f111f945f972b324$var$isSymbol = (val)=>typeof val === "symbol";
var $f111f945f972b324$var$isObject = (val)=>val !== null && typeof val === "object";
var $f111f945f972b324$var$objectToString = Object.prototype.toString;
var $f111f945f972b324$var$toTypeString = (value)=>$f111f945f972b324$var$objectToString.call(value);
var $f111f945f972b324$var$toRawType = (value)=>{
    return $f111f945f972b324$var$toTypeString(value).slice(8, -1);
};
var $f111f945f972b324$var$isIntegerKey = (key)=>$f111f945f972b324$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $f111f945f972b324$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $f111f945f972b324$var$camelizeRE = /-(\w)/g;
var $f111f945f972b324$var$camelize = $f111f945f972b324$var$cacheStringFunction((str)=>{
    return str.replace($f111f945f972b324$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $f111f945f972b324$var$hyphenateRE = /\B([A-Z])/g;
var $f111f945f972b324$var$hyphenate = $f111f945f972b324$var$cacheStringFunction((str)=>str.replace($f111f945f972b324$var$hyphenateRE, "-$1").toLowerCase());
var $f111f945f972b324$var$capitalize = $f111f945f972b324$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $f111f945f972b324$var$toHandlerKey = $f111f945f972b324$var$cacheStringFunction((str)=>str ? `on${$f111f945f972b324$var$capitalize(str)}` : ``);
var $f111f945f972b324$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $f111f945f972b324$var$targetMap = /* @__PURE__ */ new WeakMap();
var $f111f945f972b324$var$effectStack = [];
var $f111f945f972b324$var$activeEffect;
var $f111f945f972b324$var$ITERATE_KEY = Symbol("iterate");
var $f111f945f972b324$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $f111f945f972b324$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $f111f945f972b324$var$effect2(fn, options = $f111f945f972b324$var$EMPTY_OBJ) {
    if ($f111f945f972b324$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $f111f945f972b324$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $f111f945f972b324$var$stop(effect3) {
    if (effect3.active) {
        $f111f945f972b324$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $f111f945f972b324$var$uid = 0;
function $f111f945f972b324$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$f111f945f972b324$var$effectStack.includes(effect3)) {
            $f111f945f972b324$var$cleanup(effect3);
            try {
                $f111f945f972b324$var$enableTracking();
                $f111f945f972b324$var$effectStack.push(effect3);
                $f111f945f972b324$var$activeEffect = effect3;
                return fn();
            } finally{
                $f111f945f972b324$var$effectStack.pop();
                $f111f945f972b324$var$resetTracking();
                $f111f945f972b324$var$activeEffect = $f111f945f972b324$var$effectStack[$f111f945f972b324$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $f111f945f972b324$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $f111f945f972b324$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $f111f945f972b324$var$shouldTrack = true;
var $f111f945f972b324$var$trackStack = [];
function $f111f945f972b324$var$pauseTracking() {
    $f111f945f972b324$var$trackStack.push($f111f945f972b324$var$shouldTrack);
    $f111f945f972b324$var$shouldTrack = false;
}
function $f111f945f972b324$var$enableTracking() {
    $f111f945f972b324$var$trackStack.push($f111f945f972b324$var$shouldTrack);
    $f111f945f972b324$var$shouldTrack = true;
}
function $f111f945f972b324$var$resetTracking() {
    const last = $f111f945f972b324$var$trackStack.pop();
    $f111f945f972b324$var$shouldTrack = last === void 0 ? true : last;
}
function $f111f945f972b324$var$track(target, type, key) {
    if (!$f111f945f972b324$var$shouldTrack || $f111f945f972b324$var$activeEffect === void 0) return;
    let depsMap = $f111f945f972b324$var$targetMap.get(target);
    if (!depsMap) $f111f945f972b324$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($f111f945f972b324$var$activeEffect)) {
        dep.add($f111f945f972b324$var$activeEffect);
        $f111f945f972b324$var$activeEffect.deps.push(dep);
        if ($f111f945f972b324$var$activeEffect.options.onTrack) $f111f945f972b324$var$activeEffect.options.onTrack({
            effect: $f111f945f972b324$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $f111f945f972b324$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $f111f945f972b324$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $f111f945f972b324$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $f111f945f972b324$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$f111f945f972b324$var$isArray(target)) {
                    add2(depsMap.get($f111f945f972b324$var$ITERATE_KEY));
                    if ($f111f945f972b324$var$isMap(target)) add2(depsMap.get($f111f945f972b324$var$MAP_KEY_ITERATE_KEY));
                } else if ($f111f945f972b324$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$f111f945f972b324$var$isArray(target)) {
                    add2(depsMap.get($f111f945f972b324$var$ITERATE_KEY));
                    if ($f111f945f972b324$var$isMap(target)) add2(depsMap.get($f111f945f972b324$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($f111f945f972b324$var$isMap(target)) add2(depsMap.get($f111f945f972b324$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $f111f945f972b324$var$isNonTrackableKeys = /* @__PURE__ */ $f111f945f972b324$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $f111f945f972b324$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($f111f945f972b324$var$isSymbol));
var $f111f945f972b324$var$get2 = /* @__PURE__ */ $f111f945f972b324$var$createGetter();
var $f111f945f972b324$var$readonlyGet = /* @__PURE__ */ $f111f945f972b324$var$createGetter(true);
var $f111f945f972b324$var$arrayInstrumentations = /* @__PURE__ */ $f111f945f972b324$var$createArrayInstrumentations();
function $f111f945f972b324$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $f111f945f972b324$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$f111f945f972b324$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($f111f945f972b324$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $f111f945f972b324$var$pauseTracking();
            const res = $f111f945f972b324$var$toRaw(this)[key].apply(this, args);
            $f111f945f972b324$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $f111f945f972b324$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $f111f945f972b324$var$shallowReadonlyMap : $f111f945f972b324$var$readonlyMap : shallow ? $f111f945f972b324$var$shallowReactiveMap : $f111f945f972b324$var$reactiveMap).get(target)) return target;
        const targetIsArray = $f111f945f972b324$var$isArray(target);
        if (!isReadonly && targetIsArray && $f111f945f972b324$var$hasOwn($f111f945f972b324$var$arrayInstrumentations, key)) return Reflect.get($f111f945f972b324$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($f111f945f972b324$var$isSymbol(key) ? $f111f945f972b324$var$builtInSymbols.has(key) : $f111f945f972b324$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $f111f945f972b324$var$track(target, "get", key);
        if (shallow) return res;
        if ($f111f945f972b324$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$f111f945f972b324$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($f111f945f972b324$var$isObject(res)) return isReadonly ? $f111f945f972b324$var$readonly(res) : $f111f945f972b324$var$reactive2(res);
        return res;
    };
}
var $f111f945f972b324$var$set2 = /* @__PURE__ */ $f111f945f972b324$var$createSetter();
function $f111f945f972b324$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $f111f945f972b324$var$toRaw(value);
            oldValue = $f111f945f972b324$var$toRaw(oldValue);
            if (!$f111f945f972b324$var$isArray(target) && $f111f945f972b324$var$isRef(oldValue) && !$f111f945f972b324$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $f111f945f972b324$var$isArray(target) && $f111f945f972b324$var$isIntegerKey(key) ? Number(key) < target.length : $f111f945f972b324$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $f111f945f972b324$var$toRaw(receiver)) {
            if (!hadKey) $f111f945f972b324$var$trigger(target, "add", key, value);
            else if ($f111f945f972b324$var$hasChanged(value, oldValue)) $f111f945f972b324$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $f111f945f972b324$var$deleteProperty(target, key) {
    const hadKey = $f111f945f972b324$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $f111f945f972b324$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f111f945f972b324$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$f111f945f972b324$var$isSymbol(key) || !$f111f945f972b324$var$builtInSymbols.has(key)) $f111f945f972b324$var$track(target, "has", key);
    return result;
}
function $f111f945f972b324$var$ownKeys(target) {
    $f111f945f972b324$var$track(target, "iterate", $f111f945f972b324$var$isArray(target) ? "length" : $f111f945f972b324$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $f111f945f972b324$var$mutableHandlers = {
    get: $f111f945f972b324$var$get2,
    set: $f111f945f972b324$var$set2,
    deleteProperty: $f111f945f972b324$var$deleteProperty,
    has: $f111f945f972b324$var$has,
    ownKeys: $f111f945f972b324$var$ownKeys
};
var $f111f945f972b324$var$readonlyHandlers = {
    get: $f111f945f972b324$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $f111f945f972b324$var$toReactive = (value)=>$f111f945f972b324$var$isObject(value) ? $f111f945f972b324$var$reactive2(value) : value;
var $f111f945f972b324$var$toReadonly = (value)=>$f111f945f972b324$var$isObject(value) ? $f111f945f972b324$var$readonly(value) : value;
var $f111f945f972b324$var$toShallow = (value)=>value;
var $f111f945f972b324$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $f111f945f972b324$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $f111f945f972b324$var$toRaw(target);
    const rawKey = $f111f945f972b324$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f111f945f972b324$var$track(rawTarget, "get", key);
    !isReadonly && $f111f945f972b324$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $f111f945f972b324$var$getProto(rawTarget);
    const wrap = isShallow ? $f111f945f972b324$var$toShallow : isReadonly ? $f111f945f972b324$var$toReadonly : $f111f945f972b324$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $f111f945f972b324$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $f111f945f972b324$var$toRaw(target);
    const rawKey = $f111f945f972b324$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f111f945f972b324$var$track(rawTarget, "has", key);
    !isReadonly && $f111f945f972b324$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $f111f945f972b324$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $f111f945f972b324$var$track($f111f945f972b324$var$toRaw(target), "iterate", $f111f945f972b324$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $f111f945f972b324$var$add(value) {
    value = $f111f945f972b324$var$toRaw(value);
    const target = $f111f945f972b324$var$toRaw(this);
    const proto = $f111f945f972b324$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $f111f945f972b324$var$trigger(target, "add", value, value);
    }
    return this;
}
function $f111f945f972b324$var$set$1(key, value) {
    value = $f111f945f972b324$var$toRaw(value);
    const target = $f111f945f972b324$var$toRaw(this);
    const { has: has2, get: get3 } = $f111f945f972b324$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f111f945f972b324$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f111f945f972b324$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $f111f945f972b324$var$trigger(target, "add", key, value);
    else if ($f111f945f972b324$var$hasChanged(value, oldValue)) $f111f945f972b324$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $f111f945f972b324$var$deleteEntry(key) {
    const target = $f111f945f972b324$var$toRaw(this);
    const { has: has2, get: get3 } = $f111f945f972b324$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f111f945f972b324$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f111f945f972b324$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $f111f945f972b324$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f111f945f972b324$var$clear() {
    const target = $f111f945f972b324$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $f111f945f972b324$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $f111f945f972b324$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $f111f945f972b324$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $f111f945f972b324$var$toRaw(target);
        const wrap = isShallow ? $f111f945f972b324$var$toShallow : isReadonly ? $f111f945f972b324$var$toReadonly : $f111f945f972b324$var$toReactive;
        !isReadonly && $f111f945f972b324$var$track(rawTarget, "iterate", $f111f945f972b324$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $f111f945f972b324$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $f111f945f972b324$var$toRaw(target);
        const targetIsMap = $f111f945f972b324$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $f111f945f972b324$var$toShallow : isReadonly ? $f111f945f972b324$var$toReadonly : $f111f945f972b324$var$toReactive;
        !isReadonly && $f111f945f972b324$var$track(rawTarget, "iterate", isKeyOnly ? $f111f945f972b324$var$MAP_KEY_ITERATE_KEY : $f111f945f972b324$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $f111f945f972b324$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$f111f945f972b324$var$capitalize(type)} operation ${key}failed: target is readonly.`, $f111f945f972b324$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $f111f945f972b324$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $f111f945f972b324$var$get$1(this, key);
        },
        get size () {
            return $f111f945f972b324$var$size(this);
        },
        has: $f111f945f972b324$var$has$1,
        add: $f111f945f972b324$var$add,
        set: $f111f945f972b324$var$set$1,
        delete: $f111f945f972b324$var$deleteEntry,
        clear: $f111f945f972b324$var$clear,
        forEach: $f111f945f972b324$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $f111f945f972b324$var$get$1(this, key, false, true);
        },
        get size () {
            return $f111f945f972b324$var$size(this);
        },
        has: $f111f945f972b324$var$has$1,
        add: $f111f945f972b324$var$add,
        set: $f111f945f972b324$var$set$1,
        delete: $f111f945f972b324$var$deleteEntry,
        clear: $f111f945f972b324$var$clear,
        forEach: $f111f945f972b324$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $f111f945f972b324$var$get$1(this, key, true);
        },
        get size () {
            return $f111f945f972b324$var$size(this, true);
        },
        has (key) {
            return $f111f945f972b324$var$has$1.call(this, key, true);
        },
        add: $f111f945f972b324$var$createReadonlyMethod("add"),
        set: $f111f945f972b324$var$createReadonlyMethod("set"),
        delete: $f111f945f972b324$var$createReadonlyMethod("delete"),
        clear: $f111f945f972b324$var$createReadonlyMethod("clear"),
        forEach: $f111f945f972b324$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $f111f945f972b324$var$get$1(this, key, true, true);
        },
        get size () {
            return $f111f945f972b324$var$size(this, true);
        },
        has (key) {
            return $f111f945f972b324$var$has$1.call(this, key, true);
        },
        add: $f111f945f972b324$var$createReadonlyMethod("add"),
        set: $f111f945f972b324$var$createReadonlyMethod("set"),
        delete: $f111f945f972b324$var$createReadonlyMethod("delete"),
        clear: $f111f945f972b324$var$createReadonlyMethod("clear"),
        forEach: $f111f945f972b324$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $f111f945f972b324$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $f111f945f972b324$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $f111f945f972b324$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $f111f945f972b324$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$f111f945f972b324$var$mutableInstrumentations, $f111f945f972b324$var$readonlyInstrumentations, $f111f945f972b324$var$shallowInstrumentations, $f111f945f972b324$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $f111f945f972b324$var$createInstrumentations();
function $f111f945f972b324$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $f111f945f972b324$var$shallowReadonlyInstrumentations : $f111f945f972b324$var$shallowInstrumentations : isReadonly ? $f111f945f972b324$var$readonlyInstrumentations : $f111f945f972b324$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($f111f945f972b324$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $f111f945f972b324$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $f111f945f972b324$var$createInstrumentationGetter(false, false)
};
var $f111f945f972b324$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $f111f945f972b324$var$createInstrumentationGetter(true, false)
};
function $f111f945f972b324$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $f111f945f972b324$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $f111f945f972b324$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $f111f945f972b324$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $f111f945f972b324$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $f111f945f972b324$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $f111f945f972b324$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $f111f945f972b324$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $f111f945f972b324$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $f111f945f972b324$var$targetTypeMap($f111f945f972b324$var$toRawType(value));
}
function $f111f945f972b324$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $f111f945f972b324$var$createReactiveObject(target, false, $f111f945f972b324$var$mutableHandlers, $f111f945f972b324$var$mutableCollectionHandlers, $f111f945f972b324$var$reactiveMap);
}
function $f111f945f972b324$var$readonly(target) {
    return $f111f945f972b324$var$createReactiveObject(target, true, $f111f945f972b324$var$readonlyHandlers, $f111f945f972b324$var$readonlyCollectionHandlers, $f111f945f972b324$var$readonlyMap);
}
function $f111f945f972b324$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$f111f945f972b324$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $f111f945f972b324$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $f111f945f972b324$var$toRaw(observed) {
    return observed && $f111f945f972b324$var$toRaw(observed["__v_raw"]) || observed;
}
function $f111f945f972b324$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$f111f945f972b324$var$magic("nextTick", ()=>$f111f945f972b324$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$f111f945f972b324$var$magic("dispatch", (el)=>$f111f945f972b324$var$dispatch.bind($f111f945f972b324$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$f111f945f972b324$var$magic("watch", (el, { evaluateLater: evaluateLater2, effect: effect3 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let firstTime = true;
        let oldValue;
        let effectReference = effect3(()=>evaluate2((value)=>{
                JSON.stringify(value);
                if (!firstTime) queueMicrotask(()=>{
                    callback(value, oldValue);
                    oldValue = value;
                });
                else oldValue = value;
                firstTime = false;
            }));
        el._x_effects.delete(effectReference);
    });
// packages/alpinejs/src/magics/$store.js
$f111f945f972b324$var$magic("store", $f111f945f972b324$var$getStores);
// packages/alpinejs/src/magics/$data.js
$f111f945f972b324$var$magic("data", (el)=>$f111f945f972b324$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$f111f945f972b324$var$magic("root", (el)=>$f111f945f972b324$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$f111f945f972b324$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $f111f945f972b324$var$mergeProxies($f111f945f972b324$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $f111f945f972b324$var$getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while(currentEl){
        if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
        currentEl = currentEl.parentNode;
    }
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $f111f945f972b324$var$globalIdMemo = {};
function $f111f945f972b324$var$findAndIncrementId(name) {
    if (!$f111f945f972b324$var$globalIdMemo[name]) $f111f945f972b324$var$globalIdMemo[name] = 0;
    return ++$f111f945f972b324$var$globalIdMemo[name];
}
function $f111f945f972b324$var$closestIdRoot(el, name) {
    return $f111f945f972b324$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $f111f945f972b324$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $f111f945f972b324$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$f111f945f972b324$var$magic("id", (el)=>(name, key = null)=>{
        let root = $f111f945f972b324$var$closestIdRoot(el, name);
        let id = root ? root._x_ids[name] : $f111f945f972b324$var$findAndIncrementId(name);
        return key ? `${name}-${id}-${key}` : `${name}-${id}`;
    });
// packages/alpinejs/src/magics/$el.js
$f111f945f972b324$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$f111f945f972b324$var$warnMissingPluginMagic("Focus", "focus", "focus");
$f111f945f972b324$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $f111f945f972b324$var$warnMissingPluginMagic(name, magicName, slug) {
    $f111f945f972b324$var$magic(magicName, (el)=>$f111f945f972b324$var$warn(`You can't use [$${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$f111f945f972b324$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $f111f945f972b324$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
var $f111f945f972b324$var$teleportContainerDuringClone = document.createElement("div");
$f111f945f972b324$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f111f945f972b324$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $f111f945f972b324$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $f111f945f972b324$var$teleportContainerDuringClone;
    })();
    if (!target) $f111f945f972b324$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $f111f945f972b324$var$addScopeToNode(clone2, {}, el);
    $f111f945f972b324$var$mutateDom(()=>{
        if (modifiers.includes("prepend")) target.parentNode.insertBefore(clone2, target);
        else if (modifiers.includes("append")) target.parentNode.insertBefore(clone2, target.nextSibling);
        else target.appendChild(clone2);
        $f111f945f972b324$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    cleanup2(()=>clone2.remove());
});
// packages/alpinejs/src/directives/x-ignore.js
var $f111f945f972b324$var$handler = ()=>{};
$f111f945f972b324$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$f111f945f972b324$var$directive("ignore", $f111f945f972b324$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$f111f945f972b324$var$directive("effect", (el, { expression: expression }, { effect: effect3 })=>effect3($f111f945f972b324$var$evaluateLater(el, expression)));
// packages/alpinejs/src/utils/on.js
function $f111f945f972b324$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $f111f945f972b324$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $f111f945f972b324$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $f111f945f972b324$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f111f945f972b324$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $f111f945f972b324$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f111f945f972b324$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    handler4 = wrapHandler(handler4, (next, e)=>{
        if ($f111f945f972b324$var$isKeyEvent(event)) {
            if ($f111f945f972b324$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $f111f945f972b324$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $f111f945f972b324$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f111f945f972b324$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f111f945f972b324$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $f111f945f972b324$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $f111f945f972b324$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $f111f945f972b324$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $f111f945f972b324$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $f111f945f972b324$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($f111f945f972b324$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $f111f945f972b324$var$keyToModifiers(key) {
    if (!key) return [];
    key = $f111f945f972b324$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$f111f945f972b324$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $f111f945f972b324$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $f111f945f972b324$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $f111f945f972b324$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $f111f945f972b324$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($f111f945f972b324$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $f111f945f972b324$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $f111f945f972b324$var$isCloning ? ()=>{} : $f111f945f972b324$var$on(el, event, modifiers, (e)=>{
        setValue($f111f945f972b324$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue())) el.dispatchEvent(new Event(event, {}));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $f111f945f972b324$var$on(el.form, "reset", [], (e)=>{
            $f111f945f972b324$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $f111f945f972b324$var$mutateDom(()=>$f111f945f972b324$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $f111f945f972b324$var$getInputValue(el, modifiers, event, currentValue) {
    return $f111f945f972b324$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail ?? event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = modifiers.includes("number") ? $f111f945f972b324$var$safeParseNumber(event.target.value) : event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$f111f945f972b324$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) return modifiers.includes("number") ? Array.from(event.target.selectedOptions).map((option)=>{
            let rawValue = option.value || option.text;
            return $f111f945f972b324$var$safeParseNumber(rawValue);
        }) : Array.from(event.target.selectedOptions).map((option)=>{
            return option.value || option.text;
        });
        else {
            let rawValue = event.target.value;
            return modifiers.includes("number") ? $f111f945f972b324$var$safeParseNumber(rawValue) : modifiers.includes("trim") ? rawValue.trim() : rawValue;
        }
    });
}
function $f111f945f972b324$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $f111f945f972b324$var$isNumeric2(number) ? number : rawValue;
}
function $f111f945f972b324$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $f111f945f972b324$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f111f945f972b324$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$f111f945f972b324$var$directive("cloak", (el)=>queueMicrotask(()=>$f111f945f972b324$var$mutateDom(()=>el.removeAttribute($f111f945f972b324$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$f111f945f972b324$var$addInitSelector(()=>`[${$f111f945f972b324$var$prefix("init")}]`);
$f111f945f972b324$var$directive("init", $f111f945f972b324$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$f111f945f972b324$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f111f945f972b324$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$f111f945f972b324$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f111f945f972b324$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $f111f945f972b324$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$f111f945f972b324$var$mapAttributes($f111f945f972b324$var$startingWith(":", $f111f945f972b324$var$into($f111f945f972b324$var$prefix("bind:"))));
var $f111f945f972b324$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3 })=>{
    if (!value) {
        let bindingProviders = {};
        $f111f945f972b324$var$injectBindingProviders(bindingProviders);
        let getBindings = $f111f945f972b324$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $f111f945f972b324$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $f111f945f972b324$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $f111f945f972b324$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $f111f945f972b324$var$mutateDom(()=>$f111f945f972b324$var$bind(el, value, result, modifiers));
        }));
};
$f111f945f972b324$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$f111f945f972b324$var$directive("bind", $f111f945f972b324$var$handler2);
function $f111f945f972b324$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$f111f945f972b324$var$addRootSelector(()=>`[${$f111f945f972b324$var$prefix("data")}]`);
$f111f945f972b324$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($f111f945f972b324$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $f111f945f972b324$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $f111f945f972b324$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $f111f945f972b324$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $f111f945f972b324$var$injectMagics(data2, el);
    let reactiveData = $f111f945f972b324$var$reactive(data2);
    $f111f945f972b324$var$initInterceptors2(reactiveData);
    let undo = $f111f945f972b324$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $f111f945f972b324$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $f111f945f972b324$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
// packages/alpinejs/src/directives/x-show.js
$f111f945f972b324$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $f111f945f972b324$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $f111f945f972b324$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $f111f945f972b324$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $f111f945f972b324$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$f111f945f972b324$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $f111f945f972b324$var$parseForExpression(expression);
    let evaluateItems = $f111f945f972b324$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $f111f945f972b324$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$f111f945f972b324$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $f111f945f972b324$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($f111f945f972b324$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $f111f945f972b324$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>keys.push(value2), {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $f111f945f972b324$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>keys.push(value), {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($f111f945f972b324$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $f111f945f972b324$var$mutateDom(()=>{
                if (!elForSpot) $f111f945f972b324$var$warn(`x-for ":key" is undefined or invalid`, templateEl);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $f111f945f972b324$var$reactive(scope2);
            $f111f945f972b324$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $f111f945f972b324$var$mutateDom(()=>{
                lastEl.after(clone2);
                $f111f945f972b324$var$initTree(clone2);
            });
            if (typeof key === "object") $f111f945f972b324$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $f111f945f972b324$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $f111f945f972b324$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $f111f945f972b324$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $f111f945f972b324$var$handler3() {}
$f111f945f972b324$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $f111f945f972b324$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$f111f945f972b324$var$directive("ref", $f111f945f972b324$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$f111f945f972b324$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let evaluate2 = $f111f945f972b324$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $f111f945f972b324$var$addScopeToNode(clone2, {}, el);
        $f111f945f972b324$var$mutateDom(()=>{
            el.after(clone2);
            $f111f945f972b324$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $f111f945f972b324$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($f111f945f972b324$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$f111f945f972b324$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$f111f945f972b324$var$setIdRoot(el, name));
});
// packages/alpinejs/src/directives/x-on.js
$f111f945f972b324$var$mapAttributes($f111f945f972b324$var$startingWith("@", $f111f945f972b324$var$into($f111f945f972b324$var$prefix("on:"))));
$f111f945f972b324$var$directive("on", $f111f945f972b324$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $f111f945f972b324$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $f111f945f972b324$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$f111f945f972b324$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$f111f945f972b324$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$f111f945f972b324$var$warnMissingPluginDirective("Focus", "trap", "focus");
$f111f945f972b324$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $f111f945f972b324$var$warnMissingPluginDirective(name, directiveName2, slug) {
    $f111f945f972b324$var$directive(directiveName2, (el)=>$f111f945f972b324$var$warn(`You can't use [x-${directiveName2}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$f111f945f972b324$var$alpine_default.setEvaluator($f111f945f972b324$var$normalEvaluator);
$f111f945f972b324$var$alpine_default.setReactivityEngine({
    reactive: $f111f945f972b324$var$reactive2,
    effect: $f111f945f972b324$var$effect2,
    release: $f111f945f972b324$var$stop,
    raw: $f111f945f972b324$var$toRaw
});
var $f111f945f972b324$var$src_default = $f111f945f972b324$var$alpine_default;
// packages/alpinejs/builds/module.js
var $f111f945f972b324$export$2e2bcd8739ae039 = $f111f945f972b324$var$src_default;


function $02e68f8ca5696f61$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $02e68f8ca5696f61$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $02e68f8ca5696f61$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $02e68f8ca5696f61$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $02e68f8ca5696f61$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $02e68f8ca5696f61$var$CREATED = 1;
var $02e68f8ca5696f61$var$MOUNTED = 2;
var $02e68f8ca5696f61$var$IDLE = 3;
var $02e68f8ca5696f61$var$MOVING = 4;
var $02e68f8ca5696f61$var$SCROLLING = 5;
var $02e68f8ca5696f61$var$DRAGGING = 6;
var $02e68f8ca5696f61$var$DESTROYED = 7;
var $02e68f8ca5696f61$var$STATES = {
    CREATED: $02e68f8ca5696f61$var$CREATED,
    MOUNTED: $02e68f8ca5696f61$var$MOUNTED,
    IDLE: $02e68f8ca5696f61$var$IDLE,
    MOVING: $02e68f8ca5696f61$var$MOVING,
    SCROLLING: $02e68f8ca5696f61$var$SCROLLING,
    DRAGGING: $02e68f8ca5696f61$var$DRAGGING,
    DESTROYED: $02e68f8ca5696f61$var$DESTROYED
};
function $02e68f8ca5696f61$var$empty(array) {
    array.length = 0;
}
function $02e68f8ca5696f61$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $02e68f8ca5696f61$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($02e68f8ca5696f61$var$slice(arguments, 1)));
}
var $02e68f8ca5696f61$var$nextTick = setTimeout;
var $02e68f8ca5696f61$var$noop = function noop() {};
function $02e68f8ca5696f61$var$raf(func) {
    return requestAnimationFrame(func);
}
function $02e68f8ca5696f61$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $02e68f8ca5696f61$var$isObject(subject) {
    return !$02e68f8ca5696f61$var$isNull(subject) && $02e68f8ca5696f61$var$typeOf("object", subject);
}
var $02e68f8ca5696f61$var$isArray = Array.isArray;
var $02e68f8ca5696f61$var$isFunction = $02e68f8ca5696f61$var$apply($02e68f8ca5696f61$var$typeOf, "function");
var $02e68f8ca5696f61$var$isString = $02e68f8ca5696f61$var$apply($02e68f8ca5696f61$var$typeOf, "string");
var $02e68f8ca5696f61$var$isUndefined = $02e68f8ca5696f61$var$apply($02e68f8ca5696f61$var$typeOf, "undefined");
function $02e68f8ca5696f61$var$isNull(subject) {
    return subject === null;
}
function $02e68f8ca5696f61$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $02e68f8ca5696f61$var$toArray(value) {
    return $02e68f8ca5696f61$var$isArray(value) ? value : [
        value
    ];
}
function $02e68f8ca5696f61$var$forEach(values, iteratee) {
    $02e68f8ca5696f61$var$toArray(values).forEach(iteratee);
}
function $02e68f8ca5696f61$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $02e68f8ca5696f61$var$push(array, items) {
    array.push.apply(array, $02e68f8ca5696f61$var$toArray(items));
    return array;
}
function $02e68f8ca5696f61$var$toggleClass(elm, classes, add) {
    if (elm) $02e68f8ca5696f61$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $02e68f8ca5696f61$var$addClass(elm, classes) {
    $02e68f8ca5696f61$var$toggleClass(elm, $02e68f8ca5696f61$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $02e68f8ca5696f61$var$append(parent, children) {
    $02e68f8ca5696f61$var$forEach(children, parent.appendChild.bind(parent));
}
function $02e68f8ca5696f61$var$before(nodes, ref) {
    $02e68f8ca5696f61$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $02e68f8ca5696f61$var$matches(elm, selector) {
    return $02e68f8ca5696f61$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $02e68f8ca5696f61$var$children(parent, selector) {
    var children2 = parent ? $02e68f8ca5696f61$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $02e68f8ca5696f61$var$matches(child, selector);
    }) : children2;
}
function $02e68f8ca5696f61$var$child(parent, selector) {
    return selector ? $02e68f8ca5696f61$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $02e68f8ca5696f61$var$ownKeys = Object.keys;
function $02e68f8ca5696f61$var$forOwn(object, iteratee, right) {
    if (object) (right ? $02e68f8ca5696f61$var$ownKeys(object).reverse() : $02e68f8ca5696f61$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $02e68f8ca5696f61$var$assign(object) {
    $02e68f8ca5696f61$var$slice(arguments, 1).forEach(function(source) {
        $02e68f8ca5696f61$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $02e68f8ca5696f61$var$merge(object) {
    $02e68f8ca5696f61$var$slice(arguments, 1).forEach(function(source) {
        $02e68f8ca5696f61$var$forOwn(source, function(value, key) {
            if ($02e68f8ca5696f61$var$isArray(value)) object[key] = value.slice();
            else if ($02e68f8ca5696f61$var$isObject(value)) object[key] = $02e68f8ca5696f61$var$merge({}, $02e68f8ca5696f61$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $02e68f8ca5696f61$var$omit(object, keys) {
    $02e68f8ca5696f61$var$forEach(keys || $02e68f8ca5696f61$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $02e68f8ca5696f61$var$removeAttribute(elms, attrs) {
    $02e68f8ca5696f61$var$forEach(elms, function(elm) {
        $02e68f8ca5696f61$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $02e68f8ca5696f61$var$setAttribute(elms, attrs, value) {
    if ($02e68f8ca5696f61$var$isObject(attrs)) $02e68f8ca5696f61$var$forOwn(attrs, function(value2, name) {
        $02e68f8ca5696f61$var$setAttribute(elms, name, value2);
    });
    else $02e68f8ca5696f61$var$forEach(elms, function(elm) {
        $02e68f8ca5696f61$var$isNull(value) || value === "" ? $02e68f8ca5696f61$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $02e68f8ca5696f61$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $02e68f8ca5696f61$var$isString(attrs) ? $02e68f8ca5696f61$var$addClass(elm, attrs) : $02e68f8ca5696f61$var$setAttribute(elm, attrs);
    parent && $02e68f8ca5696f61$var$append(parent, elm);
    return elm;
}
function $02e68f8ca5696f61$var$style(elm, prop, value) {
    if ($02e68f8ca5696f61$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$02e68f8ca5696f61$var$isNull(value)) elm.style[prop] = "" + value;
}
function $02e68f8ca5696f61$var$display(elm, display2) {
    $02e68f8ca5696f61$var$style(elm, "display", display2);
}
function $02e68f8ca5696f61$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $02e68f8ca5696f61$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $02e68f8ca5696f61$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $02e68f8ca5696f61$var$rect(target) {
    return target.getBoundingClientRect();
}
function $02e68f8ca5696f61$var$remove(nodes) {
    $02e68f8ca5696f61$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $02e68f8ca5696f61$var$parseHtml(html) {
    return $02e68f8ca5696f61$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $02e68f8ca5696f61$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $02e68f8ca5696f61$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $02e68f8ca5696f61$var$queryAll(parent, selector) {
    return selector ? $02e68f8ca5696f61$var$slice(parent.querySelectorAll(selector)) : [];
}
function $02e68f8ca5696f61$var$removeClass(elm, classes) {
    $02e68f8ca5696f61$var$toggleClass(elm, classes, false);
}
function $02e68f8ca5696f61$var$timeOf(e) {
    return e.timeStamp;
}
function $02e68f8ca5696f61$var$unit(value) {
    return $02e68f8ca5696f61$var$isString(value) ? value : value ? value + "px" : "";
}
var $02e68f8ca5696f61$var$PROJECT_CODE = "splide";
var $02e68f8ca5696f61$var$DATA_ATTRIBUTE = "data-" + $02e68f8ca5696f61$var$PROJECT_CODE;
function $02e68f8ca5696f61$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $02e68f8ca5696f61$var$PROJECT_CODE + "] " + (message || ""));
}
var $02e68f8ca5696f61$var$min = Math.min, $02e68f8ca5696f61$var$max = Math.max, $02e68f8ca5696f61$var$floor = Math.floor, $02e68f8ca5696f61$var$ceil = Math.ceil, $02e68f8ca5696f61$var$abs = Math.abs;
function $02e68f8ca5696f61$var$approximatelyEqual(x, y, epsilon) {
    return $02e68f8ca5696f61$var$abs(x - y) < epsilon;
}
function $02e68f8ca5696f61$var$between(number, x, y, exclusive) {
    var minimum = $02e68f8ca5696f61$var$min(x, y);
    var maximum = $02e68f8ca5696f61$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $02e68f8ca5696f61$var$clamp(number, x, y) {
    var minimum = $02e68f8ca5696f61$var$min(x, y);
    var maximum = $02e68f8ca5696f61$var$max(x, y);
    return $02e68f8ca5696f61$var$min($02e68f8ca5696f61$var$max(minimum, number), maximum);
}
function $02e68f8ca5696f61$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $02e68f8ca5696f61$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $02e68f8ca5696f61$var$format(string, replacements) {
    $02e68f8ca5696f61$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $02e68f8ca5696f61$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $02e68f8ca5696f61$var$ids = {};
function $02e68f8ca5696f61$var$uniqueId(prefix) {
    return "" + prefix + $02e68f8ca5696f61$var$pad($02e68f8ca5696f61$var$ids[prefix] = ($02e68f8ca5696f61$var$ids[prefix] || 0) + 1);
}
function $02e68f8ca5696f61$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $02e68f8ca5696f61$var$forEach(targets, function(target) {
            target && $02e68f8ca5696f61$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $02e68f8ca5696f61$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $02e68f8ca5696f61$export$d300dc1a2634364b = "mounted";
var $02e68f8ca5696f61$export$d8dac49b4532735a = "ready";
var $02e68f8ca5696f61$export$2aa493d7c3275167 = "move";
var $02e68f8ca5696f61$export$fe5802204b967f0d = "moved";
var $02e68f8ca5696f61$export$5adb665701eda1ce = "click";
var $02e68f8ca5696f61$export$92e3eae133acac4c = "active";
var $02e68f8ca5696f61$export$6bcbb81035c12cea = "inactive";
var $02e68f8ca5696f61$export$6a5b3445e4066a53 = "visible";
var $02e68f8ca5696f61$export$8c5c7a21d54563e9 = "hidden";
var $02e68f8ca5696f61$export$7f4701ac5e05e39f = "refresh";
var $02e68f8ca5696f61$export$db40ab7c0855fa5c = "updated";
var $02e68f8ca5696f61$export$7e019dae5103a285 = "resize";
var $02e68f8ca5696f61$export$d637eba1e9e28482 = "resized";
var $02e68f8ca5696f61$export$e84bf5065c9087ac = "drag";
var $02e68f8ca5696f61$export$8e9f636d2c722196 = "dragging";
var $02e68f8ca5696f61$export$90ea576bd3fdeb60 = "dragged";
var $02e68f8ca5696f61$export$49801896908b5e33 = "scroll";
var $02e68f8ca5696f61$export$ff8164bff3202b9 = "scrolled";
var $02e68f8ca5696f61$export$6cbac5b662a31e1b = "overflow";
var $02e68f8ca5696f61$export$88c4cf7419e470cd = "destroy";
var $02e68f8ca5696f61$export$8647f6b043e04e9d = "arrows:mounted";
var $02e68f8ca5696f61$export$d467f9343b961f75 = "arrows:updated";
var $02e68f8ca5696f61$export$bf89a4e4349c9778 = "pagination:mounted";
var $02e68f8ca5696f61$export$eb2019082ed6de0b = "pagination:updated";
var $02e68f8ca5696f61$export$84015c33508f94ec = "navigation:mounted";
var $02e68f8ca5696f61$export$23663268a31b79e2 = "autoplay:play";
var $02e68f8ca5696f61$export$185723258309b608 = "autoplay:playing";
var $02e68f8ca5696f61$export$16a1e4f3d0368265 = "autoplay:pause";
var $02e68f8ca5696f61$export$9f64346e17f0ec8e = "lazyload:loaded";
var $02e68f8ca5696f61$export$6d5af59619d10e6a = "sk";
var $02e68f8ca5696f61$export$f0af896383d5adff = "sh";
var $02e68f8ca5696f61$export$28dea85f216954dc = "ei";
function $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $02e68f8ca5696f61$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $02e68f8ca5696f61$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $02e68f8ca5696f61$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $02e68f8ca5696f61$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($02e68f8ca5696f61$export$88c4cf7419e470cd, binder.destroy);
    return $02e68f8ca5696f61$var$assign(binder, {
        bus: bus,
        on: on,
        off: $02e68f8ca5696f61$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $02e68f8ca5696f61$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $02e68f8ca5696f61$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $02e68f8ca5696f61$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $02e68f8ca5696f61$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $02e68f8ca5696f61$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $02e68f8ca5696f61$var$includes($02e68f8ca5696f61$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $02e68f8ca5696f61$export$efff0f5979573c99(func, duration) {
    var interval = $02e68f8ca5696f61$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $02e68f8ca5696f61$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $02e68f8ca5696f61$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $02e68f8ca5696f61$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $02e68f8ca5696f61$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($02e68f8ca5696f61$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $02e68f8ca5696f61$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $02e68f8ca5696f61$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($02e68f8ca5696f61$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $02e68f8ca5696f61$var$merge(options, reducedMotion) : $02e68f8ca5696f61$var$omit(options, $02e68f8ca5696f61$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $02e68f8ca5696f61$var$merge(options, opts);
        base && $02e68f8ca5696f61$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($02e68f8ca5696f61$var$CREATED)) Splide2.emit($02e68f8ca5696f61$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $02e68f8ca5696f61$var$ARROW = "Arrow";
var $02e68f8ca5696f61$var$ARROW_LEFT = $02e68f8ca5696f61$var$ARROW + "Left";
var $02e68f8ca5696f61$var$ARROW_RIGHT = $02e68f8ca5696f61$var$ARROW + "Right";
var $02e68f8ca5696f61$var$ARROW_UP = $02e68f8ca5696f61$var$ARROW + "Up";
var $02e68f8ca5696f61$var$ARROW_DOWN = $02e68f8ca5696f61$var$ARROW + "Down";
var $02e68f8ca5696f61$export$373e92e0788ff06e = "ltr";
var $02e68f8ca5696f61$export$850f7749a2909601 = "rtl";
var $02e68f8ca5696f61$export$97170d9824b89709 = "ttb";
var $02e68f8ca5696f61$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $02e68f8ca5696f61$var$ARROW_UP,
        $02e68f8ca5696f61$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $02e68f8ca5696f61$var$ARROW_DOWN,
        $02e68f8ca5696f61$var$ARROW_LEFT
    ]
};
function $02e68f8ca5696f61$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $02e68f8ca5696f61$export$850f7749a2909601 && !axisOnly ? 1 : direction === $02e68f8ca5696f61$export$97170d9824b89709 ? 0 : -1;
        return $02e68f8ca5696f61$var$ORIENTATION_MAP[prop] && $02e68f8ca5696f61$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $02e68f8ca5696f61$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $02e68f8ca5696f61$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $02e68f8ca5696f61$var$ROLE = "role";
var $02e68f8ca5696f61$var$TAB_INDEX = "tabindex";
var $02e68f8ca5696f61$var$DISABLED = "disabled";
var $02e68f8ca5696f61$var$ARIA_PREFIX = "aria-";
var $02e68f8ca5696f61$var$ARIA_CONTROLS = $02e68f8ca5696f61$var$ARIA_PREFIX + "controls";
var $02e68f8ca5696f61$var$ARIA_CURRENT = $02e68f8ca5696f61$var$ARIA_PREFIX + "current";
var $02e68f8ca5696f61$var$ARIA_SELECTED = $02e68f8ca5696f61$var$ARIA_PREFIX + "selected";
var $02e68f8ca5696f61$var$ARIA_LABEL = $02e68f8ca5696f61$var$ARIA_PREFIX + "label";
var $02e68f8ca5696f61$var$ARIA_LABELLEDBY = $02e68f8ca5696f61$var$ARIA_PREFIX + "labelledby";
var $02e68f8ca5696f61$var$ARIA_HIDDEN = $02e68f8ca5696f61$var$ARIA_PREFIX + "hidden";
var $02e68f8ca5696f61$var$ARIA_ORIENTATION = $02e68f8ca5696f61$var$ARIA_PREFIX + "orientation";
var $02e68f8ca5696f61$var$ARIA_ROLEDESCRIPTION = $02e68f8ca5696f61$var$ARIA_PREFIX + "roledescription";
var $02e68f8ca5696f61$var$ARIA_LIVE = $02e68f8ca5696f61$var$ARIA_PREFIX + "live";
var $02e68f8ca5696f61$var$ARIA_BUSY = $02e68f8ca5696f61$var$ARIA_PREFIX + "busy";
var $02e68f8ca5696f61$var$ARIA_ATOMIC = $02e68f8ca5696f61$var$ARIA_PREFIX + "atomic";
var $02e68f8ca5696f61$var$ALL_ATTRIBUTES = [
    $02e68f8ca5696f61$var$ROLE,
    $02e68f8ca5696f61$var$TAB_INDEX,
    $02e68f8ca5696f61$var$DISABLED,
    $02e68f8ca5696f61$var$ARIA_CONTROLS,
    $02e68f8ca5696f61$var$ARIA_CURRENT,
    $02e68f8ca5696f61$var$ARIA_LABEL,
    $02e68f8ca5696f61$var$ARIA_LABELLEDBY,
    $02e68f8ca5696f61$var$ARIA_HIDDEN,
    $02e68f8ca5696f61$var$ARIA_ORIENTATION,
    $02e68f8ca5696f61$var$ARIA_ROLEDESCRIPTION
];
var $02e68f8ca5696f61$var$CLASS_PREFIX = $02e68f8ca5696f61$var$PROJECT_CODE + "__";
var $02e68f8ca5696f61$var$STATUS_CLASS_PREFIX = "is-";
var $02e68f8ca5696f61$export$93b21159ad85c843 = $02e68f8ca5696f61$var$PROJECT_CODE;
var $02e68f8ca5696f61$export$7738b09ac0a98952 = $02e68f8ca5696f61$var$CLASS_PREFIX + "track";
var $02e68f8ca5696f61$export$19cc2a5451235cae = $02e68f8ca5696f61$var$CLASS_PREFIX + "list";
var $02e68f8ca5696f61$export$8d922915837a38d3 = $02e68f8ca5696f61$var$CLASS_PREFIX + "slide";
var $02e68f8ca5696f61$export$2c1ba4a4f1aa4947 = $02e68f8ca5696f61$export$8d922915837a38d3 + "--clone";
var $02e68f8ca5696f61$export$e9ba7e444ba60a12 = $02e68f8ca5696f61$export$8d922915837a38d3 + "__container";
var $02e68f8ca5696f61$export$a26cbd955fecf11e = $02e68f8ca5696f61$var$CLASS_PREFIX + "arrows";
var $02e68f8ca5696f61$export$516e7d18e13a2dca = $02e68f8ca5696f61$var$CLASS_PREFIX + "arrow";
var $02e68f8ca5696f61$export$58ea3db24c33b76 = $02e68f8ca5696f61$export$516e7d18e13a2dca + "--prev";
var $02e68f8ca5696f61$export$4885afd7098a65c2 = $02e68f8ca5696f61$export$516e7d18e13a2dca + "--next";
var $02e68f8ca5696f61$export$cbf8e5a0ab95eda3 = $02e68f8ca5696f61$var$CLASS_PREFIX + "pagination";
var $02e68f8ca5696f61$export$52f2cca6a5eee805 = $02e68f8ca5696f61$export$cbf8e5a0ab95eda3 + "__page";
var $02e68f8ca5696f61$export$4c82dc32b1c4ace5 = $02e68f8ca5696f61$var$CLASS_PREFIX + "progress";
var $02e68f8ca5696f61$export$2c9b091c749f4409 = $02e68f8ca5696f61$export$4c82dc32b1c4ace5 + "__bar";
var $02e68f8ca5696f61$export$a29701deef84b825 = $02e68f8ca5696f61$var$CLASS_PREFIX + "toggle";
var $02e68f8ca5696f61$export$d9d247d51b430dbb = $02e68f8ca5696f61$export$a29701deef84b825 + "__play";
var $02e68f8ca5696f61$export$3529f201a419925b = $02e68f8ca5696f61$export$a29701deef84b825 + "__pause";
var $02e68f8ca5696f61$export$3e5381ee3fab8374 = $02e68f8ca5696f61$var$CLASS_PREFIX + "spinner";
var $02e68f8ca5696f61$export$bb78d7c200da8960 = $02e68f8ca5696f61$var$CLASS_PREFIX + "sr";
var $02e68f8ca5696f61$export$7761661e2d5b9388 = $02e68f8ca5696f61$var$STATUS_CLASS_PREFIX + "initialized";
var $02e68f8ca5696f61$export$72d36ecf3758cb4b = $02e68f8ca5696f61$var$STATUS_CLASS_PREFIX + "active";
var $02e68f8ca5696f61$export$e423ac4972f5e196 = $02e68f8ca5696f61$var$STATUS_CLASS_PREFIX + "prev";
var $02e68f8ca5696f61$export$457a2d20827a2779 = $02e68f8ca5696f61$var$STATUS_CLASS_PREFIX + "next";
var $02e68f8ca5696f61$export$53ca4621bbab9a = $02e68f8ca5696f61$var$STATUS_CLASS_PREFIX + "visible";
var $02e68f8ca5696f61$export$d22ec4ccb7996ba2 = $02e68f8ca5696f61$var$STATUS_CLASS_PREFIX + "loading";
var $02e68f8ca5696f61$export$b6f202a162a09100 = $02e68f8ca5696f61$var$STATUS_CLASS_PREFIX + "focus-in";
var $02e68f8ca5696f61$export$cd908cd1dd625e29 = $02e68f8ca5696f61$var$STATUS_CLASS_PREFIX + "overflow";
var $02e68f8ca5696f61$export$49f9eaea10ebf193 = [
    $02e68f8ca5696f61$export$72d36ecf3758cb4b,
    $02e68f8ca5696f61$export$53ca4621bbab9a,
    $02e68f8ca5696f61$export$e423ac4972f5e196,
    $02e68f8ca5696f61$export$457a2d20827a2779,
    $02e68f8ca5696f61$export$d22ec4ccb7996ba2,
    $02e68f8ca5696f61$export$b6f202a162a09100,
    $02e68f8ca5696f61$export$cd908cd1dd625e29
];
var $02e68f8ca5696f61$export$ba41d43e4a419565 = {
    slide: $02e68f8ca5696f61$export$8d922915837a38d3,
    clone: $02e68f8ca5696f61$export$2c1ba4a4f1aa4947,
    arrows: $02e68f8ca5696f61$export$a26cbd955fecf11e,
    arrow: $02e68f8ca5696f61$export$516e7d18e13a2dca,
    prev: $02e68f8ca5696f61$export$58ea3db24c33b76,
    next: $02e68f8ca5696f61$export$4885afd7098a65c2,
    pagination: $02e68f8ca5696f61$export$cbf8e5a0ab95eda3,
    page: $02e68f8ca5696f61$export$52f2cca6a5eee805,
    spinner: $02e68f8ca5696f61$export$3e5381ee3fab8374
};
function $02e68f8ca5696f61$var$closest(from, selector) {
    if ($02e68f8ca5696f61$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($02e68f8ca5696f61$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $02e68f8ca5696f61$var$FRICTION = 5;
var $02e68f8ca5696f61$var$LOG_INTERVAL = 200;
var $02e68f8ca5696f61$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $02e68f8ca5696f61$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $02e68f8ca5696f61$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $02e68f8ca5696f61$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($02e68f8ca5696f61$export$7f4701ac5e05e39f, destroy);
        on($02e68f8ca5696f61$export$7f4701ac5e05e39f, setup);
        on($02e68f8ca5696f61$export$db40ab7c0855fa5c, update);
        bind(document, $02e68f8ca5696f61$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $02e68f8ca5696f61$var$toggleClass(root, $02e68f8ca5696f61$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $02e68f8ca5696f61$var$ALL_ATTRIBUTES.concat("style");
        $02e68f8ca5696f61$var$empty(slides);
        $02e68f8ca5696f61$var$removeClass(root, rootClasses);
        $02e68f8ca5696f61$var$removeClass(track, trackClasses);
        $02e68f8ca5696f61$var$removeAttribute([
            track,
            list
        ], attrs);
        $02e68f8ca5696f61$var$removeAttribute(root, completely ? attrs : [
            "style",
            $02e68f8ca5696f61$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $02e68f8ca5696f61$var$removeClass(root, rootClasses);
        $02e68f8ca5696f61$var$removeClass(track, trackClasses);
        rootClasses = getClasses($02e68f8ca5696f61$export$93b21159ad85c843);
        trackClasses = getClasses($02e68f8ca5696f61$export$7738b09ac0a98952);
        $02e68f8ca5696f61$var$addClass(root, rootClasses);
        $02e68f8ca5696f61$var$addClass(track, trackClasses);
        $02e68f8ca5696f61$var$setAttribute(root, $02e68f8ca5696f61$var$ARIA_LABEL, options.label);
        $02e68f8ca5696f61$var$setAttribute(root, $02e68f8ca5696f61$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $02e68f8ca5696f61$export$7738b09ac0a98952);
        list = $02e68f8ca5696f61$var$child(track, "." + $02e68f8ca5696f61$export$19cc2a5451235cae);
        $02e68f8ca5696f61$var$assert(track && list, "A track/list element is missing.");
        $02e68f8ca5696f61$var$push(slides, $02e68f8ca5696f61$var$children(list, "." + $02e68f8ca5696f61$export$8d922915837a38d3 + ":not(." + $02e68f8ca5696f61$export$2c1ba4a4f1aa4947 + ")"));
        $02e68f8ca5696f61$var$forOwn({
            arrows: $02e68f8ca5696f61$export$a26cbd955fecf11e,
            pagination: $02e68f8ca5696f61$export$cbf8e5a0ab95eda3,
            prev: $02e68f8ca5696f61$export$58ea3db24c33b76,
            next: $02e68f8ca5696f61$export$4885afd7098a65c2,
            bar: $02e68f8ca5696f61$export$2c9b091c749f4409,
            toggle: $02e68f8ca5696f61$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $02e68f8ca5696f61$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $02e68f8ca5696f61$var$uniqueId($02e68f8ca5696f61$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$02e68f8ca5696f61$var$getAttribute(root, $02e68f8ca5696f61$var$ROLE) && root.tagName !== "SECTION" && role) $02e68f8ca5696f61$var$setAttribute(root, $02e68f8ca5696f61$var$ROLE, role);
        $02e68f8ca5696f61$var$setAttribute(root, $02e68f8ca5696f61$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $02e68f8ca5696f61$var$setAttribute(list, $02e68f8ca5696f61$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $02e68f8ca5696f61$var$query(root, selector);
        return elm && $02e68f8ca5696f61$var$closest(elm, "." + $02e68f8ca5696f61$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $02e68f8ca5696f61$export$93b21159ad85c843 && $02e68f8ca5696f61$export$72d36ecf3758cb4b
        ];
    }
    return $02e68f8ca5696f61$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $02e68f8ca5696f61$export$e5a58a5ee5b54c22 = "slide";
var $02e68f8ca5696f61$export$f42383286ed1223d = "loop";
var $02e68f8ca5696f61$export$742b62a5690c060 = "fade";
function $02e68f8ca5696f61$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $02e68f8ca5696f61$var$getAttribute(slide, "style");
    var label = $02e68f8ca5696f61$var$getAttribute(slide, $02e68f8ca5696f61$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $02e68f8ca5696f61$var$child(slide, "." + $02e68f8ca5696f61$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $02e68f8ca5696f61$var$pad(index + 1);
            $02e68f8ca5696f61$var$setAttribute(slide, $02e68f8ca5696f61$var$ROLE, pagination ? "tabpanel" : "group");
            $02e68f8ca5696f61$var$setAttribute(slide, $02e68f8ca5696f61$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $02e68f8ca5696f61$var$setAttribute(slide, $02e68f8ca5696f61$var$ARIA_LABEL, label || $02e68f8ca5696f61$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $02e68f8ca5696f61$var$apply(emit, $02e68f8ca5696f61$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $02e68f8ca5696f61$var$apply(emit, $02e68f8ca5696f61$export$6d5af59619d10e6a, self));
        on([
            $02e68f8ca5696f61$export$fe5802204b967f0d,
            $02e68f8ca5696f61$export$f0af896383d5adff,
            $02e68f8ca5696f61$export$ff8164bff3202b9
        ], update);
        on($02e68f8ca5696f61$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($02e68f8ca5696f61$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $02e68f8ca5696f61$var$removeClass(slide, $02e68f8ca5696f61$export$49f9eaea10ebf193);
        $02e68f8ca5696f61$var$removeAttribute(slide, $02e68f8ca5696f61$var$ALL_ATTRIBUTES);
        $02e68f8ca5696f61$var$setAttribute(slide, "style", styles);
        $02e68f8ca5696f61$var$setAttribute(slide, $02e68f8ca5696f61$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $02e68f8ca5696f61$var$setAttribute(slide, $02e68f8ca5696f61$var$ARIA_LABEL, $02e68f8ca5696f61$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $02e68f8ca5696f61$var$setAttribute(slide, $02e68f8ca5696f61$var$ARIA_CONTROLS, controls);
        $02e68f8ca5696f61$var$setAttribute(slide, $02e68f8ca5696f61$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $02e68f8ca5696f61$var$removeAttribute(slide, $02e68f8ca5696f61$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $02e68f8ca5696f61$var$toggleClass(slide, $02e68f8ca5696f61$export$e423ac4972f5e196, index === curr - 1);
            $02e68f8ca5696f61$var$toggleClass(slide, $02e68f8ca5696f61$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $02e68f8ca5696f61$var$hasClass(slide, $02e68f8ca5696f61$export$72d36ecf3758cb4b)) {
            $02e68f8ca5696f61$var$toggleClass(slide, $02e68f8ca5696f61$export$72d36ecf3758cb4b, active);
            $02e68f8ca5696f61$var$setAttribute(slide, $02e68f8ca5696f61$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $02e68f8ca5696f61$export$92e3eae133acac4c : $02e68f8ca5696f61$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $02e68f8ca5696f61$var$MOVING,
            $02e68f8ca5696f61$var$SCROLLING
        ])) $02e68f8ca5696f61$var$setAttribute(slide, $02e68f8ca5696f61$var$ARIA_HIDDEN, hidden || "");
        $02e68f8ca5696f61$var$setAttribute($02e68f8ca5696f61$var$queryAll(slide, options.focusableNodes || ""), $02e68f8ca5696f61$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $02e68f8ca5696f61$var$setAttribute(slide, $02e68f8ca5696f61$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $02e68f8ca5696f61$var$hasClass(slide, $02e68f8ca5696f61$export$53ca4621bbab9a)) {
            $02e68f8ca5696f61$var$toggleClass(slide, $02e68f8ca5696f61$export$53ca4621bbab9a, visible);
            emit(visible ? $02e68f8ca5696f61$export$6a5b3445e4066a53 : $02e68f8ca5696f61$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $02e68f8ca5696f61$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $02e68f8ca5696f61$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($02e68f8ca5696f61$export$742b62a5690c060)) return isActive();
        var trackRect = $02e68f8ca5696f61$var$rect(Components.Elements.track);
        var slideRect = $02e68f8ca5696f61$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $02e68f8ca5696f61$var$floor(trackRect[left]) <= $02e68f8ca5696f61$var$ceil(slideRect[left]) && $02e68f8ca5696f61$var$floor(slideRect[right]) <= $02e68f8ca5696f61$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $02e68f8ca5696f61$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($02e68f8ca5696f61$export$f42383286ed1223d))) diff = $02e68f8ca5696f61$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $02e68f8ca5696f61$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($02e68f8ca5696f61$export$7f4701ac5e05e39f, destroy);
        on($02e68f8ca5696f61$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $02e68f8ca5696f61$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $02e68f8ca5696f61$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $02e68f8ca5696f61$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $02e68f8ca5696f61$var$forEach(items, function(slide) {
            if ($02e68f8ca5696f61$var$isString(slide)) slide = $02e68f8ca5696f61$var$parseHtml(slide);
            if ($02e68f8ca5696f61$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $02e68f8ca5696f61$var$before(slide, ref) : $02e68f8ca5696f61$var$append(list, slide);
                $02e68f8ca5696f61$var$addClass(slide, options.classes.slide);
                observeImages(slide, $02e68f8ca5696f61$var$apply(emit, $02e68f8ca5696f61$export$7e019dae5103a285));
            }
        });
        emit($02e68f8ca5696f61$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $02e68f8ca5696f61$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($02e68f8ca5696f61$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($02e68f8ca5696f61$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $02e68f8ca5696f61$var$isString(matcher) ? $02e68f8ca5696f61$var$matches(Slide2.slide, matcher) : $02e68f8ca5696f61$var$includes($02e68f8ca5696f61$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $02e68f8ca5696f61$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $02e68f8ca5696f61$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $02e68f8ca5696f61$export$efff0f5979573c99($02e68f8ca5696f61$var$apply(emit, $02e68f8ca5696f61$export$7e019dae5103a285)));
        on([
            $02e68f8ca5696f61$export$db40ab7c0855fa5c,
            $02e68f8ca5696f61$export$7f4701ac5e05e39f
        ], init);
        on($02e68f8ca5696f61$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $02e68f8ca5696f61$export$97170d9824b89709;
        $02e68f8ca5696f61$var$style(root, "maxWidth", $02e68f8ca5696f61$var$unit(options.width));
        $02e68f8ca5696f61$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $02e68f8ca5696f61$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $02e68f8ca5696f61$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $02e68f8ca5696f61$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $02e68f8ca5696f61$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($02e68f8ca5696f61$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $02e68f8ca5696f61$var$toggleClass(root, $02e68f8ca5696f61$export$cd908cd1dd625e29, overflow);
                emit($02e68f8ca5696f61$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $02e68f8ca5696f61$var$unit(padding[prop] || ($02e68f8ca5696f61$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $02e68f8ca5696f61$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $02e68f8ca5696f61$var$unit(options.height || $02e68f8ca5696f61$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $02e68f8ca5696f61$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $02e68f8ca5696f61$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $02e68f8ca5696f61$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $02e68f8ca5696f61$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $02e68f8ca5696f61$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $02e68f8ca5696f61$var$rect(Slide.slide)[resolve("right")];
            var left = $02e68f8ca5696f61$var$rect(list)[resolve("left")];
            return $02e68f8ca5696f61$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($02e68f8ca5696f61$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($02e68f8ca5696f61$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($02e68f8ca5696f61$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $02e68f8ca5696f61$var$MULTIPLIER = 2;
function $02e68f8ca5696f61$var$Clones(Splide2, Components2, options) {
    var event = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($02e68f8ca5696f61$export$7f4701ac5e05e39f, remount);
        on([
            $02e68f8ca5696f61$export$db40ab7c0855fa5c,
            $02e68f8ca5696f61$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $02e68f8ca5696f61$var$remove(clones);
        $02e68f8ca5696f61$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($02e68f8ca5696f61$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$02e68f8ca5696f61$var$push(slides, slides);
            $02e68f8ca5696f61$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $02e68f8ca5696f61$var$before(clone, slides[0].slide) : $02e68f8ca5696f61$var$append(Elements.list, clone);
                $02e68f8ca5696f61$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $02e68f8ca5696f61$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $02e68f8ca5696f61$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($02e68f8ca5696f61$export$f42383286ed1223d)) clones2 = 0;
        else if ($02e68f8ca5696f61$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $02e68f8ca5696f61$var$ceil($02e68f8ca5696f61$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $02e68f8ca5696f61$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $02e68f8ca5696f61$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $02e68f8ca5696f61$export$d300dc1a2634364b,
            $02e68f8ca5696f61$export$d637eba1e9e28482,
            $02e68f8ca5696f61$export$db40ab7c0855fa5c,
            $02e68f8ca5696f61$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($02e68f8ca5696f61$var$MOVING);
        emit($02e68f8ca5696f61$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($02e68f8ca5696f61$var$IDLE);
            emit($02e68f8ca5696f61$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($02e68f8ca5696f61$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $02e68f8ca5696f61$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($02e68f8ca5696f61$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($02e68f8ca5696f61$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($02e68f8ca5696f61$var$ceil($02e68f8ca5696f61$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $02e68f8ca5696f61$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $02e68f8ca5696f61$var$rect(list)[left] - $02e68f8ca5696f61$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($02e68f8ca5696f61$export$e5a58a5ee5b54c22)) position = $02e68f8ca5696f61$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $02e68f8ca5696f61$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $02e68f8ca5696f61$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $02e68f8ca5696f61$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($02e68f8ca5696f61$export$f42383286ed1223d);
    var isSlide = Splide2.is($02e68f8ca5696f61$export$e5a58a5ee5b54c22);
    var getNext = $02e68f8ca5696f61$var$apply(getAdjacent, false);
    var getPrev = $02e68f8ca5696f61$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $02e68f8ca5696f61$export$db40ab7c0855fa5c,
            $02e68f8ca5696f61$export$7f4701ac5e05e39f,
            $02e68f8ca5696f61$export$28dea85f216954dc
        ], init);
        on($02e68f8ca5696f61$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $02e68f8ca5696f61$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($02e68f8ca5696f61$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $02e68f8ca5696f61$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($02e68f8ca5696f61$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $02e68f8ca5696f61$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$02e68f8ca5696f61$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($02e68f8ca5696f61$var$between(0, dest, from, true) || $02e68f8ca5696f61$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $02e68f8ca5696f61$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $02e68f8ca5696f61$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $02e68f8ca5696f61$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $02e68f8ca5696f61$var$min(index, endIndex) : $02e68f8ca5696f61$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $02e68f8ca5696f61$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$02e68f8ca5696f61$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $02e68f8ca5696f61$var$MOVING,
            $02e68f8ca5696f61$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $02e68f8ca5696f61$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $02e68f8ca5696f61$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $02e68f8ca5696f61$var$SIZE = 40;
function $02e68f8ca5696f61$var$Arrows(Splide2, Components2, options) {
    var event = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($02e68f8ca5696f61$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $02e68f8ca5696f61$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $02e68f8ca5696f61$var$display(wrapper, enabled ? "" : "none");
            $02e68f8ca5696f61$var$addClass(wrapper, wrapperClasses = $02e68f8ca5696f61$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $02e68f8ca5696f61$var$setAttribute([
                    prev,
                    next
                ], $02e68f8ca5696f61$var$ARIA_CONTROLS, track.id);
                emit($02e68f8ca5696f61$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $02e68f8ca5696f61$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $02e68f8ca5696f61$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $02e68f8ca5696f61$var$removeAttribute([
            prev,
            next
        ], $02e68f8ca5696f61$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $02e68f8ca5696f61$export$d300dc1a2634364b,
            $02e68f8ca5696f61$export$fe5802204b967f0d,
            $02e68f8ca5696f61$export$7f4701ac5e05e39f,
            $02e68f8ca5696f61$export$ff8164bff3202b9,
            $02e68f8ca5696f61$export$28dea85f216954dc
        ], update);
        bind(next, "click", $02e68f8ca5696f61$var$apply(go, ">"));
        bind(prev, "click", $02e68f8ca5696f61$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $02e68f8ca5696f61$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $02e68f8ca5696f61$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $02e68f8ca5696f61$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + $02e68f8ca5696f61$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $02e68f8ca5696f61$var$SIZE + " " + $02e68f8ca5696f61$var$SIZE + '" width="' + $02e68f8ca5696f61$var$SIZE + '" height="' + $02e68f8ca5696f61$var$SIZE + '" focusable="false"><path d="' + (options.arrowPath || $02e68f8ca5696f61$var$PATH) + '" />';
        return $02e68f8ca5696f61$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $02e68f8ca5696f61$var$setAttribute(prev, $02e68f8ca5696f61$var$ARIA_LABEL, prevLabel);
            $02e68f8ca5696f61$var$setAttribute(next, $02e68f8ca5696f61$var$ARIA_LABEL, nextLabel);
            emit($02e68f8ca5696f61$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $02e68f8ca5696f61$var$INTERVAL_DATA_ATTRIBUTE = $02e68f8ca5696f61$var$DATA_ATTRIBUTE + "-interval";
function $02e68f8ca5696f61$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $02e68f8ca5696f61$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $02e68f8ca5696f61$var$setAttribute(toggle, $02e68f8ca5696f61$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $02e68f8ca5696f61$export$2aa493d7c3275167,
            $02e68f8ca5696f61$export$49801896908b5e33,
            $02e68f8ca5696f61$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($02e68f8ca5696f61$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($02e68f8ca5696f61$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($02e68f8ca5696f61$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $02e68f8ca5696f61$var$toggleClass(toggle, $02e68f8ca5696f61$export$72d36ecf3758cb4b, !stopped);
            $02e68f8ca5696f61$var$setAttribute(toggle, $02e68f8ca5696f61$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $02e68f8ca5696f61$var$style(bar, "width", rate * 100 + "%");
        emit($02e68f8ca5696f61$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$02e68f8ca5696f61$var$getAttribute(Slide.slide, $02e68f8ca5696f61$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $02e68f8ca5696f61$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($02e68f8ca5696f61$export$9f64346e17f0ec8e, $02e68f8ca5696f61$var$apply(toggle, true));
            on([
                $02e68f8ca5696f61$export$d300dc1a2634364b,
                $02e68f8ca5696f61$export$db40ab7c0855fa5c,
                $02e68f8ca5696f61$export$7f4701ac5e05e39f
            ], $02e68f8ca5696f61$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $02e68f8ca5696f61$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
        $02e68f8ca5696f61$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $02e68f8ca5696f61$var$apply(cover, false)
    };
}
var $02e68f8ca5696f61$var$BOUNCE_DIFF_THRESHOLD = 10;
var $02e68f8ca5696f61$var$BOUNCE_DURATION = 600;
var $02e68f8ca5696f61$var$FRICTION_FACTOR = 0.6;
var $02e68f8ca5696f61$var$BASE_VELOCITY = 1.5;
var $02e68f8ca5696f61$var$MIN_DURATION = 800;
function $02e68f8ca5696f61$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($02e68f8ca5696f61$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($02e68f8ca5696f61$export$2aa493d7c3275167, clear);
        on([
            $02e68f8ca5696f61$export$db40ab7c0855fa5c,
            $02e68f8ca5696f61$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $02e68f8ca5696f61$var$sign(destination) * size * $02e68f8ca5696f61$var$floor($02e68f8ca5696f61$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $02e68f8ca5696f61$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $02e68f8ca5696f61$var$max($02e68f8ca5696f61$var$abs(destination - from) / $02e68f8ca5696f61$var$BASE_VELOCITY, $02e68f8ca5696f61$var$MIN_DURATION);
        callback = onScrolled;
        interval = $02e68f8ca5696f61$export$46ad21b25b6dccf0(duration, onEnd, $02e68f8ca5696f61$var$apply(update, from, destination, noConstrain), 1);
        set($02e68f8ca5696f61$var$SCROLLING);
        emit($02e68f8ca5696f61$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($02e68f8ca5696f61$var$IDLE);
        callback && callback();
        emit($02e68f8ca5696f61$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $02e68f8ca5696f61$var$FRICTION_FACTOR;
            if ($02e68f8ca5696f61$var$abs(diff) < $02e68f8ca5696f61$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $02e68f8ca5696f61$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $02e68f8ca5696f61$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $02e68f8ca5696f61$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $02e68f8ca5696f61$var$POINTER_MOVE_EVENTS, $02e68f8ca5696f61$var$noop, $02e68f8ca5696f61$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $02e68f8ca5696f61$var$POINTER_UP_EVENTS, $02e68f8ca5696f61$var$noop, $02e68f8ca5696f61$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $02e68f8ca5696f61$var$POINTER_DOWN_EVENTS, onPointerDown, $02e68f8ca5696f61$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $02e68f8ca5696f61$var$prevent);
        on([
            $02e68f8ca5696f61$export$d300dc1a2634364b,
            $02e68f8ca5696f61$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $02e68f8ca5696f61$var$MOVING,
                        $02e68f8ca5696f61$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $02e68f8ca5696f61$var$POINTER_MOVE_EVENTS, onPointerMove, $02e68f8ca5696f61$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $02e68f8ca5696f61$var$POINTER_UP_EVENTS, onPointerUp, $02e68f8ca5696f61$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $02e68f8ca5696f61$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($02e68f8ca5696f61$var$DRAGGING)) {
            state.set($02e68f8ca5696f61$var$DRAGGING);
            emit($02e68f8ca5696f61$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $02e68f8ca5696f61$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($02e68f8ca5696f61$export$8e9f636d2c722196);
                $02e68f8ca5696f61$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $02e68f8ca5696f61$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($02e68f8ca5696f61$var$DRAGGING)) {
            state.set($02e68f8ca5696f61$var$IDLE);
            emit($02e68f8ca5696f61$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $02e68f8ca5696f61$var$prevent(e);
        }
        unbind(target, $02e68f8ca5696f61$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $02e68f8ca5696f61$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $02e68f8ca5696f61$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($02e68f8ca5696f61$export$742b62a5690c060)) Controller.go(orient($02e68f8ca5696f61$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($02e68f8ca5696f61$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $02e68f8ca5696f61$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $02e68f8ca5696f61$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $02e68f8ca5696f61$var$abs(diffCoord(e)) > $02e68f8ca5696f61$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($02e68f8ca5696f61$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $02e68f8ca5696f61$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $02e68f8ca5696f61$var$sign(velocity) * $02e68f8ca5696f61$var$min($02e68f8ca5696f61$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $02e68f8ca5696f61$var$timeOf(e) - $02e68f8ca5696f61$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($02e68f8ca5696f61$export$e5a58a5ee5b54c22) ? $02e68f8ca5696f61$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$02e68f8ca5696f61$var$matches(target2, "." + $02e68f8ca5696f61$export$52f2cca6a5eee805 + ", ." + $02e68f8ca5696f61$export$516e7d18e13a2dca) && (!noDrag || !$02e68f8ca5696f61$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $02e68f8ca5696f61$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $02e68f8ca5696f61$var$ARROW_RIGHT,
    Left: $02e68f8ca5696f61$var$ARROW_LEFT,
    Up: $02e68f8ca5696f61$var$ARROW_UP,
    Down: $02e68f8ca5696f61$var$ARROW_DOWN
};
function $02e68f8ca5696f61$var$normalizeKey(key) {
    key = $02e68f8ca5696f61$var$isString(key) ? key : key.key;
    return $02e68f8ca5696f61$var$NORMALIZATION_MAP[key] || key;
}
var $02e68f8ca5696f61$var$KEYBOARD_EVENT = "keydown";
function $02e68f8ca5696f61$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($02e68f8ca5696f61$export$db40ab7c0855fa5c, destroy);
        on($02e68f8ca5696f61$export$db40ab7c0855fa5c, init);
        on($02e68f8ca5696f61$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $02e68f8ca5696f61$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $02e68f8ca5696f61$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $02e68f8ca5696f61$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $02e68f8ca5696f61$var$normalizeKey(e);
            if (key === resolve($02e68f8ca5696f61$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($02e68f8ca5696f61$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $02e68f8ca5696f61$var$SRC_DATA_ATTRIBUTE = $02e68f8ca5696f61$var$DATA_ATTRIBUTE + "-lazy";
var $02e68f8ca5696f61$var$SRCSET_DATA_ATTRIBUTE = $02e68f8ca5696f61$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $02e68f8ca5696f61$var$IMAGE_SELECTOR = "[" + $02e68f8ca5696f61$var$SRC_DATA_ATTRIBUTE + "], [" + $02e68f8ca5696f61$var$SRCSET_DATA_ATTRIBUTE + "]";
function $02e68f8ca5696f61$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $02e68f8ca5696f61$export$fe5802204b967f0d,
        $02e68f8ca5696f61$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($02e68f8ca5696f61$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $02e68f8ca5696f61$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $02e68f8ca5696f61$var$queryAll(Slide.slide, $02e68f8ca5696f61$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $02e68f8ca5696f61$var$getAttribute(img, $02e68f8ca5696f61$var$SRC_DATA_ATTRIBUTE);
                var srcset = $02e68f8ca5696f61$var$getAttribute(img, $02e68f8ca5696f61$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $02e68f8ca5696f61$var$child(parent, "." + className) || $02e68f8ca5696f61$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $02e68f8ca5696f61$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $02e68f8ca5696f61$var$addClass(data[1].slide, $02e68f8ca5696f61$export$d22ec4ccb7996ba2);
        bind(img, "load error", $02e68f8ca5696f61$var$apply(onLoad, data));
        $02e68f8ca5696f61$var$setAttribute(img, "src", $02e68f8ca5696f61$var$getAttribute(img, $02e68f8ca5696f61$var$SRC_DATA_ATTRIBUTE));
        $02e68f8ca5696f61$var$setAttribute(img, "srcset", $02e68f8ca5696f61$var$getAttribute(img, $02e68f8ca5696f61$var$SRCSET_DATA_ATTRIBUTE));
        $02e68f8ca5696f61$var$removeAttribute(img, $02e68f8ca5696f61$var$SRC_DATA_ATTRIBUTE);
        $02e68f8ca5696f61$var$removeAttribute(img, $02e68f8ca5696f61$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $02e68f8ca5696f61$var$removeClass(Slide.slide, $02e68f8ca5696f61$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $02e68f8ca5696f61$var$remove(data[2]);
            $02e68f8ca5696f61$var$display(img, "");
            emit($02e68f8ca5696f61$export$9f64346e17f0ec8e, img, Slide);
            emit($02e68f8ca5696f61$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $02e68f8ca5696f61$var$apply($02e68f8ca5696f61$var$empty, entries),
        check: check
    };
}
function $02e68f8ca5696f61$var$Pagination(Splide2, Components2, options) {
    var event = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $02e68f8ca5696f61$export$db40ab7c0855fa5c,
            $02e68f8ca5696f61$export$7f4701ac5e05e39f,
            $02e68f8ca5696f61$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $02e68f8ca5696f61$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $02e68f8ca5696f61$export$2aa493d7c3275167,
                $02e68f8ca5696f61$export$49801896908b5e33,
                $02e68f8ca5696f61$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($02e68f8ca5696f61$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $02e68f8ca5696f61$var$remove(placeholder ? $02e68f8ca5696f61$var$slice(list.children) : list);
            $02e68f8ca5696f61$var$removeClass(list, paginationClasses);
            $02e68f8ca5696f61$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $02e68f8ca5696f61$var$ceil(length / perPage);
        list = placeholder || $02e68f8ca5696f61$var$create("ul", classes.pagination, Elements.track.parentElement);
        $02e68f8ca5696f61$var$addClass(list, paginationClasses = $02e68f8ca5696f61$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $02e68f8ca5696f61$var$setAttribute(list, $02e68f8ca5696f61$var$ROLE, "tablist");
        $02e68f8ca5696f61$var$setAttribute(list, $02e68f8ca5696f61$var$ARIA_LABEL, i18n.select);
        $02e68f8ca5696f61$var$setAttribute(list, $02e68f8ca5696f61$var$ARIA_ORIENTATION, getDirection() === $02e68f8ca5696f61$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $02e68f8ca5696f61$var$create("li", null, list);
            var button = $02e68f8ca5696f61$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $02e68f8ca5696f61$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $02e68f8ca5696f61$var$apply(onKeydown, i));
            $02e68f8ca5696f61$var$setAttribute(li, $02e68f8ca5696f61$var$ROLE, "presentation");
            $02e68f8ca5696f61$var$setAttribute(button, $02e68f8ca5696f61$var$ROLE, "tab");
            $02e68f8ca5696f61$var$setAttribute(button, $02e68f8ca5696f61$var$ARIA_CONTROLS, controls.join(" "));
            $02e68f8ca5696f61$var$setAttribute(button, $02e68f8ca5696f61$var$ARIA_LABEL, $02e68f8ca5696f61$var$format(text, i + 1));
            $02e68f8ca5696f61$var$setAttribute(button, $02e68f8ca5696f61$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $02e68f8ca5696f61$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($02e68f8ca5696f61$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($02e68f8ca5696f61$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $02e68f8ca5696f61$var$focus(item.button);
            go(">" + nextPage);
            $02e68f8ca5696f61$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $02e68f8ca5696f61$var$removeClass(button, $02e68f8ca5696f61$export$72d36ecf3758cb4b);
            $02e68f8ca5696f61$var$removeAttribute(button, $02e68f8ca5696f61$var$ARIA_SELECTED);
            $02e68f8ca5696f61$var$setAttribute(button, $02e68f8ca5696f61$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $02e68f8ca5696f61$var$addClass(_button, $02e68f8ca5696f61$export$72d36ecf3758cb4b);
            $02e68f8ca5696f61$var$setAttribute(_button, $02e68f8ca5696f61$var$ARIA_SELECTED, true);
            $02e68f8ca5696f61$var$setAttribute(_button, $02e68f8ca5696f61$var$TAB_INDEX, "");
        }
        emit($02e68f8ca5696f61$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $02e68f8ca5696f61$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $02e68f8ca5696f61$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $02e68f8ca5696f61$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $02e68f8ca5696f61$export$f188226459c8a3ff(splide);
        event.on($02e68f8ca5696f61$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($02e68f8ca5696f61$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($02e68f8ca5696f61$export$5adb665701eda1ce, onClick);
        on($02e68f8ca5696f61$export$6d5af59619d10e6a, onKeydown);
        on([
            $02e68f8ca5696f61$export$d300dc1a2634364b,
            $02e68f8ca5696f61$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($02e68f8ca5696f61$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $02e68f8ca5696f61$var$setAttribute(Components2.Elements.list, $02e68f8ca5696f61$var$ARIA_ORIENTATION, options.direction === $02e68f8ca5696f61$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($02e68f8ca5696f61$var$includes($02e68f8ca5696f61$var$TRIGGER_KEYS, $02e68f8ca5696f61$var$normalizeKey(e))) {
            onClick(Slide);
            $02e68f8ca5696f61$var$prevent(e);
        }
    }
    return {
        setup: $02e68f8ca5696f61$var$apply(Components2.Media.set, {
            slideFocus: $02e68f8ca5696f61$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $02e68f8ca5696f61$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $02e68f8ca5696f61$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $02e68f8ca5696f61$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($02e68f8ca5696f61$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $02e68f8ca5696f61$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($02e68f8ca5696f61$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $02e68f8ca5696f61$var$SR_REMOVAL_DELAY = 90;
function $02e68f8ca5696f61$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $02e68f8ca5696f61$var$create("span", $02e68f8ca5696f61$export$bb78d7c200da8960);
    var interval = $02e68f8ca5696f61$export$46ad21b25b6dccf0($02e68f8ca5696f61$var$SR_REMOVAL_DELAY, $02e68f8ca5696f61$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $02e68f8ca5696f61$var$setAttribute(track, $02e68f8ca5696f61$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($02e68f8ca5696f61$export$23663268a31b79e2, $02e68f8ca5696f61$var$apply(disable, true));
            on($02e68f8ca5696f61$export$16a1e4f3d0368265, $02e68f8ca5696f61$var$apply(disable, false));
            on([
                $02e68f8ca5696f61$export$fe5802204b967f0d,
                $02e68f8ca5696f61$export$ff8164bff3202b9
            ], $02e68f8ca5696f61$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $02e68f8ca5696f61$var$setAttribute(track, $02e68f8ca5696f61$var$ARIA_BUSY, active);
        if (active) {
            $02e68f8ca5696f61$var$append(track, sr);
            interval.start();
        } else {
            $02e68f8ca5696f61$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $02e68f8ca5696f61$var$removeAttribute(track, [
            $02e68f8ca5696f61$var$ARIA_LIVE,
            $02e68f8ca5696f61$var$ARIA_ATOMIC,
            $02e68f8ca5696f61$var$ARIA_BUSY
        ]);
        $02e68f8ca5696f61$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $02e68f8ca5696f61$var$setAttribute(track, $02e68f8ca5696f61$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $02e68f8ca5696f61$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $02e68f8ca5696f61$var$Media,
    Direction: $02e68f8ca5696f61$var$Direction,
    Elements: $02e68f8ca5696f61$var$Elements,
    Slides: $02e68f8ca5696f61$var$Slides,
    Layout: $02e68f8ca5696f61$var$Layout,
    Clones: $02e68f8ca5696f61$var$Clones,
    Move: $02e68f8ca5696f61$var$Move,
    Controller: $02e68f8ca5696f61$var$Controller,
    Arrows: $02e68f8ca5696f61$var$Arrows,
    Autoplay: $02e68f8ca5696f61$var$Autoplay,
    Cover: $02e68f8ca5696f61$var$Cover,
    Scroll: $02e68f8ca5696f61$var$Scroll,
    Drag: $02e68f8ca5696f61$var$Drag,
    Keyboard: $02e68f8ca5696f61$var$Keyboard,
    LazyLoad: $02e68f8ca5696f61$var$LazyLoad,
    Pagination: $02e68f8ca5696f61$var$Pagination,
    Sync: $02e68f8ca5696f61$var$Sync,
    Wheel: $02e68f8ca5696f61$var$Wheel,
    Live: $02e68f8ca5696f61$var$Live
});
var $02e68f8ca5696f61$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $02e68f8ca5696f61$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $02e68f8ca5696f61$export$ba41d43e4a419565,
    i18n: $02e68f8ca5696f61$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $02e68f8ca5696f61$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2).on([
            $02e68f8ca5696f61$export$d300dc1a2634364b,
            $02e68f8ca5696f61$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $02e68f8ca5696f61$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $02e68f8ca5696f61$var$noop
    };
}
function $02e68f8ca5696f61$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $02e68f8ca5696f61$var$apply($02e68f8ca5696f61$var$style, list, "transition");
    var endCallback;
    function mount() {
        $02e68f8ca5696f61$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($02e68f8ca5696f61$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($02e68f8ca5696f61$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $02e68f8ca5696f61$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $02e68f8ca5696f61$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $02e68f8ca5696f61$export$7254cc27399e90bd($02e68f8ca5696f61$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $02e68f8ca5696f61$var$isString(target) ? $02e68f8ca5696f61$var$query(document, target) : target;
        $02e68f8ca5696f61$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $02e68f8ca5696f61$var$merge({
            label: $02e68f8ca5696f61$var$getAttribute(root, $02e68f8ca5696f61$var$ARIA_LABEL) || "",
            labelledby: $02e68f8ca5696f61$var$getAttribute(root, $02e68f8ca5696f61$var$ARIA_LABELLEDBY) || ""
        }, $02e68f8ca5696f61$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $02e68f8ca5696f61$var$merge(options, JSON.parse($02e68f8ca5696f61$var$getAttribute(root, $02e68f8ca5696f61$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $02e68f8ca5696f61$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($02e68f8ca5696f61$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $02e68f8ca5696f61$var$assert(state.is([
            $02e68f8ca5696f61$var$CREATED,
            $02e68f8ca5696f61$var$DESTROYED
        ]), "Already mounted!");
        state.set($02e68f8ca5696f61$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($02e68f8ca5696f61$export$742b62a5690c060) ? $02e68f8ca5696f61$var$Fade : $02e68f8ca5696f61$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $02e68f8ca5696f61$var$assign({}, $02e68f8ca5696f61$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $02e68f8ca5696f61$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $02e68f8ca5696f61$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($02e68f8ca5696f61$export$d300dc1a2634364b);
        $02e68f8ca5696f61$var$addClass(this.root, $02e68f8ca5696f61$export$7761661e2d5b9388);
        state.set($02e68f8ca5696f61$var$IDLE);
        this.emit($02e68f8ca5696f61$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($02e68f8ca5696f61$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($02e68f8ca5696f61$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($02e68f8ca5696f61$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($02e68f8ca5696f61$var$CREATED)) $02e68f8ca5696f61$export$f188226459c8a3ff(this).on($02e68f8ca5696f61$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $02e68f8ca5696f61$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($02e68f8ca5696f61$export$88c4cf7419e470cd);
            event.destroy();
            completely && $02e68f8ca5696f61$var$empty(this.splides);
            state.set($02e68f8ca5696f61$var$DESTROYED);
        }
        return this;
    };
    $02e68f8ca5696f61$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $02e68f8ca5696f61$export$24494c7438c070bf = $02e68f8ca5696f61$var$_Splide;
$02e68f8ca5696f61$export$24494c7438c070bf.defaults = {};
$02e68f8ca5696f61$export$24494c7438c070bf.STATES = $02e68f8ca5696f61$var$STATES;
var $02e68f8ca5696f61$var$CLASS_RENDERED = "is-rendered";
var $02e68f8ca5696f61$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $02e68f8ca5696f61$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $02e68f8ca5696f61$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $02e68f8ca5696f61$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $02e68f8ca5696f61$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $02e68f8ca5696f61$var$merge($02e68f8ca5696f61$export$f484e977a69c6ba6, defaults || {});
        $02e68f8ca5696f61$var$merge($02e68f8ca5696f61$var$merge(this.options, $02e68f8ca5696f61$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $02e68f8ca5696f61$var$assign({}, $02e68f8ca5696f61$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $02e68f8ca5696f61$var$uniqueId("splide");
        this.Style = new $02e68f8ca5696f61$var$Style(this.id, this.options);
        this.Direction = $02e68f8ca5696f61$var$Direction(null, null, this.options);
        $02e68f8ca5696f61$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $02e68f8ca5696f61$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $02e68f8ca5696f61$var$queryAll(root, "." + $02e68f8ca5696f61$export$2c1ba4a4f1aa4947);
        on($02e68f8ca5696f61$export$d300dc1a2634364b, function() {
            $02e68f8ca5696f61$var$remove($02e68f8ca5696f61$var$child(root, "style"));
        });
        $02e68f8ca5696f61$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $02e68f8ca5696f61$var$push(this.slides, this.contents.map(function(content, index) {
            content = $02e68f8ca5696f61$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $02e68f8ca5696f61$export$72d36ecf3758cb4b : "");
            $02e68f8ca5696f61$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $02e68f8ca5696f61$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $02e68f8ca5696f61$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $02e68f8ca5696f61$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $02e68f8ca5696f61$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $02e68f8ca5696f61$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $02e68f8ca5696f61$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $02e68f8ca5696f61$var$unit(padding[prop] || ($02e68f8ca5696f61$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $02e68f8ca5696f61$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $02e68f8ca5696f61$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $02e68f8ca5696f61$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $02e68f8ca5696f61$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $02e68f8ca5696f61$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($02e68f8ca5696f61$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $02e68f8ca5696f61$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $02e68f8ca5696f61$var$merge($02e68f8ca5696f61$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $02e68f8ca5696f61$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $02e68f8ca5696f61$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $02e68f8ca5696f61$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $02e68f8ca5696f61$export$93b21159ad85c843,
            $02e68f8ca5696f61$export$93b21159ad85c843 + "--" + options.type,
            $02e68f8ca5696f61$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $02e68f8ca5696f61$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $02e68f8ca5696f61$export$93b21159ad85c843 + "--nav",
            $02e68f8ca5696f61$export$72d36ecf3758cb4b,
            !this.config.hidden && $02e68f8ca5696f61$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $02e68f8ca5696f61$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $02e68f8ca5696f61$var$camelToKebab(key) + '="' + value + '"' : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $02e68f8ca5696f61$var$forOwn(styles, function(value, key) {
            style += " " + $02e68f8ca5696f61$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$02e68f8ca5696f61$var$push(slides, slides);
        $02e68f8ca5696f61$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $02e68f8ca5696f61$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $02e68f8ca5696f61$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $02e68f8ca5696f61$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += '<div class="' + this.options.classes.arrows + '">';
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + '><svg xmlns="' + $02e68f8ca5696f61$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $02e68f8ca5696f61$var$SIZE + " " + $02e68f8ca5696f61$var$SIZE + '" width="' + $02e68f8ca5696f61$var$SIZE + '" height="' + $02e68f8ca5696f61$var$SIZE + '"><path d="' + (this.options.arrowPath || $02e68f8ca5696f61$var$PATH) + '" /></svg></button>';
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += '<div id="' + this.id + '" class="' + this.buildClasses() + " " + (rootClass || "") + '">';
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += '<div class="splide__slider">';
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += '<div class="splide__track">';
        html += "<" + listTag + ' class="splide__list">';
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


const $ec1ca42a27246f5f$export$11492d885e5574aa = ()=>{
    new (0, $02e68f8ca5696f61$export$24494c7438c070bf)(".service-splide", {
        type: "loop",
        perPage: 3,
        perMove: 1,
        gap: "30px",
        autoplay: true,
        speed: 500,
        interval: 5000,
        pagination: false,
        breakpoints: {
            1024: {
                perPage: 3
            },
            767: {
                perPage: 2
            },
            640: {
                perPage: 1
            }
        }
    }).mount();
};


var $8399e4e9dca8c987$exports = {};
/**!
 * MixItUp v3.3.1
 * A high-performance, dependency-free library for animated filtering, sorting and more
 * Build 94e0fbf6-cd0b-4987-b3c0-14b59b67b8a0
 *
 * @copyright Copyright 2014-2018 KunkaLabs Limited.
 * @author    KunkaLabs Limited.
 * @link      https://www.kunkalabs.com/mixitup/
 *
 * @license   Commercial use requires a commercial license.
 *            https://www.kunkalabs.com/mixitup/licenses/
 *
 *            Non-commercial use permitted under same terms as CC BY-NC 3.0 license.
 *            http://creativecommons.org/licenses/by-nc/3.0/
 */ (function(window1) {
    "use strict";
    var mixitup = null, h = null;
    (function() {
        var VENDORS = [
            "webkit",
            "moz",
            "o",
            "ms"
        ], canary = window1.document.createElement("div"), i = -1;
        // window.requestAnimationFrame
        for(i = 0; i < VENDORS.length && !window1.requestAnimationFrame; i++)window1.requestAnimationFrame = window1[VENDORS[i] + "RequestAnimationFrame"];
        // Element.nextElementSibling
        if (typeof canary.nextElementSibling === "undefined") Object.defineProperty(window1.Element.prototype, "nextElementSibling", {
            get: function() {
                var el = this.nextSibling;
                while(el){
                    if (el.nodeType === 1) return el;
                    el = el.nextSibling;
                }
                return null;
            }
        });
        // Element.matches
        (function(ElementPrototype) {
            ElementPrototype.matches = ElementPrototype.matches || ElementPrototype.machesSelector || ElementPrototype.mozMatchesSelector || ElementPrototype.msMatchesSelector || ElementPrototype.oMatchesSelector || ElementPrototype.webkitMatchesSelector || function(selector) {
                return Array.prototype.indexOf.call(this.parentElement.querySelectorAll(selector), this) > -1;
            };
        })(window1.Element.prototype);
        // Object.keys
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
        if (!Object.keys) Object.keys = function() {
            var hasOwnProperty = Object.prototype.hasOwnProperty, hasDontEnumBug = false, dontEnums = [], dontEnumsLength = -1;
            hasDontEnumBug = !({
                toString: null
            }).propertyIsEnumerable("toString");
            dontEnums = [
                "toString",
                "toLocaleString",
                "valueOf",
                "hasOwnProperty",
                "isPrototypeOf",
                "propertyIsEnumerable",
                "constructor"
            ];
            dontEnumsLength = dontEnums.length;
            return function(obj) {
                var result = [], prop = "", i = -1;
                if (typeof obj !== "object" && (typeof obj !== "function" || obj === null)) throw new TypeError("Object.keys called on non-object");
                for(prop in obj)if (hasOwnProperty.call(obj, prop)) result.push(prop);
                if (hasDontEnumBug) {
                    for(i = 0; i < dontEnumsLength; i++)if (hasOwnProperty.call(obj, dontEnums[i])) result.push(dontEnums[i]);
                }
                return result;
            };
        }();
        // Array.isArray
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
        if (!Array.isArray) Array.isArray = function(arg) {
            return Object.prototype.toString.call(arg) === "[object Array]";
        };
        // Object.create
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/create
        if (typeof Object.create !== "function") Object.create = function(undefined) {
            var Temp = function() {};
            return function(prototype, propertiesObject) {
                if (prototype !== Object(prototype) && prototype !== null) throw TypeError("Argument must be an object, or null");
                Temp.prototype = prototype || {};
                var result = new Temp();
                Temp.prototype = null;
                if (propertiesObject !== undefined) Object.defineProperties(result, propertiesObject);
                if (prototype === null) /* jshint ignore:start */ result.__proto__ = null;
                return result;
            };
        }();
        // String.prototyoe.trim
        if (!String.prototype.trim) String.prototype.trim = function() {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        };
        // Array.prototype.indexOf
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf
        if (!Array.prototype.indexOf) Array.prototype.indexOf = function(searchElement) {
            var n, k, t, len;
            if (this === null) throw new TypeError();
            t = Object(this);
            len = t.length >>> 0;
            if (len === 0) return -1;
            n = 0;
            if (arguments.length > 1) {
                n = Number(arguments[1]);
                if (n !== n) n = 0;
                else if (n !== 0 && n !== Infinity && n !== -Infinity) n = (n > 0 || -1) * Math.floor(Math.abs(n));
            }
            if (n >= len) return -1;
            for(k = n >= 0 ? n : Math.max(len - Math.abs(n), 0); k < len; k++){
                if (k in t && t[k] === searchElement) return k;
            }
            return -1;
        };
        // Function.prototype.bind
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_objects/Function/bind
        if (!Function.prototype.bind) Function.prototype.bind = function(oThis) {
            var aArgs, self, FNOP, fBound;
            if (typeof this !== "function") throw new TypeError();
            aArgs = Array.prototype.slice.call(arguments, 1);
            self = this;
            FNOP = function() {};
            fBound = function() {
                return self.apply(this instanceof FNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
            };
            if (this.prototype) FNOP.prototype = this.prototype;
            fBound.prototype = new FNOP();
            return fBound;
        };
        // Element.prototype.dispatchEvent
        if (!window1.Element.prototype.dispatchEvent) window1.Element.prototype.dispatchEvent = function(event) {
            try {
                return this.fireEvent("on" + event.type, event);
            } catch (err) {}
        };
    })();
    /**
     * The `mixitup()` "factory" function creates and returns individual instances
     * of MixItUp, known as "mixers", on which API methods can be called.
     *
     * When loading MixItUp via a script tag, the factory function is accessed
     * via the global variable `mixitup`. When using a module loading
     * system (e.g. ES2015, CommonJS, RequireJS), the factory function is
     * exported into your module when you require the MixItUp library.
     *
     * @example
     * mixitup(container [,config] [,foreignDoc])
     *
     * @example <caption>Example 1: Creating a mixer instance with an element reference</caption>
     * var containerEl = document.querySelector('.container');
     *
     * var mixer = mixitup(containerEl);
     *
     * @example <caption>Example 2: Creating a mixer instance with a selector string</caption>
     * var mixer = mixitup('.container');
     *
     * @example <caption>Example 3: Passing a configuration object</caption>
     * var mixer = mixitup(containerEl, {
     *     animation: {
     *         effects: 'fade scale(0.5)'
     *     }
     * });
     *
     * @example <caption>Example 4: Passing an iframe reference</caption>
     * var mixer = mixitup(containerEl, config, foreignDocument);
     *
     * @global
     * @namespace
     * @public
     * @kind        function
     * @since       3.0.0
     * @param       {(Element|string)}  container
     *      A DOM element or selector string representing the container(s) on which to instantiate MixItUp.
     * @param       {object}            [config]
     *      An optional "configuration object" used to customize the behavior of the MixItUp instance.
     * @param       {object}            [foreignDoc]
     *      An optional reference to a `document`, which can be used to control a MixItUp instance in an iframe.
     * @return      {mixitup.Mixer}
     *      A "mixer" object holding the MixItUp instance.
     */ mixitup = function(container, config, foreignDoc) {
        var el = null, returnCollection = false, instance = null, facade = null, doc = null, output = null, instances = [], id = "", elements = [], i = -1;
        doc = foreignDoc || window1.document;
        if (returnCollection = arguments[3]) // A non-documented 4th paramater enabling control of multiple instances
        returnCollection = typeof returnCollection === "boolean";
        if (typeof container === "string") elements = doc.querySelectorAll(container);
        else if (container && typeof container === "object" && h.isElement(container, doc)) elements = [
            container
        ];
        else if (container && typeof container === "object" && container.length) // Although not documented, the container may also be an array-like list of
        // elements such as a NodeList or jQuery collection, is returnCollection is true
        elements = container;
        else throw new Error(mixitup.messages.errorFactoryInvalidContainer());
        if (elements.length < 1) throw new Error(mixitup.messages.errorFactoryContainerNotFound());
        for(i = 0; el = elements[i]; i++){
            if (i > 0 && !returnCollection) break;
            if (!el.id) {
                id = "MixItUp" + h.randomHex();
                el.id = id;
            } else id = el.id;
            if (mixitup.instances[id] instanceof mixitup.Mixer) {
                instance = mixitup.instances[id];
                if (!config || config && config.debug && config.debug.showWarnings !== false) console.warn(mixitup.messages.warningFactoryPreexistingInstance());
            } else {
                instance = new mixitup.Mixer();
                instance.attach(el, doc, id, config);
                mixitup.instances[id] = instance;
            }
            facade = new mixitup.Facade(instance);
            if (config && config.debug && config.debug.enable) instances.push(instance);
            else instances.push(facade);
        }
        if (returnCollection) output = new mixitup.Collection(instances);
        else // Return the first instance regardless
        output = instances[0];
        return output;
    };
    /**
     * The `.use()` static method is used to extend the functionality of mixitup with compatible
     * extensions and libraries in an environment with modular scoping e.g. ES2015, CommonJS, or RequireJS.
     *
     * You need only call the `.use()` function once per project, per extension, as module loaders
     * will cache a single reference to MixItUp inclusive of all changes made.
     *
     * @example
     * mixitup.use(extension)
     *
     * @example <caption>Example 1: Extending MixItUp with the Pagination Extension</caption>
     *
     * import mixitup from 'mixitup';
     * import mixitupPagination from 'mixitup-pagination';
     *
     * mixitup.use(mixitupPagination);
     *
     * // All mixers created by the factory function in all modules will now
     * // have pagination functionality
     *
     * var mixer = mixitup('.container');
     *
     * @public
     * @name     use
     * @memberof mixitup
     * @kind     function
     * @static
     * @since    3.0.0
     * @param    {*}  extension   A reference to the extension or library to be used.
     * @return   {void}
     */ mixitup.use = function(extension) {
        mixitup.Base.prototype.callActions.call(mixitup, "beforeUse", arguments);
        // Call the extension's factory function, passing
        // the mixitup factory as a paramater
        if (typeof extension === "function" && extension.TYPE === "mixitup-extension") // Mixitup extension
        {
            if (typeof mixitup.extensions[extension.NAME] === "undefined") {
                extension(mixitup);
                mixitup.extensions[extension.NAME] = extension;
            }
        } else if (extension.fn && extension.fn.jquery) // jQuery
        mixitup.libraries.$ = extension;
        mixitup.Base.prototype.callActions.call(mixitup, "afterUse", arguments);
    };
    mixitup.instances = {};
    mixitup.extensions = {};
    mixitup.libraries = {};
    /**
     * @private
     */ h = {
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        cls
         * @return  {boolean}
         */ hasClass: function(el, cls) {
            return !!el.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        cls
         * @return  {void}
         */ addClass: function(el, cls) {
            if (!this.hasClass(el, cls)) el.className += el.className ? " " + cls : cls;
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        cls
         * @return  {void}
         */ removeClass: function(el, cls) {
            if (this.hasClass(el, cls)) {
                var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
                el.className = el.className.replace(reg, " ").trim();
            }
        },
        /**
         * Merges the properties of the source object onto the
         * target object. Alters the target object.
         *
         * @private
         * @param   {object}    destination
         * @param   {object}    source
         * @param   {boolean}   [deep=false]
         * @param   {boolean}   [handleErrors=false]
         * @return  {void}
         */ extend: function(destination, source, deep, handleErrors) {
            var sourceKeys = [], key = "", i = -1;
            deep = deep || false;
            handleErrors = handleErrors || false;
            try {
                if (Array.isArray(source)) for(i = 0; i < source.length; i++)sourceKeys.push(i);
                else if (source) sourceKeys = Object.keys(source);
                for(i = 0; i < sourceKeys.length; i++){
                    key = sourceKeys[i];
                    if (!deep || typeof source[key] !== "object" || this.isElement(source[key])) // All non-object properties, or all properties if shallow extend
                    destination[key] = source[key];
                    else if (Array.isArray(source[key])) {
                        // Arrays
                        if (!destination[key]) destination[key] = [];
                        this.extend(destination[key], source[key], deep, handleErrors);
                    } else {
                        // Objects
                        if (!destination[key]) destination[key] = {};
                        this.extend(destination[key], source[key], deep, handleErrors);
                    }
                }
            } catch (err) {
                if (handleErrors) this.handleExtendError(err, destination);
                else throw err;
            }
            return destination;
        },
        /**
         * @private
         * @param   {Error}  err
         * @param   {object} destination
         * @return  {void}
         */ handleExtendError: function(err, destination) {
            var re = /property "?(\w*)"?[,:] object/i, matches = null, erroneous = "", message = "", suggestion = "", probableMatch = "", key = "", mostMatchingChars = -1, i = -1;
            if (err instanceof TypeError && (matches = re.exec(err.message))) {
                erroneous = matches[1];
                for(key in destination){
                    i = 0;
                    while(i < erroneous.length && erroneous.charAt(i) === key.charAt(i))i++;
                    if (i > mostMatchingChars) {
                        mostMatchingChars = i;
                        probableMatch = key;
                    }
                }
                if (mostMatchingChars > 1) suggestion = mixitup.messages.errorConfigInvalidPropertySuggestion({
                    probableMatch: probableMatch
                });
                message = mixitup.messages.errorConfigInvalidProperty({
                    erroneous: erroneous,
                    suggestion: suggestion
                });
                throw new TypeError(message);
            }
            throw err;
        },
        /**
         * @private
         * @param   {string} str
         * @return  {function}
         */ template: function(str) {
            var re = /\${([\w]*)}/g, dynamics = {}, matches = null;
            while(matches = re.exec(str))dynamics[matches[1]] = new RegExp("\\${" + matches[1] + "}", "g");
            return function(data) {
                var key = "", output = str;
                data = data || {};
                for(key in dynamics)output = output.replace(dynamics[key], typeof data[key] !== "undefined" ? data[key] : "");
                return output;
            };
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        type
         * @param   {function}      fn
         * @param   {boolean}       useCapture
         * @return  {void}
         */ on: function(el, type, fn, useCapture) {
            if (!el) return;
            if (el.addEventListener) el.addEventListener(type, fn, useCapture);
            else if (el.attachEvent) {
                el["e" + type + fn] = fn;
                el[type + fn] = function() {
                    el["e" + type + fn](window1.event);
                };
                el.attachEvent("on" + type, el[type + fn]);
            }
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        type
         * @param   {function}      fn
         * @return  {void}
         */ off: function(el, type, fn) {
            if (!el) return;
            if (el.removeEventListener) el.removeEventListener(type, fn, false);
            else if (el.detachEvent) {
                el.detachEvent("on" + type, el[type + fn]);
                el[type + fn] = null;
            }
        },
        /**
         * @private
         * @param   {string}      eventType
         * @param   {object}      detail
         * @param   {Document}    [doc]
         * @return  {CustomEvent}
         */ getCustomEvent: function(eventType, detail, doc) {
            var event = null;
            doc = doc || window1.document;
            if (typeof window1.CustomEvent === "function") event = new window1.CustomEvent(eventType, {
                detail: detail,
                bubbles: true,
                cancelable: true
            });
            else if (typeof doc.createEvent === "function") {
                event = doc.createEvent("CustomEvent");
                event.initCustomEvent(eventType, true, true, detail);
            } else {
                event = doc.createEventObject(), event.type = eventType;
                event.returnValue = false;
                event.cancelBubble = false;
                event.detail = detail;
            }
            return event;
        },
        /**
         * @private
         * @param   {Event} e
         * @return  {Event}
         */ getOriginalEvent: function(e) {
            if (e.touches && e.touches.length) return e.touches[0];
            else if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0];
            else return e;
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        selector
         * @return  {Number}
         */ index: function(el, selector) {
            var i = 0;
            while((el = el.previousElementSibling) !== null)if (!selector || el.matches(selector)) ++i;
            return i;
        },
        /**
         * Converts a dash or snake-case string to camel case.
         *
         * @private
         * @param   {string}    str
         * @param   {boolean}   [isPascal]
         * @return  {string}
         */ camelCase: function(str) {
            return str.toLowerCase().replace(/([_-][a-z])/g, function($1) {
                return $1.toUpperCase().replace(/[_-]/, "");
            });
        },
        /**
         * Converts a dash or snake-case string to pascal case.
         *
         * @private
         * @param   {string}    str
         * @param   {boolean}   [isPascal]
         * @return  {string}
         */ pascalCase: function(str) {
            return (str = this.camelCase(str)).charAt(0).toUpperCase() + str.slice(1);
        },
        /**
         * Converts a camel or pascal-case string to dash case.
         *
         * @private
         * @param   {string}    str
         * @return  {string}
         */ dashCase: function(str) {
            return str.replace(/([A-Z])/g, "-$1").replace(/^-/, "").toLowerCase();
        },
        /**
         * @private
         * @param   {HTMLElement}       el
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {boolean}
         */ isElement: function(el, doc) {
            doc = doc || window1.document;
            if (window1.HTMLElement && el instanceof window1.HTMLElement) return true;
            else if (doc.defaultView && doc.defaultView.HTMLElement && el instanceof doc.defaultView.HTMLElement) return true;
            else return el !== null && el.nodeType === 1 && typeof el.nodeName === "string";
        },
        /**
         * @private
         * @param   {string}            htmlString
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {DocumentFragment}
         */ createElement: function(htmlString, doc) {
            var frag = null, temp = null;
            doc = doc || window1.document;
            frag = doc.createDocumentFragment();
            temp = doc.createElement("div");
            temp.innerHTML = htmlString.trim();
            while(temp.firstChild)frag.appendChild(temp.firstChild);
            return frag;
        },
        /**
         * @private
         * @param   {Node} node
         * @return  {void}
         */ removeWhitespace: function(node) {
            var deleting;
            while(node && node.nodeName === "#text"){
                deleting = node;
                node = node.previousSibling;
                deleting.parentElement && deleting.parentElement.removeChild(deleting);
            }
        },
        /**
         * @private
         * @param   {Array<*>}  a
         * @param   {Array<*>}  b
         * @return  {boolean}
         */ isEqualArray: function(a, b) {
            var i = a.length;
            if (i !== b.length) return false;
            while(i--){
                if (a[i] !== b[i]) return false;
            }
            return true;
        },
        /**
         * @private
         * @param   {object}  a
         * @param   {object}  b
         * @return  {boolean}
         */ deepEquals: function(a, b) {
            var key;
            if (typeof a === "object" && a && typeof b === "object" && b) {
                if (Object.keys(a).length !== Object.keys(b).length) return false;
                for(key in a){
                    if (!b.hasOwnProperty(key) || !this.deepEquals(a[key], b[key])) return false;
                }
            } else if (a !== b) return false;
            return true;
        },
        /**
         * @private
         * @param   {Array<*>}  oldArray
         * @return  {Array<*>}
         */ arrayShuffle: function(oldArray) {
            var newArray = oldArray.slice(), len = newArray.length, i = len, p = -1, t = [];
            while(i--){
                p = ~~(Math.random() * len);
                t = newArray[i];
                newArray[i] = newArray[p];
                newArray[p] = t;
            }
            return newArray;
        },
        /**
         * @private
         * @param   {object}    list
         */ arrayFromList: function(list) {
            var output, i;
            try {
                return Array.prototype.slice.call(list);
            } catch (err) {
                output = [];
                for(i = 0; i < list.length; i++)output.push(list[i]);
                return output;
            }
        },
        /**
         * @private
         * @param   {function}  func
         * @param   {Number}    wait
         * @param   {boolean}   immediate
         * @return  {function}
         */ debounce: function(func, wait, immediate) {
            var timeout;
            return function() {
                var self = this, args = arguments, callNow = immediate && !timeout, later = null;
                later = function() {
                    timeout = null;
                    if (!immediate) func.apply(self, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(self, args);
            };
        },
        /**
         * @private
         * @param   {HTMLElement}   element
         * @return  {object}
         */ position: function(element) {
            var xPosition = 0, yPosition = 0, offsetParent = element;
            while(element){
                xPosition -= element.scrollLeft;
                yPosition -= element.scrollTop;
                if (element === offsetParent) {
                    xPosition += element.offsetLeft;
                    yPosition += element.offsetTop;
                    offsetParent = element.offsetParent;
                }
                element = element.parentElement;
            }
            return {
                x: xPosition,
                y: yPosition
            };
        },
        /**
         * @private
         * @param   {object}    node1
         * @param   {object}    node2
         * @return  {Number}
         */ getHypotenuse: function(node1, node2) {
            var distanceX = node1.x - node2.x, distanceY = node1.y - node2.y;
            distanceX = distanceX < 0 ? distanceX * -1 : distanceX, distanceY = distanceY < 0 ? distanceY * -1 : distanceY;
            return Math.sqrt(Math.pow(distanceX, 2) + Math.pow(distanceY, 2));
        },
        /**
         * Calcuates the area of intersection between two rectangles and expresses it as
         * a ratio in comparison to the area of the first rectangle.
         *
         * @private
         * @param   {Rect}  box1
         * @param   {Rect}  box2
         * @return  {number}
         */ getIntersectionRatio: function(box1, box2) {
            var controlArea = box1.width * box1.height, intersectionX = -1, intersectionY = -1, intersectionArea = -1, ratio = -1;
            intersectionX = Math.max(0, Math.min(box1.left + box1.width, box2.left + box2.width) - Math.max(box1.left, box2.left));
            intersectionY = Math.max(0, Math.min(box1.top + box1.height, box2.top + box2.height) - Math.max(box1.top, box2.top));
            intersectionArea = intersectionY * intersectionX;
            ratio = intersectionArea / controlArea;
            return ratio;
        },
        /**
         * @private
         * @param   {object}            el
         * @param   {string}            selector
         * @param   {boolean}           [includeSelf]
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {Element|null}
         */ closestParent: function(el, selector, includeSelf, doc) {
            var parent = el.parentNode;
            doc = doc || window1.document;
            if (includeSelf && el.matches(selector)) return el;
            while(parent && parent != doc.body){
                if (parent.matches && parent.matches(selector)) return parent;
                else if (parent.parentNode) parent = parent.parentNode;
                else return null;
            }
            return null;
        },
        /**
         * @private
         * @param   {HTMLElement}       el
         * @param   {string}            selector
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {NodeList}
         */ children: function(el, selector, doc) {
            var children = [], tempId = "";
            doc = doc || window1.doc;
            if (el) {
                if (!el.id) {
                    tempId = "Temp" + this.randomHexKey();
                    el.id = tempId;
                }
                children = doc.querySelectorAll("#" + el.id + " > " + selector);
                if (tempId) el.removeAttribute("id");
            }
            return children;
        },
        /**
         * Creates a clone of a provided array, with any empty strings removed.
         *
         * @private
         * @param   {Array<*>} originalArray
         * @return  {Array<*>}
         */ clean: function(originalArray) {
            var cleanArray = [], i = -1;
            for(i = 0; i < originalArray.length; i++)if (originalArray[i] !== "") cleanArray.push(originalArray[i]);
            return cleanArray;
        },
        /**
         * Abstracts an ES6 promise into a q-like deferred interface for storage and deferred resolution.
         *
         * @private
         * @param  {object} libraries
         * @return {h.Deferred}
         */ defer: function(libraries) {
            var deferred = null, promiseWrapper = null, $ = null;
            promiseWrapper = new this.Deferred();
            if (mixitup.features.has.promises) // ES6 native promise or polyfill
            promiseWrapper.promise = new Promise(function(resolve, reject) {
                promiseWrapper.resolve = resolve;
                promiseWrapper.reject = reject;
            });
            else if (($ = window1.jQuery || libraries.$) && typeof $.Deferred === "function") {
                // jQuery
                deferred = $.Deferred();
                promiseWrapper.promise = deferred.promise();
                promiseWrapper.resolve = deferred.resolve;
                promiseWrapper.reject = deferred.reject;
            } else if (window1.console) // No implementation
            console.warn(mixitup.messages.warningNoPromiseImplementation());
            return promiseWrapper;
        },
        /**
         * @private
         * @param   {Array<Promise>}    tasks
         * @param   {object}            libraries
         * @return  {Promise<Array>}
         */ all: function(tasks, libraries) {
            var $ = null;
            if (mixitup.features.has.promises) return Promise.all(tasks);
            else if (($ = window1.jQuery || libraries.$) && typeof $.when === "function") return $.when.apply($, tasks).done(function() {
                // jQuery when returns spread arguments rather than an array or resolutions
                return arguments;
            });
            // No implementation
            if (window1.console) console.warn(mixitup.messages.warningNoPromiseImplementation());
            return [];
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        property
         * @param   {Array<string>} vendors
         * @return  {string}
         */ getPrefix: function(el, property, vendors) {
            var i = -1, prefix = "";
            if (h.dashCase(property) in el.style) return "";
            for(i = 0; prefix = vendors[i]; i++){
                if (prefix + property in el.style) return prefix.toLowerCase();
            }
            return "unsupported";
        },
        /**
         * @private
         * @return  {string}
         */ randomHex: function() {
            return ("00000" + (Math.random() * 16777216 << 0).toString(16)).substr(-6).toUpperCase();
        },
        /**
         * @private
         * @param   {HTMLDocument}  [doc]
         * @return  {object}
         */ getDocumentState: function(doc) {
            doc = typeof doc.body === "object" ? doc : window1.document;
            return {
                scrollTop: window1.pageYOffset,
                scrollLeft: window1.pageXOffset,
                docHeight: doc.documentElement.scrollHeight,
                docWidth: doc.documentElement.scrollWidth,
                viewportHeight: doc.documentElement.clientHeight,
                viewportWidth: doc.documentElement.clientWidth
            };
        },
        /**
         * @private
         * @param   {object}    obj
         * @param   {function}  fn
         * @return  {function}
         */ bind: function(obj, fn) {
            return function() {
                return fn.apply(obj, arguments);
            };
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @return  {boolean}
         */ isVisible: function(el) {
            var styles = null;
            if (el.offsetParent) return true;
            styles = window1.getComputedStyle(el);
            if (styles.position === "fixed" && styles.visibility !== "hidden" && styles.opacity !== "0") // Fixed elements report no offsetParent,
            // but may still be invisible
            return true;
            return false;
        },
        /**
         * @private
         * @param   {object}    obj
         */ seal: function(obj) {
            if (typeof Object.seal === "function") Object.seal(obj);
        },
        /**
         * @private
         * @param   {object}    obj
         */ freeze: function(obj) {
            if (typeof Object.freeze === "function") Object.freeze(obj);
        },
        /**
         * @private
         * @param   {string}    control
         * @param   {string}    specimen
         * @return  {boolean}
         */ compareVersions: function(control, specimen) {
            var controlParts = control.split("."), specimenParts = specimen.split("."), controlPart = -1, specimenPart = -1, i = -1;
            for(i = 0; i < controlParts.length; i++){
                controlPart = parseInt(controlParts[i].replace(/[^\d.]/g, ""));
                specimenPart = parseInt(specimenParts[i].replace(/[^\d.]/g, "") || 0);
                if (specimenPart < controlPart) return false;
                else if (specimenPart > controlPart) return true;
            }
            return true;
        },
        /**
         * @private
         * @constructor
         */ Deferred: function() {
            this.promise = null;
            this.resolve = null;
            this.reject = null;
            this.id = h.randomHex();
        },
        /**
         * @private
         * @param   {object}  obj
         * @return  {boolean}
         */ isEmptyObject: function(obj) {
            var key = "";
            if (typeof Object.keys === "function") return Object.keys(obj).length === 0;
            for(key in obj){
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        },
        /**
         * @param   {mixitup.Config.ClassNames}   classNames
         * @param   {string}                      elementName
         * @param   {string}                      [modifier]
         * @return  {string}
         */ getClassname: function(classNames, elementName, modifier) {
            var classname = "";
            classname += classNames.block;
            if (classname.length) classname += classNames.delineatorElement;
            classname += classNames["element" + this.pascalCase(elementName)];
            if (!modifier) return classname;
            if (classname.length) classname += classNames.delineatorModifier;
            classname += modifier;
            return classname;
        },
        /**
         * Returns the value of a property on a given object via its string key.
         *
         * @param   {object}    obj
         * @param   {string}    stringKey
         * @return  {*} value
         */ getProperty: function(obj, stringKey) {
            var parts = stringKey.split("."), returnCurrent = null, current = "", i = 0;
            if (!stringKey) return obj;
            returnCurrent = function(obj) {
                if (!obj) return null;
                else return obj[current];
            };
            while(i < parts.length){
                current = parts[i];
                obj = returnCurrent(obj);
                i++;
            }
            if (typeof obj !== "undefined") return obj;
            else return null;
        }
    };
    mixitup.h = h;
    /**
     * The Base class adds instance methods to all other extensible MixItUp classes,
     * enabling the calling of any registered hooks.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Base = function() {};
    mixitup.Base.prototype = {
        constructor: mixitup.Base,
        /**
         * Calls any registered hooks for the provided action.
         *
         * @memberof    mixitup.Base
         * @private
         * @instance
         * @since       2.0.0
         * @param       {string}    actionName
         * @param       {Array<*>}  args
         * @return      {void}
         */ callActions: function(actionName, args) {
            var self = this, hooks = self.constructor.actions[actionName], extensionName = "";
            if (!hooks || h.isEmptyObject(hooks)) return;
            for(extensionName in hooks)hooks[extensionName].apply(self, args);
        },
        /**
         * Calls any registered hooks for the provided filter.
         *
         * @memberof    mixitup.Base
         * @private
         * @instance
         * @since       2.0.0
         * @param       {string}    filterName
         * @param       {*}         input
         * @param       {Array<*>}  args
         * @return      {*}
         */ callFilters: function(filterName, input, args) {
            var self = this, hooks = self.constructor.filters[filterName], output = input, extensionName = "";
            if (!hooks || h.isEmptyObject(hooks)) return output;
            args = args || [];
            for(extensionName in hooks){
                args = h.arrayFromList(args);
                args.unshift(output);
                output = hooks[extensionName].apply(self, args);
            }
            return output;
        }
    };
    /**
     * The BaseStatic class holds a set of static methods which are then added to all other
     * extensible MixItUp classes as a means of integrating extensions via the addition of new
     * methods and/or actions and hooks.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.BaseStatic = function() {
        this.actions = {};
        this.filters = {};
        /**
         * Performs a shallow extend on the class's prototype, adding one or more new members to
         * the class in a single operation.
         *
         * @memberof    mixitup.BaseStatic
         * @public
         * @static
         * @since       2.1.0
         * @param       {object} extension
         * @return      {void}
         */ this.extend = function(extension) {
            h.extend(this.prototype, extension);
        };
        /**
         * Registers a function to be called on the action hook of the provided name.
         *
         * @memberof    mixitup.BaseStatic
         * @public
         * @static
         * @since       2.1.0
         * @param       {string}    hookName
         * @param       {string}    extensionName
         * @param       {function}  func
         * @return      {void}
         */ this.registerAction = function(hookName, extensionName, func) {
            (this.actions[hookName] = this.actions[hookName] || {})[extensionName] = func;
        };
        /**
         * Registers a function to be called on the filter of the provided name.
         *
         * @memberof    mixitup.BaseStatic
         * @public
         * @static
         * @since       2.1.0
         * @param       {string}    hookName
         * @param       {string}    extensionName
         * @param       {function}  func
         * @return      {void}
         */ this.registerFilter = function(hookName, extensionName, func) {
            (this.filters[hookName] = this.filters[hookName] || {})[extensionName] = func;
        };
    };
    /**
     * The `mixitup.Features` class performs all feature and CSS prefix detection
     * neccessary for MixItUp to function correctly, as well as storing various
     * string and array constants. All feature decection is on evaluation of the
     * library and stored in a singleton instance for use by other internal classes.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Features = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.boxSizingPrefix = "";
        this.transformPrefix = "";
        this.transitionPrefix = "";
        this.boxSizingPrefix = "";
        this.transformProp = "";
        this.transformRule = "";
        this.transitionProp = "";
        this.perspectiveProp = "";
        this.perspectiveOriginProp = "";
        this.has = new mixitup.Has();
        this.canary = null;
        this.BOX_SIZING_PROP = "boxSizing";
        this.TRANSITION_PROP = "transition";
        this.TRANSFORM_PROP = "transform";
        this.PERSPECTIVE_PROP = "perspective";
        this.PERSPECTIVE_ORIGIN_PROP = "perspectiveOrigin";
        this.VENDORS = [
            "Webkit",
            "moz",
            "O",
            "ms"
        ];
        this.TWEENABLE = [
            "opacity",
            "width",
            "height",
            "marginRight",
            "marginBottom",
            "x",
            "y",
            "scale",
            "translateX",
            "translateY",
            "translateZ",
            "rotateX",
            "rotateY",
            "rotateZ"
        ];
        this.callActions("afterConstruct");
    };
    mixitup.BaseStatic.call(mixitup.Features);
    mixitup.Features.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Features.prototype, /** @lends mixitup.Features */ {
        constructor: mixitup.Features,
        /**
         * @private
         * @return  {void}
         */ init: function() {
            var self = this;
            self.callActions("beforeInit", arguments);
            self.canary = document.createElement("div");
            self.setPrefixes();
            self.runTests();
            self.callActions("beforeInit", arguments);
        },
        /**
         * @private
         * @return  {void}
         */ runTests: function() {
            var self = this;
            self.callActions("beforeRunTests", arguments);
            self.has.promises = typeof window1.Promise === "function";
            self.has.transitions = self.transitionPrefix !== "unsupported";
            self.callActions("afterRunTests", arguments);
            h.freeze(self.has);
        },
        /**
         * @private
         * @return  {void}
         */ setPrefixes: function() {
            var self = this;
            self.callActions("beforeSetPrefixes", arguments);
            self.transitionPrefix = h.getPrefix(self.canary, "Transition", self.VENDORS);
            self.transformPrefix = h.getPrefix(self.canary, "Transform", self.VENDORS);
            self.boxSizingPrefix = h.getPrefix(self.canary, "BoxSizing", self.VENDORS);
            self.boxSizingProp = self.boxSizingPrefix ? self.boxSizingPrefix + h.pascalCase(self.BOX_SIZING_PROP) : self.BOX_SIZING_PROP;
            self.transitionProp = self.transitionPrefix ? self.transitionPrefix + h.pascalCase(self.TRANSITION_PROP) : self.TRANSITION_PROP;
            self.transformProp = self.transformPrefix ? self.transformPrefix + h.pascalCase(self.TRANSFORM_PROP) : self.TRANSFORM_PROP;
            self.transformRule = self.transformPrefix ? "-" + self.transformPrefix + "-" + self.TRANSFORM_PROP : self.TRANSFORM_PROP;
            self.perspectiveProp = self.transformPrefix ? self.transformPrefix + h.pascalCase(self.PERSPECTIVE_PROP) : self.PERSPECTIVE_PROP;
            self.perspectiveOriginProp = self.transformPrefix ? self.transformPrefix + h.pascalCase(self.PERSPECTIVE_ORIGIN_PROP) : self.PERSPECTIVE_ORIGIN_PROP;
            self.callActions("afterSetPrefixes", arguments);
        }
    });
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Has = function() {
        this.transitions = false;
        this.promises = false;
        h.seal(this);
    };
    // Assign a singleton instance to `mixitup.features` and initialise:
    mixitup.features = new mixitup.Features();
    mixitup.features.init();
    /**
     * A group of properties defining the mixer's animation and effects settings.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        animation
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigAnimation = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not animation should be enabled for the MixItUp instance.
         * If `false`, all operations will occur instantly and syncronously, although callback
         * functions and any returned promises will still be fulfilled.
         *
         * @example <caption>Example: Create a mixer with all animations disabled</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         enable: false
         *     }
         * });
         *
         * @name        enable
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.enable = true;
        /**
         * A string of one or more space-seperated properties to which transitions will be
         * applied for all filtering animations.
         *
         * Properties can be listed any order or combination, although they will be applied in a specific
         * predefined order to produce consistent results.
         *
         * To learn more about available effects, experiment with our <a href="https://www.kunkalabs.com/mixitup/">
         * sandbox demo</a> and try out the "Export config" button in the Animation options drop down.
         *
         * @example <caption>Example: Apply "fade" and "translateZ" effects to all animations</caption>
         * // As targets are filtered in and out, they will fade between
         * // opacity 1 and 0 and transform between translateZ(-100px) and
         * // translateZ(0).
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade translateZ(-100px)'
         *     }
         * });
         *
         * @name        effects
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     'fade scale'
         */ this.effects = "fade scale";
        /**
         * A string of one or more space-seperated effects to be applied only to filter-in
         * animations, overriding `config.animation.effects` if set.
         *
         * @example <caption>Example: Apply downwards vertical translate to targets being filtered in</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effectsIn: 'fade translateY(-100%)'
         *     }
         * });
         *
         * @name        effectsIn
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     ''
         */ this.effectsIn = "";
        /**
         * A string of one or more space-seperated effects to be applied only to filter-out
         * animations, overriding `config.animation.effects` if set.
         *
         * @example <caption>Example: Apply upwards vertical translate to targets being filtered out</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effectsOut: 'fade translateY(-100%)'
         *     }
         * });
         *
         * @name        effectsOut
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     ''
         */ this.effectsOut = "";
        /**
         * An integer dictating the duration of all MixItUp animations in milliseconds, not
         * including any additional delay apllied via the `'stagger'` effect.
         *
         * @example <caption>Example: Apply an animation duration of 200ms to all mixitup animations</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         duration: 200
         *     }
         * });
         *
         * @name        duration
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {number}
         * @default     600
         */ this.duration = 600;
        /**
         * A valid CSS3 transition-timing function or shorthand. For a full list of accepted
         * values, visit <a href="http://easings.net" target="_blank">easings.net</a>.
         *
         * @example <caption>Example 1: Apply "ease-in-out" easing to all animations</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         easing: 'ease-in-out'
         *     }
         * });
         *
         * @example <caption>Example 2: Apply a custom "cubic-bezier" easing function to all animations</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)'
         *     }
         * });
         *
         * @name        easing
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     'ease'
         */ this.easing = "ease";
        /**
         * A boolean dictating whether or not to apply perspective to the MixItUp container
         * during animations. By default, perspective is always applied and creates the
         * illusion of three-dimensional space for effects such as `translateZ`, `rotateX`,
         * and `rotateY`.
         *
         * You may wish to disable this and define your own perspective settings via CSS.
         *
         * @example <caption>Example: Prevent perspective from being applied to any 3D transforms</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         applyPerspective: false
         *     }
         * });
         *
         * @name        applyPerspective
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {bolean}
         * @default     true
         */ this.applyPerspective = true;
        /**
         * The perspective distance value to be applied to the container during animations,
         * affecting any 3D-transform-based effects.
         *
         * @example <caption>Example: Set a perspective distance of 2000px</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'rotateY(-25deg)',
         *         perspectiveDistance: '2000px'
         *     }
         * });
         *
         * @name        perspectiveDistance
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     '3000px'
         */ this.perspectiveDistance = "3000px";
        /**
         * The perspective-origin value to be applied to the container during animations,
         * affecting any 3D-transform-based effects.
         *
         * @example <caption>Example: Set a perspective origin in the top-right of the container</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'transateZ(-200px)',
         *         perspectiveOrigin: '100% 0'
         *     }
         * });
         *
         * @name        perspectiveOrigin
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     '50% 50%'
         */ this.perspectiveOrigin = "50% 50%";
        /**
         * A boolean dictating whether or not to enable the queuing of operations.
         *
         * If `true` (default), and a control is clicked or an API call is made while another
         * operation is progress, the operation will go into the queue and will be automatically exectuted
         * when the previous operaitons is finished.
         *
         * If `false`, any requested operations will be ignored, and the `onMixBusy` callback and `mixBusy`
         * event will be fired. If `debug.showWarnings` is enabled, a console warning will also occur.
         *
         * @example <caption>Example: Disable queuing</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         queue: false
         *     }
         * });
         *
         * @name        queue
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.queue = true;
        /**
         * An integer dictacting the maximum number of operations allowed in the queue at
         * any time, when queuing is enabled.
         *
         * @example <caption>Example: Allow a maximum of 5 operations in the queue at any time</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         queueLimit: 5
         *     }
         * });
         *
         * @name        queueLimit
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {number}
         * @default     3
         */ this.queueLimit = 3;
        /**
         * A boolean dictating whether or not to transition the height and width of the
         * container as elements are filtered in and out. If disabled, the container height
         * will change abruptly.
         *
         * It may be desirable to disable this on mobile devices as the CSS `height` and
         * `width` properties do not receive GPU-acceleration and can therefore cause stuttering.
         *
         * @example <caption>Example 1: Disable the transitioning of the container height and/or width</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         animateResizeContainer: false
         *     }
         * });
         *
         * @example <caption>Example 2: Disable the transitioning of the container height and/or width for mobile devices only</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         animateResizeContainer: myFeatureTests.isMobile ? false : true
         *     }
         * });
         *
         * @name        animateResizeContainer
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.animateResizeContainer = true;
        /**
         * A boolean dictating whether or not to transition the height and width of target
         * elements as they change throughout the course of an animation.
         *
         * This is often a must for flex-box grid layouts where the size of target elements may change
         * depending on final their position in relation to their siblings, or for `.changeLayout()`
         * operations where the size of targets change between layouts.
         *
         * NB: This feature requires additional calculations and manipulation to non-hardware-accelerated
         * properties which may adversely affect performance on slower devices, and is therefore
         * disabled by default.
         *
         * @example <caption>Example: Enable the transitioning of target widths and heights</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         animateResizeTargets: true
         *     }
         * });
         *
         * @name        animateResizeTargets
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.animateResizeTargets = false;
        /**
         * A custom function used to manipulate the order in which the stagger delay is
         * incremented when using the ‘stagger’ effect.
         *
         * When using the 'stagger' effect, the delay applied to each target element is incremented
         * based on its index. You may create a custom function to manipulate the order in which the
         * delay is incremented and create engaging non-linear stagger effects.
         *
         * The function receives the index of the target element as a parameter, and must
         * return an integer which serves as the multiplier for the stagger delay.
         *
         * @example <caption>Example 1: Stagger target elements by column in a 3-column grid</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade stagger(100ms)',
         *         staggerSequence: function(i) {
         *             return i % 3;
         *         }
         *     }
         * });
         *
         * @example <caption>Example 2: Using an algorithm to produce a more complex sequence</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade stagger(100ms)',
         *         staggerSequence: function(i) {
         *             return (2*i) - (5*((i/3) - ((1/3) * (i%3))));
         *         }
         *     }
         * });
         *
         * @name        staggerSequence
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {function}
         * @default     null
         */ this.staggerSequence = null;
        /**
         * A boolean dictating whether or not to reverse the direction of `translate`
         * and `rotate` transforms for elements being filtered out.
         *
         * It can be used to create carousel-like animations where elements enter and exit
         * from opposite directions. If enabled, the effect `translateX(-100%)` for elements
         * being filtered in would become `translateX(100%)` for targets being filtered out.
         *
         * This functionality can also be achieved by providing seperate effects
         * strings for `config.animation.effectsIn` and `config.animation.effectsOut`.
         *
         * @example <caption>Example: Reverse the desired direction on any translate/rotate effect for targets being filtered out</caption>
         * // Elements being filtered in will be translated from '100%' to '0' while
         * // elements being filtered out will be translated from 0 to '-100%'
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade translateX(100%)',
         *         reverseOut: true,
         *         nudge: false // Disable nudging to create a carousel-like effect
         *     }
         * });
         *
         * @name        reverseOut
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.reverseOut = false;
        /**
         * A boolean dictating whether or not to "nudge" the animation path of targets
         * when they are being filtered in and out simulatenously.
         *
         * This has been the default behavior of MixItUp since version 1, but it
         * may be desirable to disable this effect when filtering directly from
         * one exclusive set of targets to a different exclusive set of targets,
         * to create a carousel-like effect, or a generally more subtle animation.
         *
         * @example <caption>Example: Disable the "nudging" of targets being filtered in and out simulatenously</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         nudge: false
         *     }
         * });
         *
         * @name        nudge
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.nudge = true;
        /**
         * A boolean dictating whether or not to clamp the height of the container while MixItUp's
         * geometry tests are carried out before an operation.
         *
         * To prevent scroll-bar flicker, clamping is turned on by default. But in the case where the
         * height of the container might affect its vertical positioning in the viewport
         * (e.g. a vertically-centered container), this should be turned off to ensure accurate
         * test results and a smooth animation.
         *
         * @example <caption>Example: Disable container height-clamping</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         clampHeight: false
         *     }
         * });
         *
         * @name        clampHeight
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.clampHeight = true;
        /**
         * A boolean dictating whether or not to clamp the width of the container while MixItUp's
         * geometry tests are carried out before an operation.
         *
         * To prevent scroll-bar flicker, clamping is turned on by default. But in the case where the
         * width of the container might affect its horitzontal positioning in the viewport
         * (e.g. a horizontall-centered container), this should be turned off to ensure accurate
         * test results and a smooth animation.
         *
         * @example <caption>Example: Disable container width-clamping</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         clampWidth: false
         *     }
         * });
         *
         * @name        clampWidth
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.clampWidth = true;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigAnimation);
    mixitup.ConfigAnimation.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigAnimation.prototype.constructor = mixitup.ConfigAnimation;
    /**
     * A group of properties relating to the behavior of the Mixer.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        behavior
     * @namespace
     * @public
     * @since       3.1.12
     */ mixitup.ConfigBehavior = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether to allow "live" sorting of the mixer.
         *
         * Because of the expensive nature of sorting, MixItUp makes use of several
         * internal optimizations to skip redundant sorting operations, such as when
         * the newly requested sort command is the same as the active one. The caveat
         * to this optimization is that "live" edits to the value of a target's sorting
         * attribute will be ignored when requesting a re-sort by the same attribute.
         *
         * By setting to `behavior.liveSort` to `true`, the mixer will always re-sort
         * regardless of whether or not the sorting attribute and order have changed.
         *
         * @example <caption>Example: Enabling `liveSort` to allow for re-sorting</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     behavior: {
         *         liveSort: true
         *     },
         *     load: {
         *         sort: 'edited:desc'
         *     }
         * });
         *
         * var target = containerEl.children[3];
         *
         * console.log(target.getAttribute('data-edited')); // '2015-04-24'
         *
         * target.setAttribute('data-edited', '2017-08-10'); // Update the target's edited date
         *
         * mixer.sort('edited:desc')
         *     .then(function(state) {
         *         // The target is now at the top of the list
         *
         *         console.log(state.targets[0] === target); // true
         *     });
         *
         * @name        liveSort
         * @memberof    mixitup.Config.behavior
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.liveSort = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigBehavior);
    mixitup.ConfigBehavior.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigBehavior.prototype.constructor = mixitup.ConfigBehavior;
    /**
     * A group of optional callback functions to be invoked at various
     * points within the lifecycle of a mixer operation.
     *
     * Each function is analogous to an event of the same name triggered from the
     * container element, and is invoked immediately after it.
     *
     * All callback functions receive the current `state` object as their first
     * argument, as well as other more specific arguments described below.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        callbacks
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigCallbacks = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A callback function invoked immediately after any MixItUp operation is requested
         * and before animations have begun.
         *
         * A second `futureState` argument is passed to the function which represents the final
         * state of the mixer once the requested operation has completed.
         *
         * @example <caption>Example: Adding an `onMixStart` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixStart: function(state, futureState) {
         *              console.log('Starting operation...');
         *         }
         *     }
         * });
         *
         * @name        onMixStart
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixStart = null;
        /**
         * A callback function invoked when a MixItUp operation is requested while another
         * operation is in progress, and the animation queue is full, or queueing
         * is disabled.
         *
         * @example <caption>Example: Adding an `onMixBusy` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixBusy: function(state) {
         *              console.log('Mixer busy');
         *         }
         *     }
         * });
         *
         * @name        onMixBusy
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixBusy = null;
        /**
         * A callback function invoked after any MixItUp operation has completed, and the
         * state has been updated.
         *
         * @example <caption>Example: Adding an `onMixEnd` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixEnd: function(state) {
         *              console.log('Operation complete');
         *         }
         *     }
         * });
         *
         * @name        onMixEnd
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixEnd = null;
        /**
         * A callback function invoked whenever an operation "fails", i.e. no targets
         * could be found matching the requested filter.
         *
         * @example <caption>Example: Adding an `onMixFail` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixFail: function(state) {
         *              console.log('No items could be found matching the requested filter');
         *         }
         *     }
         * });
         *
         * @name        onMixFail
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixFail = null;
        /**
         * A callback function invoked whenever a MixItUp control is clicked, and before its
         * respective operation is requested.
         *
         * The clicked element is assigned to the `this` keyword within the function. The original
         * click event is passed to the function as the second argument, which can be useful if
         * using `<a>` tags as controls where the default behavior needs to be prevented.
         *
         * Returning `false` from the callback will prevent the control click from triggering
         * an operation.
         *
         * @example <caption>Example 1: Adding an `onMixClick` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixClick: function(state, originalEvent) {
         *              console.log('The control "' + this.innerText + '" was clicked');
         *         }
         *     }
         * });
         *
         * @example <caption>Example 2: Using `onMixClick` to manipulate the original click event</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixClick: function(state, originalEvent) {
         *              // Prevent original click event from bubbling up:
         *              originalEvent.stopPropagation();
         *
         *              // Prevent default behavior of clicked element:
         *              originalEvent.preventDefault();
         *         }
         *     }
         * });
         *
         * @example <caption>Example 3: Using `onMixClick` to conditionally cancel operations</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixClick: function(state, originalEvent) {
         *              // Perform some conditional check:
         *
         *              if (myApp.isLoading) {
         *                  // By returning false, we can prevent the control click from triggering an operation.
         *
         *                  return false;
         *              }
         *         }
         *     }
         * });
         *
         * @name        onMixClick
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixClick = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigCallbacks);
    mixitup.ConfigCallbacks.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigCallbacks.prototype.constructor = mixitup.ConfigCallbacks;
    /**
     * A group of properties relating to clickable control elements.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        controls
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigControls = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not controls should be enabled for the mixer instance.
         *
         * If `true` (default behavior), MixItUp will search the DOM for any clickable elements with
         * `data-filter`, `data-sort` or `data-toggle` attributes, and bind them for click events.
         *
         * If `false`, no click handlers will be bound, and all functionality must therefore be performed
         * via the mixer's API methods.
         *
         * If you do not intend to use the default controls, setting this property to `false` will
         * marginally improve the startup time of your mixer instance, and will also prevent any other active
         * mixer instances in the DOM which are bound to controls from controlling the instance.
         *
         * @example <caption>Example: Disabling controls</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         enable: false
         *     }
         * });
         *
         * // With the default controls disabled, we can only control
         * // the mixer via its API methods, e.g.:
         *
         * mixer.filter('.cat-1');
         *
         * @name        enable
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.enable = true;
        /**
         * A boolean dictating whether or not to use event delegation when binding click events
         * to the default controls.
         *
         * If `false` (default behavior), each control button in the DOM will be found and
         * individually bound when a mixer is instantiated, with their corresponding actions
         * cached for performance.
         *
         * If `true`, a single click handler will be applied to the `window` (or container element - see
         * `config.controls.scope`), and any click events triggered by elements with `data-filter`,
         * `data-sort` or `data-toggle` attributes present will be handled as they propagate upwards.
         *
         * If you require a user interface where control buttons may be added, removed, or changed during the
         * lifetime of a mixer, `controls.live` should be set to `true`. There is a marginal but unavoidable
         * performance deficit when using live controls, as the value of each control button must be read
         * from the DOM in real time once the click event has propagated.
         *
         * @example <caption>Example: Setting live controls</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         live: true
         *     }
         * });
         *
         * // Control buttons can now be added, remove and changed without breaking
         * // the mixer's UI
         *
         * @name        live
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.live = false;
        /**
         * A string dictating the "scope" to use when binding or querying the default controls. The available
         * values are `'global'` or `'local'`.
         *
         * When set to `'global'` (default behavior), MixItUp will query the entire document for control buttons
         * to bind, or delegate click events from (see `config.controls.live`).
         *
         * When set to `'local'`, MixItUp will only query (or bind click events to) its own container element.
         * This may be desireable if you require multiple active mixer instances within the same document, with
         * controls that would otherwise intefere with each other if scoped globally.
         *
         * Conversely, if you wish to control multiple instances with a single UI, you would create one
         * set of controls and keep the controls scope of each mixer set to `global`.
         *
         * @example <caption>Example: Setting 'local' scoped controls</caption>
         * var mixerOne = mixitup(containerOne, {
         *     controls: {
         *         scope: 'local'
         *     }
         * });
         *
         * var mixerTwo = mixitup(containerTwo, {
         *     controls: {
         *         scope: 'local'
         *     }
         * });
         *
         * // Both mixers can now exist within the same document with
         * // isolated controls placed within their container elements.
         *
         * @name        scope
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {string}
         * @default     'global'
         */ this.scope = "global"; // enum: ['local' ,'global']
        /**
         * A string dictating the type of logic to apply when concatenating the filter selectors of
         * active toggle buttons (i.e. any clickable element with a `data-toggle` attribute).
         *
         * If set to `'or'` (default behavior), selectors will be concatenated together as
         * a comma-seperated list. For example:
         *
         * `'.cat-1, .cat-2'` (shows any elements matching `'.cat-1'` OR `'.cat-2'`)
         *
         * If set to `'and'`, selectors will be directly concatenated together. For example:
         *
         * `'.cat-1.cat-2'` (shows any elements which match both `'.cat-1'` AND `'.cat-2'`)
         *
         * @example <caption>Example: Setting "and" toggle logic</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         toggleLogic: 'and'
         *     }
         * });
         *
         * @name        toggleLogic
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {string}
         * @default     'or'
         */ this.toggleLogic = "or"; // enum: ['or', 'and']
        /**
         * A string dictating the filter behavior when all toggles are inactive.
         *
         * When set to `'all'` (default behavior), *all* targets will be shown by default
         * when no toggles are active, or at the moment all active toggles are toggled off.
         *
         * When set to `'none'`, no targets will be shown by default when no toggles are
         * active, or at the moment all active toggles are toggled off.
         *
         * @example <caption>Example 1: Setting the default toggle behavior to `'all'`</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         toggleDefault: 'all'
         *     }
         * });
         *
         * mixer.toggleOn('.cat-2')
         *     .then(function() {
         *         // Deactivate all active toggles
         *
         *         return mixer.toggleOff('.cat-2')
         *     })
         *     .then(function(state) {
         *          console.log(state.activeFilter.selector); // 'all'
         *          console.log(state.totalShow); // 12
         *     });
         *
         * @example <caption>Example 2: Setting the default toggle behavior to `'none'`</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         toggleDefault: 'none'
         *     }
         * });
         *
         * mixer.toggleOn('.cat-2')
         *     .then(function() {
         *         // Deactivate all active toggles
         *
         *         return mixer.toggleOff('.cat-2')
         *     })
         *     .then(function(state) {
         *          console.log(state.activeFilter.selector); // 'none'
         *          console.log(state.totalShow); // 0
         *     });
         *
         * @name        toggleDefault
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {string}
         * @default     'all'
         */ this.toggleDefault = "all"; // enum: ['all', 'none']
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigControls);
    mixitup.ConfigControls.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigControls.prototype.constructor = mixitup.ConfigControls;
    /**
     * A group of properties defining the output and structure of class names programmatically
     * added to controls and containers to reflect the state of the mixer.
     *
     * Most commonly, class names are added to controls by MixItUp to indicate that
     * the control is active so that it can be styled accordingly - `'mixitup-control-active'` by default.
     *
     * Using a "BEM" like structure, each classname is broken into the three parts:
     * a block namespace (`'mixitup'`), an element name (e.g. `'control'`), and an optional modifier
     * name (e.g. `'active'`) reflecting the state of the element.
     *
     * By default, each part of the classname is concatenated together using single hyphens as
     * delineators, but this can be easily customised to match the naming convention and style of
     * your project.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        classNames
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigClassNames = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * The "block" portion, or top-level namespace added to the start of any class names created by MixItUp.
         *
         * @example <caption>Example 1: changing the `config.classNames.block` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio'
         *     }
         * });
         *
         * // Active control output: "portfolio-control-active"
         *
         * @example <caption>Example 2: Removing `config.classNames.block`</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: ''
         *     }
         * });
         *
         * // Active control output: "control-active"
         *
         * @name        block
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'mixitup'
         */ this.block = "mixitup";
        /**
         * The "element" portion of the class name added to container.
         *
         * @name        elementContainer
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'container'
         */ this.elementContainer = "container";
        /**
         * The "element" portion of the class name added to filter controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementFilter` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementFilter: 'filter'
         *     }
         * });
         *
         * // Active filter output: "mixitup-filter-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementFilter` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementFilter: 'filter'
         *     }
         * });
         *
         * // Active filter output: "portfolio-filter-active"
         *
         * @name        elementFilter
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementFilter = "control";
        /**
         * The "element" portion of the class name added to sort controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementSort` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementSort: 'sort'
         *     }
         * });
         *
         * // Active sort output: "mixitup-sort-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementSort` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementSort: 'sort'
         *     }
         * });
         *
         * // Active sort output: "portfolio-sort-active"
         *
         * @name        elementSort
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementSort = "control";
        /**
         * The "element" portion of the class name added to multimix controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementMultimix` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementMultimix: 'multimix'
         *     }
         * });
         *
         * // Active multimix output: "mixitup-multimix-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementMultimix` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementSort: 'multimix'
         *     }
         * });
         *
         * // Active multimix output: "portfolio-multimix-active"
         *
         * @name        elementMultimix
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementMultimix = "control";
        /**
         * The "element" portion of the class name added to toggle controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementToggle` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementToggle: 'toggle'
         *     }
         * });
         *
         * // Active toggle output: "mixitup-toggle-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementToggle` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementToggle: 'toggle'
         *     }
         * });
         *
         * // Active toggle output: "portfolio-toggle-active"
         *
         * @name        elementToggle
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementToggle = "control";
        /**
         * The "modifier" portion of the class name added to active controls.
         * @name        modifierActive
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'active'
         */ this.modifierActive = "active";
        /**
         * The "modifier" portion of the class name added to disabled controls.
         *
         * @name        modifierDisabled
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'disabled'
         */ this.modifierDisabled = "disabled";
        /**
         * The "modifier" portion of the class name added to the container when in a "failed" state.
         *
         * @name        modifierFailed
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'failed'
         */ this.modifierFailed = "failed";
        /**
         * The delineator used between the "block" and "element" portions of any class name added by MixItUp.
         *
         * If the block portion is ommited by setting it to an empty string, no delineator will be added.
         *
         * @example <caption>Example: changing the delineator to match BEM convention</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         delineatorElement: '__'
         *     }
         * });
         *
         * // example active control output: "mixitup__control-active"
         *
         * @name        delineatorElement
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     '-'
         */ this.delineatorElement = "-";
        /**
         * The delineator used between the "element" and "modifier" portions of any class name added by MixItUp.
         *
         * If the element portion is ommited by setting it to an empty string, no delineator will be added.
         *
         * @example <caption>Example: changing both delineators to match BEM convention</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         delineatorElement: '__'
         *         delineatorModifier: '--'
         *     }
         * });
         *
         * // Active control output: "mixitup__control--active"
         *
         * @name        delineatorModifier
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     '-'
         */ this.delineatorModifier = "-";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigClassNames);
    mixitup.ConfigClassNames.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigClassNames.prototype.constructor = mixitup.ConfigClassNames;
    /**
     * A group of properties relating to MixItUp's dataset API.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        data
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A string specifying the name of the key containing your data model's unique
         * identifier (UID). To use the dataset API, a UID key must be specified and
         * be present and unique on all objects in the dataset you provide to MixItUp.
         *
         * For example, if your dataset is made up of MongoDB documents, the UID
         * key would be `'id'` or `'_id'`.
         *
         * @example <caption>Example: Setting the UID to `'id'`</caption>
         * var mixer = mixitup(containerEl, {
         *     data: {
         *         uidKey: 'id'
         *     }
         * });
         *
         * @name        uidKey
         * @memberof    mixitup.Config.data
         * @instance
         * @type        {string}
         * @default     ''
         */ this.uidKey = "";
        /**
         * A boolean dictating whether or not MixItUp should "dirty check" each object in
         * your dataset for changes whenever `.dataset()` is called, and re-render any targets
         * for which a change is found.
         *
         * Depending on the complexity of your data model, dirty checking can be expensive
         * and is therefore disabled by default.
         *
         * NB: For changes to be detected, a new immutable instance of the edited model must be
         * provided to mixitup, rather than manipulating properties on the existing instance.
         * If your changes are a result of a DB write and read, you will most likely be calling
         * `.dataset()` with a clean set of objects each time, so this will not be an issue.
         *
         * @example <caption>Example: Enabling dirty checking</caption>
         *
         * var myDataset = [
         *     {
         *         id: 0,
         *         title: "Blog Post Title 0"
         *         ...
         *     },
         *     {
         *         id: 1,
         *         title: "Blog Post Title 1"
         *         ...
         *     }
         * ];
         *
         * // Instantiate a mixer with a pre-loaded dataset, and a target renderer
         * // function defined
         *
         * var mixer = mixitup(containerEl, {
         *     data: {
         *         uidKey: 'id',
         *         dirtyCheck: true
         *     },
         *     load: {
         *         dataset: myDataset
         *     },
         *     render: {
         *         target: function() { ... }
         *     }
         * });
         *
         * // For illustration, we will clone and edit the second object in the dataset.
         * // NB: this would typically be done server-side in response to a DB update,
         * and then re-queried via an API.
         *
         * myDataset[1] = Object.assign({}, myDataset[1]);
         *
         * myDataset[1].title = 'Blog Post Title 11';
         *
         * mixer.dataset(myDataset)
         *    .then(function() {
         *        // the target with ID "1", will be re-rendered reflecting its new title
         *    });
         *
         * @name        dirtyCheck
         * @memberof    mixitup.Config.data
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.dirtyCheck = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigData);
    mixitup.ConfigData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigData.prototype.constructor = mixitup.ConfigData;
    /**
     * A group of properties allowing the toggling of various debug features.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        debug
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigDebug = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not the mixer instance returned by the
         * `mixitup()` factory function should expose private properties and methods.
         *
         * By default, mixer instances only expose their public API, but enabling
         * debug mode will give you access to various mixer internals which may aid
         * in debugging, or the authoring of extensions.
         *
         * @example <caption>Example: Enabling debug mode</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     debug: {
         *         enable: true
         *     }
         * });
         *
         * // Private properties and methods will now be visible on the mixer instance:
         *
         * console.log(mixer);
         *
         * @name        enable
         * @memberof    mixitup.Config.debug
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.enable = false;
        /**
         * A boolean dictating whether or not warnings should be shown when various
         * common gotchas occur.
         *
         * Warnings are intended to provide insights during development when something
         * occurs that is not a fatal, but may indicate an issue with your integration,
         * and are therefore turned on by default. However, you may wish to disable
         * them in production.
         *
         * @example <caption>Example 1: Disabling warnings</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     debug: {
         *         showWarnings: false
         *     }
         * });
         *
         * @example <caption>Example 2: Disabling warnings based on environment</caption>
         *
         * var showWarnings = myAppConfig.environment === 'development' ? true : false;
         *
         * var mixer = mixitup(containerEl, {
         *     debug: {
         *         showWarnings: showWarnings
         *     }
         * });
         *
         * @name        showWarnings
         * @memberof    mixitup.Config.debug
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.showWarnings = true;
        /**
         * Used for server-side testing only.
         *
         * @private
         * @name        fauxAsync
         * @memberof    mixitup.Config.debug
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.fauxAsync = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigDebug);
    mixitup.ConfigDebug.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigDebug.prototype.constructor = mixitup.ConfigDebug;
    /**
     * A group of properties relating to the layout of the container.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        layout
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigLayout = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not mixitup should query all descendants
         * of the container for targets, or only immediate children.
         *
         * By default, mixitup will query all descendants matching the
         * `selectors.target` selector when indexing targets upon instantiation.
         * This allows for targets to be nested inside a sub-container which is
         * useful when ring-fencing targets from locally scoped controls in your
         * markup (see `controls.scope`).
         *
         * However, if you are building a more complex UI requiring the nesting
         * of mixers within mixers, you will most likely want to limit targets to
         * immediate children of the container by setting this property to `false`.
         *
         * @example <caption>Example: Restricting targets to immediate children</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         allowNestedTargets: false
         *     }
         * });
         *
         * @name        allowNestedTargets
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.allowNestedTargets = true;
        /**
         * A string specifying an optional class name to apply to the container when in
         * its default state.
         *
         * By changing this class name or adding a class name to the container via the
         * `.changeLayout()` API method, the CSS layout of the container can be changed,
         * and MixItUp will attemp to gracefully animate the container and its targets
         * between states.
         *
         * @example <caption>Example 1: Specifying a container class name</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         containerClassName: 'grid'
         *     }
         * });
         *
         * @example <caption>Example 2: Changing the default class name with `.changeLayout()`</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         containerClassName: 'grid'
         *     }
         * });
         *
         * mixer.changeLayout('list')
         *     .then(function(state) {
         *          console.log(state.activeContainerClass); // "list"
         *     });
         *
         * @name        containerClassName
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {string}
         * @default     ''
         */ this.containerClassName = "";
        /**
         * A reference to a non-target sibling element after which to insert targets
         * when there are no targets in the container.
         *
         * @example <caption>Example: Setting a `siblingBefore` reference element</caption>
         *
         * var addButton = containerEl.querySelector('button');
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         siblingBefore: addButton
         *     }
         * });
         *
         * @name        siblingBefore
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {HTMLElement}
         * @default     null
         */ this.siblingBefore = null;
        /**
         * A reference to a non-target sibling element before which to insert targets
         * when there are no targets in the container.
         *
         * @example <caption>Example: Setting an `siblingAfter` reference element</caption>
         *
         * var gap = containerEl.querySelector('.gap');
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         siblingAfter: gap
         *     }
         * });
         *
         * @name        siblingAfter
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {HTMLElement}
         * @default     null
         */ this.siblingAfter = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigLayout);
    mixitup.ConfigLayout.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigLayout.prototype.constructor = mixitup.ConfigLayout;
    /**
     * A group of properties defining the initial state of the mixer on load (instantiation).
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        load
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigLoad = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A string defining any filtering to be statically applied to the mixer on load.
         * As per the `.filter()` API, this can be any valid selector string, or the
         * values `'all'` or `'none'`.
         *
         * @example <caption>Example 1: Defining an initial filter selector to be applied on load</caption>
         *
         * // The mixer will show only those targets matching '.category-a' on load.
         *
         * var mixer = mixitup(containerEl, {
         *     load: {
         *         filter: '.category-a'
         *     }
         * });
         *
         * @example <caption>Example 2: Hiding all targets on load</caption>
         *
         * // The mixer will show hide all targets on load.
         *
         * var mixer = mixitup(containerEl, {
         *     load: {
         *         filter: 'none'
         *     }
         * });
         *
         * @name        filter
         * @memberof    mixitup.Config.load
         * @instance
         * @type        {string}
         * @default     'all'
         */ this.filter = "all";
        /**
         * A string defining any sorting to be statically applied to the mixer on load.
         * As per the `.sort()` API, this should be a valid "sort string" made up of
         * an attribute to sort by (or `'default'`) followed by an optional sorting
         * order, or the value `'random'`;
         *
         * @example <caption>Example: Defining sorting to be applied on load</caption>
         *
         * // The mixer will sort the container by the value of the `data-published-date`
         * // attribute, in descending order.
         *
         * var mixer = mixitup(containerEl, {
         *     load: {
         *         sort: 'published-date:desc'
         *     }
         * });
         *
         * @name        sort
         * @memberof    mixitup.Config.load
         * @instance
         * @type        {string}
         * @default     'default:asc'
         */ this.sort = "default:asc";
        /**
         * An array of objects representing the underlying data of any pre-rendered targets,
         * when using the `.dataset()` API.
         *
         * NB: If targets are pre-rendered when the mixer is instantiated, this must be set.
         *
         * @example <caption>Example: Defining the initial underyling dataset</caption>
         *
         * var myDataset = [
         *     {
         *         id: 0,
         *         title: "Blog Post Title 0",
         *         ...
         *     },
         *     {
         *         id: 1,
         *         title: "Blog Post Title 1",
         *         ...
         *     }
         * ];
         *
         * var mixer = mixitup(containerEl, {
         *     data: {
         *         uidKey: 'id'
         *     },
         *     load: {
         *         dataset: myDataset
         *     }
         * });
         *
         * @name        dataset
         * @memberof    mixitup.Config.load
         * @instance
         * @type        {Array.<object>}
         * @default     null
         */ this.dataset = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigLoad);
    mixitup.ConfigLoad.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigLoad.prototype.constructor = mixitup.ConfigLoad;
    /**
     * A group of properties defining the selectors used to query elements within a mixitup container.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        selectors
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigSelectors = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A selector string used to query and index target elements within the container.
         *
         * By default, the class selector `'.mix'` is used, but this can be changed to an
         * attribute or element selector to match the style of your project.
         *
         * @example <caption>Example 1: Changing the target selector</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     selectors: {
         *         target: '.portfolio-item'
         *     }
         * });
         *
         * @example <caption>Example 2: Using an attribute selector as a target selector</caption>
         *
         * // The mixer will search for any children with the attribute `data-ref="mix"`
         *
         * var mixer = mixitup(containerEl, {
         *     selectors: {
         *         target: '[data-ref="mix"]'
         *     }
         * });
         *
         * @name        target
         * @memberof    mixitup.Config.selectors
         * @instance
         * @type        {string}
         * @default     '.mix'
         */ this.target = ".mix";
        /**
         * A optional selector string used to add further specificity to the querying of control elements,
         * in addition to their mandatory data attribute (e.g. `data-filter`, `data-toggle`, `data-sort`).
         *
         * This can be used if other elements in your document must contain the above attributes
         * (e.g. for use in third-party scripts), and would otherwise interfere with MixItUp. Adding
         * an additional `control` selector of your choice allows MixItUp to restrict event handling
         * to only those elements matching the defined selector.
         *
         * @name        control
         * @memberof    mixitup.Config.selectors
         * @instance
         * @type        {string}
         * @default     ''
         *
         * @example <caption>Example 1: Adding a `selectors.control` selector</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     selectors: {
         *         control: '.mixitup-control'
         *     }
         * });
         *
         * // Will not be handled:
         * // <button data-filter=".category-a"></button>
         *
         * // Will be handled:
         * // <button class="mixitup-control" data-filter=".category-a"></button>
         */ this.control = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigSelectors);
    mixitup.ConfigSelectors.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigSelectors.prototype.constructor = mixitup.ConfigSelectors;
    /**
     * A group of optional render functions for creating and updating elements.
     *
     * All render functions receive a data object, and should return a valid HTML string.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        render
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigRender = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A function returning an HTML string representing a target element, or a reference to a
         * single DOM element.
         *
         * The function is invoked as part of the `.dataset()` API, whenever a new item is added
         * to the dataset, or an item in the dataset changes (if `dataset.dirtyCheck` is enabled).
         *
         * The function receives the relevant dataset item as its first parameter.
         *
         * @example <caption>Example 1: Using string concatenation</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: function(item) {
         *             return (
         *                 '&lt;div class="mix"&gt;' +
         *                     '&lt;h2&gt;' + item.title + '&lt;/h2&gt;' +
         *                 '&lt;/div&gt;'
         *             );
         *         }
         *     }
         * });
         *
         * @example <caption>Example 2: Using an ES2015 template literal</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: function(item) {
         *             return (
         *                 `&lt;div class="mix"&gt;
         *                     &lt;h2&gt;${item.title}&lt;/h2&gt;
         *                  &lt;/div&gt;`
         *             );
         *         }
         *     }
         * });
         *
         * @example <caption>Example 3: Using a Handlebars template</caption>
         *
         * var targetTemplate = Handlebars.compile('&lt;div class="mix"&gt;&lt;h2&gt;{{title}}&lt;/h2&gt;&lt;/div&gt;');
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: targetTemplate
         *     }
         * });
         *
         * @example <caption>Example 4: Returning a DOM element</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: function(item) {
         *              // Create a single element using your framework's built-in renderer
         *
         *              var el = ...
         *
         *              return el;
         *         }
         *     }
         * });
         *
         * @name        target
         * @memberof    mixitup.Config.render
         * @instance
         * @type        {function}
         * @default     'null'
         */ this.target = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigRender);
    mixitup.ConfigRender.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigRender.prototype.constructor = mixitup.ConfigRender;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.ConfigTemplates = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigTemplates);
    mixitup.ConfigTemplates.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigTemplates.prototype.constructor = mixitup.ConfigTemplates;
    /**
     * `mixitup.Config` is an interface used for customising the functionality of a
     * mixer instance. It is organised into several semantically distinct sub-objects,
     * each one pertaining to a particular aspect of MixItUp functionality.
     *
     * An object literal containing any or all of the available properies,
     * known as the "configuration object", can be passed as the second parameter to
     * the `mixitup` factory function when creating a mixer instance to customise its
     * functionality as needed.
     *
     * If no configuration object is passed, the mixer instance will take on the default
     * configuration values detailed below.
     *
     * @example <caption>Example 1: Creating and passing the configuration object</caption>
     * // Create a configuration object with desired values
     *
     * var config = {
     *     animation: {
     *         enable: false
     *     },
     *     selectors: {
     *         target: '.item'
     *     }
     * };
     *
     * // Pass the configuration object to the mixitup factory function
     *
     * var mixer = mixitup(containerEl, config);
     *
     * @example <caption>Example 2: Passing the configuration object inline</caption>
     * // Typically, the configuration object is passed inline for brevity.
     *
     * var mixer = mixitup(containerEl, {
     *     controls: {
     *         live: true,
     *         toggleLogic: 'and'
     *     }
     * });
     *
     *
     * @constructor
     * @memberof    mixitup
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.Config = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.animation = new mixitup.ConfigAnimation();
        this.behavior = new mixitup.ConfigBehavior();
        this.callbacks = new mixitup.ConfigCallbacks();
        this.controls = new mixitup.ConfigControls();
        this.classNames = new mixitup.ConfigClassNames();
        this.data = new mixitup.ConfigData();
        this.debug = new mixitup.ConfigDebug();
        this.layout = new mixitup.ConfigLayout();
        this.load = new mixitup.ConfigLoad();
        this.selectors = new mixitup.ConfigSelectors();
        this.render = new mixitup.ConfigRender();
        this.templates = new mixitup.ConfigTemplates();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Config);
    mixitup.Config.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Config.prototype.constructor = mixitup.Config;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.MixerDom = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.document = null;
        this.body = null;
        this.container = null;
        this.parent = null;
        this.targets = [];
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.MixerDom);
    mixitup.MixerDom.prototype = Object.create(mixitup.Base.prototype);
    mixitup.MixerDom.prototype.constructor = mixitup.MixerDom;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.UiClassNames = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.base = "";
        this.active = "";
        this.disabled = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.UiClassNames);
    mixitup.UiClassNames.prototype = Object.create(mixitup.Base.prototype);
    mixitup.UiClassNames.prototype.constructor = mixitup.UiClassNames;
    /**
     * An object into which all arbitrary arguments sent to '.dataset()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandDataset = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.dataset = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandDataset);
    mixitup.CommandDataset.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandDataset.prototype.constructor = mixitup.CommandDataset;
    /**
     * An object into which all arbitrary arguments sent to '.multimix()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandMultimix = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.filter = null;
        this.sort = null;
        this.insert = null;
        this.remove = null;
        this.changeLayout = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandMultimix);
    mixitup.CommandMultimix.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandMultimix.prototype.constructor = mixitup.CommandMultimix;
    /**
     * An object into which all arbitrary arguments sent to '.filter()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandFilter = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.selector = "";
        this.collection = null;
        this.action = "show"; // enum: ['show', 'hide']
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandFilter);
    mixitup.CommandFilter.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandFilter.prototype.constructor = mixitup.CommandFilter;
    /**
     * An object into which all arbitrary arguments sent to '.sort()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandSort = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.sortString = "";
        this.attribute = "";
        this.order = "asc";
        this.collection = null;
        this.next = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandSort);
    mixitup.CommandSort.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandSort.prototype.constructor = mixitup.CommandSort;
    /**
     * An object into which all arbitrary arguments sent to '.insert()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandInsert = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.index = 0;
        this.collection = [];
        this.position = "before"; // enum: ['before', 'after']
        this.sibling = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandInsert);
    mixitup.CommandInsert.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandInsert.prototype.constructor = mixitup.CommandInsert;
    /**
     * An object into which all arbitrary arguments sent to '.remove()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandRemove = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.targets = [];
        this.collection = [];
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandRemove);
    mixitup.CommandRemove.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandRemove.prototype.constructor = mixitup.CommandRemove;
    /**
     * An object into which all arbitrary arguments sent to '.changeLayout()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandChangeLayout = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.containerClassName = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandChangeLayout);
    mixitup.CommandChangeLayout.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandChangeLayout.prototype.constructor = mixitup.CommandChangeLayout;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     * @param       {string}        type
     * @param       {string}        selector
     * @param       {boolean}       [live]
     * @param       {string}        [parent]
     *     An optional string representing the name of the mixer.dom property containing a reference to a parent element.
     */ mixitup.ControlDefinition = function(type, selector, live, parent) {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.type = type;
        this.selector = selector;
        this.live = live || false;
        this.parent = parent || "";
        this.callActions("afterConstruct");
        h.freeze(this);
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ControlDefinition);
    mixitup.ControlDefinition.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ControlDefinition.prototype.constructor = mixitup.ControlDefinition;
    mixitup.controlDefinitions = [];
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("multimix", "[data-filter][data-sort]"));
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("filter", "[data-filter]"));
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("sort", "[data-sort]"));
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("toggle", "[data-toggle]"));
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Control = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.el = null;
        this.selector = "";
        this.bound = [];
        this.pending = -1;
        this.type = "";
        this.status = "inactive"; // enum: ['inactive', 'active', 'disabled', 'live']
        this.filter = "";
        this.sort = "";
        this.canDisable = false;
        this.handler = null;
        this.classNames = new mixitup.UiClassNames();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Control);
    mixitup.Control.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Control.prototype, /** @lends mixitup.Control */ {
        constructor: mixitup.Control,
        /**
         * @private
         * @param {HTMLElement} el
         * @param {string}      type
         * @param {string}      selector
         */ init: function(el, type, selector) {
            var self = this;
            this.callActions("beforeInit", arguments);
            self.el = el;
            self.type = type;
            self.selector = selector;
            if (self.selector) self.status = "live";
            else {
                self.canDisable = typeof self.el.disable === "boolean";
                switch(self.type){
                    case "filter":
                        self.filter = self.el.getAttribute("data-filter");
                        break;
                    case "toggle":
                        self.filter = self.el.getAttribute("data-toggle");
                        break;
                    case "sort":
                        self.sort = self.el.getAttribute("data-sort");
                        break;
                    case "multimix":
                        self.filter = self.el.getAttribute("data-filter");
                        self.sort = self.el.getAttribute("data-sort");
                        break;
                }
            }
            self.bindClick();
            mixitup.controls.push(self);
            this.callActions("afterInit", arguments);
        },
        /**
         * @private
         * @param  {mixitup.Mixer} mixer
         * @return {boolean}
         */ isBound: function(mixer) {
            var self = this, isBound = false;
            this.callActions("beforeIsBound", arguments);
            isBound = self.bound.indexOf(mixer) > -1;
            return self.callFilters("afterIsBound", isBound, arguments);
        },
        /**
         * @private
         * @param  {mixitup.Mixer} mixer
         * @return {void}
         */ addBinding: function(mixer) {
            var self = this;
            this.callActions("beforeAddBinding", arguments);
            if (!self.isBound()) self.bound.push(mixer);
            this.callActions("afterAddBinding", arguments);
        },
        /**
         * @private
         * @param  {mixitup.Mixer} mixer
         * @return {void}
         */ removeBinding: function(mixer) {
            var self = this, removeIndex = -1;
            this.callActions("beforeRemoveBinding", arguments);
            if ((removeIndex = self.bound.indexOf(mixer)) > -1) self.bound.splice(removeIndex, 1);
            if (self.bound.length < 1) {
                // No bindings exist, unbind event click handlers
                self.unbindClick();
                // Remove from `mixitup.controls` list
                removeIndex = mixitup.controls.indexOf(self);
                mixitup.controls.splice(removeIndex, 1);
                if (self.status === "active") self.renderStatus(self.el, "inactive");
            }
            this.callActions("afterRemoveBinding", arguments);
        },
        /**
         * @private
         * @return {void}
         */ bindClick: function() {
            var self = this;
            this.callActions("beforeBindClick", arguments);
            self.handler = function(e) {
                self.handleClick(e);
            };
            h.on(self.el, "click", self.handler);
            this.callActions("afterBindClick", arguments);
        },
        /**
         * @private
         * @return {void}
         */ unbindClick: function() {
            var self = this;
            this.callActions("beforeUnbindClick", arguments);
            h.off(self.el, "click", self.handler);
            self.handler = null;
            this.callActions("afterUnbindClick", arguments);
        },
        /**
         * @private
         * @param   {MouseEvent} e
         * @return  {void}
         */ handleClick: function(e) {
            var self = this, button = null, mixer = null, isActive = false, returnValue = void 0, command = {}, clone = null, commands = [], i = -1;
            this.callActions("beforeHandleClick", arguments);
            this.pending = 0;
            mixer = self.bound[0];
            if (!self.selector) button = self.el;
            else button = h.closestParent(e.target, mixer.config.selectors.control + self.selector, true, mixer.dom.document);
            if (!button) {
                self.callActions("afterHandleClick", arguments);
                return;
            }
            switch(self.type){
                case "filter":
                    command.filter = self.filter || button.getAttribute("data-filter");
                    break;
                case "sort":
                    command.sort = self.sort || button.getAttribute("data-sort");
                    break;
                case "multimix":
                    command.filter = self.filter || button.getAttribute("data-filter");
                    command.sort = self.sort || button.getAttribute("data-sort");
                    break;
                case "toggle":
                    command.filter = self.filter || button.getAttribute("data-toggle");
                    if (self.status === "live") isActive = h.hasClass(button, self.classNames.active);
                    else isActive = self.status === "active";
                    break;
            }
            for(i = 0; i < self.bound.length; i++){
                // Create a clone of the command for each bound mixer instance
                clone = new mixitup.CommandMultimix();
                h.extend(clone, command);
                commands.push(clone);
            }
            commands = self.callFilters("commandsHandleClick", commands, arguments);
            self.pending = self.bound.length;
            for(i = 0; mixer = self.bound[i]; i++){
                command = commands[i];
                if (!command) continue;
                if (!mixer.lastClicked) mixer.lastClicked = button;
                mixitup.events.fire("mixClick", mixer.dom.container, {
                    state: mixer.state,
                    instance: mixer,
                    originalEvent: e,
                    control: mixer.lastClicked
                }, mixer.dom.document);
                if (typeof mixer.config.callbacks.onMixClick === "function") {
                    returnValue = mixer.config.callbacks.onMixClick.call(mixer.lastClicked, mixer.state, e, mixer);
                    if (returnValue === false) continue;
                }
                if (self.type === "toggle") isActive ? mixer.toggleOff(command.filter) : mixer.toggleOn(command.filter);
                else mixer.multimix(command);
            }
            this.callActions("afterHandleClick", arguments);
        },
        /**
         * @param   {object}          command
         * @param   {Array<string>}   toggleArray
         * @return  {void}
         */ update: function(command, toggleArray) {
            var self = this, actions = new mixitup.CommandMultimix();
            self.callActions("beforeUpdate", arguments);
            self.pending--;
            self.pending = Math.max(0, self.pending);
            if (self.pending > 0) return;
            if (self.status === "live") // Live control (status unknown)
            self.updateLive(command, toggleArray);
            else {
                // Static control
                actions.sort = self.sort;
                actions.filter = self.filter;
                self.callFilters("actionsUpdate", actions, arguments);
                self.parseStatusChange(self.el, command, actions, toggleArray);
            }
            self.callActions("afterUpdate", arguments);
        },
        /**
         * @param   {mixitup.CommandMultimix} command
         * @param   {Array<string>}           toggleArray
         * @return  {void}
         */ updateLive: function(command, toggleArray) {
            var self = this, controlButtons = null, actions = null, button = null, i = -1;
            self.callActions("beforeUpdateLive", arguments);
            if (!self.el) return;
            controlButtons = self.el.querySelectorAll(self.selector);
            for(i = 0; button = controlButtons[i]; i++){
                actions = new mixitup.CommandMultimix();
                switch(self.type){
                    case "filter":
                        actions.filter = button.getAttribute("data-filter");
                        break;
                    case "sort":
                        actions.sort = button.getAttribute("data-sort");
                        break;
                    case "multimix":
                        actions.filter = button.getAttribute("data-filter");
                        actions.sort = button.getAttribute("data-sort");
                        break;
                    case "toggle":
                        actions.filter = button.getAttribute("data-toggle");
                        break;
                }
                actions = self.callFilters("actionsUpdateLive", actions, arguments);
                self.parseStatusChange(button, command, actions, toggleArray);
            }
            self.callActions("afterUpdateLive", arguments);
        },
        /**
         * @param   {HTMLElement}             button
         * @param   {mixitup.CommandMultimix} command
         * @param   {mixitup.CommandMultimix} actions
         * @param   {Array<string>}           toggleArray
         * @return  {void}
         */ parseStatusChange: function(button, command, actions, toggleArray) {
            var self = this, alias = "", toggle = "", i = -1;
            self.callActions("beforeParseStatusChange", arguments);
            switch(self.type){
                case "filter":
                    if (command.filter === actions.filter) self.renderStatus(button, "active");
                    else self.renderStatus(button, "inactive");
                    break;
                case "multimix":
                    if (command.sort === actions.sort && command.filter === actions.filter) self.renderStatus(button, "active");
                    else self.renderStatus(button, "inactive");
                    break;
                case "sort":
                    if (command.sort.match(/:asc/g)) alias = command.sort.replace(/:asc/g, "");
                    if (command.sort === actions.sort || alias === actions.sort) self.renderStatus(button, "active");
                    else self.renderStatus(button, "inactive");
                    break;
                case "toggle":
                    if (toggleArray.length < 1) self.renderStatus(button, "inactive");
                    if (command.filter === actions.filter) self.renderStatus(button, "active");
                    for(i = 0; i < toggleArray.length; i++){
                        toggle = toggleArray[i];
                        if (toggle === actions.filter) {
                            // Button matches one active toggle
                            self.renderStatus(button, "active");
                            break;
                        }
                        self.renderStatus(button, "inactive");
                    }
                    break;
            }
            self.callActions("afterParseStatusChange", arguments);
        },
        /**
         * @param   {HTMLElement}   button
         * @param   {string}        status
         * @return  {void}
         */ renderStatus: function(button, status) {
            var self = this;
            self.callActions("beforeRenderStatus", arguments);
            switch(status){
                case "active":
                    h.addClass(button, self.classNames.active);
                    h.removeClass(button, self.classNames.disabled);
                    if (self.canDisable) self.el.disabled = false;
                    break;
                case "inactive":
                    h.removeClass(button, self.classNames.active);
                    h.removeClass(button, self.classNames.disabled);
                    if (self.canDisable) self.el.disabled = false;
                    break;
                case "disabled":
                    if (self.canDisable) self.el.disabled = true;
                    h.addClass(button, self.classNames.disabled);
                    h.removeClass(button, self.classNames.active);
                    break;
            }
            if (self.status !== "live") // Update the control's status propery if not live
            self.status = status;
            self.callActions("afterRenderStatus", arguments);
        }
    });
    mixitup.controls = [];
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.StyleData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.x = 0;
        this.y = 0;
        this.top = 0;
        this.right = 0;
        this.bottom = 0;
        this.left = 0;
        this.width = 0;
        this.height = 0;
        this.marginRight = 0;
        this.marginBottom = 0;
        this.opacity = 0;
        this.scale = new mixitup.TransformData();
        this.translateX = new mixitup.TransformData();
        this.translateY = new mixitup.TransformData();
        this.translateZ = new mixitup.TransformData();
        this.rotateX = new mixitup.TransformData();
        this.rotateY = new mixitup.TransformData();
        this.rotateZ = new mixitup.TransformData();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.StyleData);
    mixitup.StyleData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.StyleData.prototype.constructor = mixitup.StyleData;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.TransformData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.value = 0;
        this.unit = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.TransformData);
    mixitup.TransformData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.TransformData.prototype.constructor = mixitup.TransformData;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.TransformDefaults = function() {
        mixitup.StyleData.apply(this);
        this.callActions("beforeConstruct");
        this.scale.value = 0.01;
        this.scale.unit = "";
        this.translateX.value = 20;
        this.translateX.unit = "px";
        this.translateY.value = 20;
        this.translateY.unit = "px";
        this.translateZ.value = 20;
        this.translateZ.unit = "px";
        this.rotateX.value = 90;
        this.rotateX.unit = "deg";
        this.rotateY.value = 90;
        this.rotateY.unit = "deg";
        this.rotateX.value = 90;
        this.rotateX.unit = "deg";
        this.rotateZ.value = 180;
        this.rotateZ.unit = "deg";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.TransformDefaults);
    mixitup.TransformDefaults.prototype = Object.create(mixitup.StyleData.prototype);
    mixitup.TransformDefaults.prototype.constructor = mixitup.TransformDefaults;
    /**
     * @private
     * @static
     * @since   3.0.0
     * @type    {mixitup.TransformDefaults}
     */ mixitup.transformDefaults = new mixitup.TransformDefaults();
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.EventDetail = function() {
        this.state = null;
        this.futureState = null;
        this.instance = null;
        this.originalEvent = null;
    };
    /**
     * The `mixitup.Events` class contains all custom events dispatched by MixItUp at various
     * points within the lifecycle of a mixer operation.
     *
     * Each event is analogous to the callback function of the same name defined in
     * the `callbacks` configuration object, and is triggered immediately before it.
     *
     * Events are always triggered from the container element on which MixItUp is instantiated
     * upon.
     *
     * As with any event, registered event handlers receive the event object as a parameter
     * which includes a `detail` property containting references to the current `state`,
     * the `mixer` instance, and other event-specific properties described below.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @public
     * @since       3.0.0
     */ mixitup.Events = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A custom event triggered immediately after any MixItUp operation is requested
         * and before animations have begun.
         *
         * The `mixStart` event also exposes a `futureState` property via the
         * `event.detail` object, which represents the final state of the mixer once
         * the requested operation has completed.
         *
         * @name        mixStart
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixStart = null;
        /**
         * A custom event triggered when a MixItUp operation is requested while another
         * operation is in progress, and the animation queue is full, or queueing
         * is disabled.
         *
         * @name        mixBusy
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixBusy = null;
        /**
         * A custom event triggered after any MixItUp operation has completed, and the
         * state has been updated.
         *
         * @name        mixEnd
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixEnd = null;
        /**
         * A custom event triggered whenever a filter operation "fails", i.e. no targets
         * could be found matching the requested filter.
         *
         * @name        mixFail
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixFail = null;
        /**
         * A custom event triggered whenever a MixItUp control is clicked, and before its
         * respective operation is requested.
         *
         * This event also exposes an `originalEvent` property via the `event.detail`
         * object, which holds a reference to the original click event.
         *
         * @name        mixClick
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixClick = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Events);
    mixitup.Events.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Events.prototype.constructor = mixitup.Events;
    /**
     * @private
     * @param   {string}      eventType
     * @param   {Element}     el
     * @param   {object}      detail
     * @param   {Document}    [doc]
     */ mixitup.Events.prototype.fire = function(eventType, el, detail, doc) {
        var self = this, event = null, eventDetail = new mixitup.EventDetail();
        self.callActions("beforeFire", arguments);
        if (typeof self[eventType] === "undefined") throw new Error('Event type "' + eventType + '" not found.');
        eventDetail.state = new mixitup.State();
        h.extend(eventDetail.state, detail.state);
        if (detail.futureState) {
            eventDetail.futureState = new mixitup.State();
            h.extend(eventDetail.futureState, detail.futureState);
        }
        eventDetail.instance = detail.instance;
        if (detail.originalEvent) eventDetail.originalEvent = detail.originalEvent;
        event = h.getCustomEvent(eventType, eventDetail, doc);
        self.callFilters("eventFire", event, arguments);
        el.dispatchEvent(event);
    };
    // Asign a singleton instance to `mixitup.events`:
    mixitup.events = new mixitup.Events();
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.QueueItem = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.args = [];
        this.instruction = null;
        this.triggerElement = null;
        this.deferred = null;
        this.isToggling = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.QueueItem);
    mixitup.QueueItem.prototype = Object.create(mixitup.Base.prototype);
    mixitup.QueueItem.prototype.constructor = mixitup.QueueItem;
    /**
     * The `mixitup.Mixer` class is used to hold discreet, user-configured
     * instances of MixItUp on a provided container element.
     *
     * Mixer instances are returned whenever the `mixitup()` factory function is called,
     * which expose a range of methods enabling API-based filtering, sorting,
     * insertion, removal and more.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @public
     * @since       3.0.0
     */ mixitup.Mixer = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.config = new mixitup.Config();
        this.id = "";
        this.isBusy = false;
        this.isToggling = false;
        this.incPadding = true;
        this.controls = [];
        this.targets = [];
        this.origOrder = [];
        this.cache = {};
        this.toggleArray = [];
        this.targetsMoved = 0;
        this.targetsImmovable = 0;
        this.targetsBound = 0;
        this.targetsDone = 0;
        this.staggerDuration = 0;
        this.effectsIn = null;
        this.effectsOut = null;
        this.transformIn = [];
        this.transformOut = [];
        this.queue = [];
        this.state = null;
        this.lastOperation = null;
        this.lastClicked = null;
        this.userCallback = null;
        this.userDeferred = null;
        this.dom = new mixitup.MixerDom();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Mixer);
    mixitup.Mixer.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Mixer.prototype, /** @lends mixitup.Mixer */ {
        constructor: mixitup.Mixer,
        /**
         * @private
         * @instance
         * @since 3.0.0
         * @param {HTMLElement} container
         * @param {HTMLElement} document
         * @param {string}      id
         * @param {object}      [config]
         */ attach: function(container, document1, id, config) {
            var self = this, target = null, i = -1;
            self.callActions("beforeAttach", arguments);
            self.id = id;
            if (config) h.extend(self.config, config, true, true);
            self.sanitizeConfig();
            self.cacheDom(container, document1);
            if (self.config.layout.containerClassName) h.addClass(self.dom.container, self.config.layout.containerClassName);
            if (!mixitup.features.has.transitions) self.config.animation.enable = false;
            if (typeof window1.console === "undefined") self.config.debug.showWarnings = false;
            if (self.config.data.uidKey) // If the dataset API is in use, force disable controls
            self.config.controls.enable = false;
            self.indexTargets();
            self.state = self.getInitialState();
            for(i = 0; target = self.lastOperation.toHide[i]; i++)target.hide();
            if (self.config.controls.enable) {
                self.initControls();
                self.buildToggleArray(null, self.state);
                self.updateControls({
                    filter: self.state.activeFilter,
                    sort: self.state.activeSort
                });
            }
            self.parseEffects();
            self.callActions("afterAttach", arguments);
        },
        /**
         * @private
         * @instance
         * @since 3.0.0
         * @return {void}
         */ sanitizeConfig: function() {
            var self = this;
            self.callActions("beforeSanitizeConfig", arguments);
            // Sanitize enum/string config options
            self.config.controls.scope = self.config.controls.scope.toLowerCase().trim();
            self.config.controls.toggleLogic = self.config.controls.toggleLogic.toLowerCase().trim();
            self.config.controls.toggleDefault = self.config.controls.toggleDefault.toLowerCase().trim();
            self.config.animation.effects = self.config.animation.effects.trim();
            self.callActions("afterSanitizeConfig", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {mixitup.State}
         */ getInitialState: function() {
            var self = this, state = new mixitup.State(), operation = new mixitup.Operation();
            self.callActions("beforeGetInitialState", arguments);
            // Map initial values into a mock state object in order to construct an operation
            state.activeContainerClassName = self.config.layout.containerClassName;
            if (self.config.load.dataset) {
                // Dataset API
                if (!self.config.data.uidKey || typeof self.config.data.uidKey !== "string") throw new TypeError(mixitup.messages.errorConfigDataUidKeyNotSet());
                operation.startDataset = operation.newDataset = state.activeDataset = self.config.load.dataset.slice();
                operation.startContainerClassName = operation.newContainerClassName = state.activeContainerClassName;
                operation.show = self.targets.slice();
                state = self.callFilters("stateGetInitialState", state, arguments);
            } else {
                // DOM API
                state.activeFilter = self.parseFilterArgs([
                    self.config.load.filter
                ]).command;
                state.activeSort = self.parseSortArgs([
                    self.config.load.sort
                ]).command;
                state.totalTargets = self.targets.length;
                state = self.callFilters("stateGetInitialState", state, arguments);
                if (state.activeSort.collection || state.activeSort.attribute || state.activeSort.order === "random" || state.activeSort.order === "desc") {
                    // Sorting on load
                    operation.newSort = state.activeSort;
                    self.sortOperation(operation);
                    self.printSort(false, operation);
                    self.targets = operation.newOrder;
                } else operation.startOrder = operation.newOrder = self.targets;
                operation.startFilter = operation.newFilter = state.activeFilter;
                operation.startSort = operation.newSort = state.activeSort;
                operation.startContainerClassName = operation.newContainerClassName = state.activeContainerClassName;
                if (operation.newFilter.selector === "all") operation.newFilter.selector = self.config.selectors.target;
                else if (operation.newFilter.selector === "none") operation.newFilter.selector = "";
            }
            operation = self.callFilters("operationGetInitialState", operation, [
                state
            ]);
            self.lastOperation = operation;
            if (operation.newFilter) self.filterOperation(operation);
            state = self.buildState(operation);
            return state;
        },
        /**
         * Caches references of DOM elements neccessary for the mixer's functionality.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {HTMLElement}       el
         * @param   {HTMLHtmlElement}   document
         * @return  {void}
         */ cacheDom: function(el, document1) {
            var self = this;
            self.callActions("beforeCacheDom", arguments);
            self.dom.document = document1;
            self.dom.body = self.dom.document.querySelector("body");
            self.dom.container = el;
            self.dom.parent = el;
            self.callActions("afterCacheDom", arguments);
        },
        /**
         * Indexes all child elements of the mixer matching the `selectors.target`
         * selector, instantiating a mixitup.Target for each one.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ indexTargets: function() {
            var self = this, target = null, el = null, dataset = null, i = -1;
            self.callActions("beforeIndexTargets", arguments);
            self.dom.targets = self.config.layout.allowNestedTargets ? self.dom.container.querySelectorAll(self.config.selectors.target) : h.children(self.dom.container, self.config.selectors.target, self.dom.document);
            self.dom.targets = h.arrayFromList(self.dom.targets);
            self.targets = [];
            if ((dataset = self.config.load.dataset) && dataset.length !== self.dom.targets.length) throw new Error(mixitup.messages.errorDatasetPrerenderedMismatch());
            if (self.dom.targets.length) {
                for(i = 0; el = self.dom.targets[i]; i++){
                    target = new mixitup.Target();
                    target.init(el, self, dataset ? dataset[i] : void 0);
                    target.isInDom = true;
                    self.targets.push(target);
                }
                self.dom.parent = self.dom.targets[0].parentElement === self.dom.container ? self.dom.container : self.dom.targets[0].parentElement;
            }
            self.origOrder = self.targets;
            self.callActions("afterIndexTargets", arguments);
        },
        initControls: function() {
            var self = this, definition = "", controlElements = null, el = null, parent = null, delagators = null, control = null, i = -1, j = -1;
            self.callActions("beforeInitControls", arguments);
            switch(self.config.controls.scope){
                case "local":
                    parent = self.dom.container;
                    break;
                case "global":
                    parent = self.dom.document;
                    break;
                default:
                    throw new Error(mixitup.messages.errorConfigInvalidControlsScope());
            }
            for(i = 0; definition = mixitup.controlDefinitions[i]; i++)if (self.config.controls.live || definition.live) {
                if (definition.parent) {
                    delagators = self.dom[definition.parent];
                    if (!delagators || delagators.length < 0) continue;
                    if (typeof delagators.length !== "number") delagators = [
                        delagators
                    ];
                } else delagators = [
                    parent
                ];
                for(j = 0; el = delagators[j]; j++){
                    control = self.getControl(el, definition.type, definition.selector);
                    self.controls.push(control);
                }
            } else {
                controlElements = parent.querySelectorAll(self.config.selectors.control + definition.selector);
                for(j = 0; el = controlElements[j]; j++){
                    control = self.getControl(el, definition.type, "");
                    if (!control) continue;
                    self.controls.push(control);
                }
            }
            self.callActions("afterInitControls", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {HTMLElement} el
         * @param   {string}      type
         * @param   {string}      selector
         * @return  {mixitup.Control|null}
         */ getControl: function(el, type, selector) {
            var self = this, control = null, i = -1;
            self.callActions("beforeGetControl", arguments);
            if (!selector) // Static controls only
            for(i = 0; control = mixitup.controls[i]; i++){
                if (control.el === el && control.isBound(self)) // Control already bound to this mixer (as another type).
                // NB: This prevents duplicate controls from being registered where a selector
                // might collide, eg: "[data-filter]" and "[data-filter][data-sort]"
                return self.callFilters("controlGetControl", null, arguments);
                else if (control.el === el && control.type === type && control.selector === selector) {
                    // Another mixer is already using this control, add this mixer as a binding
                    control.addBinding(self);
                    return self.callFilters("controlGetControl", control, arguments);
                }
            }
            // Create new control
            control = new mixitup.Control();
            control.init(el, type, selector);
            control.classNames.base = h.getClassname(self.config.classNames, type);
            control.classNames.active = h.getClassname(self.config.classNames, type, self.config.classNames.modifierActive);
            control.classNames.disabled = h.getClassname(self.config.classNames, type, self.config.classNames.modifierDisabled);
            // Add a reference to this mixer as a binding
            control.addBinding(self);
            return self.callFilters("controlGetControl", control, arguments);
        },
        /**
         * Creates a compound selector by joining the `toggleArray` value as per the
         * defined toggle logic.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @return  {string}
         */ getToggleSelector: function() {
            var self = this, delineator = self.config.controls.toggleLogic === "or" ? ", " : "", toggleSelector = "";
            self.callActions("beforeGetToggleSelector", arguments);
            self.toggleArray = h.clean(self.toggleArray);
            toggleSelector = self.toggleArray.join(delineator);
            if (toggleSelector === "") toggleSelector = self.config.controls.toggleDefault;
            return self.callFilters("selectorGetToggleSelector", toggleSelector, arguments);
        },
        /**
         * Breaks compound selector strings in an array of discreet selectors,
         * as per the active `controls.toggleLogic` configuration option. Accepts
         * either a dynamic command object, or a state object.
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {object}        [command]
         * @param   {mixitup.State} [state]
         * @return  {void}
         */ buildToggleArray: function(command, state) {
            var self = this, activeFilterSelector = "";
            self.callActions("beforeBuildToggleArray", arguments);
            if (command && command.filter) activeFilterSelector = command.filter.selector.replace(/\s/g, "");
            else if (state) activeFilterSelector = state.activeFilter.selector.replace(/\s/g, "");
            else return;
            if (activeFilterSelector === self.config.selectors.target || activeFilterSelector === "all") activeFilterSelector = "";
            if (self.config.controls.toggleLogic === "or") self.toggleArray = activeFilterSelector.split(",");
            else self.toggleArray = self.splitCompoundSelector(activeFilterSelector);
            self.toggleArray = h.clean(self.toggleArray);
            self.callActions("afterBuildToggleArray", arguments);
        },
        /**
         * Takes a compound selector (e.g. `.cat-1.cat-2`, `[data-cat="1"][data-cat="2"]`)
         * and breaks into its individual selectors.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string} compoundSelector
         * @return  {string[]}
         */ splitCompoundSelector: function(compoundSelector) {
            // Break at a `.` or `[`, capturing the delineator
            var partials = compoundSelector.split(/([\.\[])/g), toggleArray = [], selector = "", i = -1;
            if (partials[0] === "") partials.shift();
            for(i = 0; i < partials.length; i++){
                if (i % 2 === 0) selector = "";
                selector += partials[i];
                if (i % 2 !== 0) toggleArray.push(selector);
            }
            return toggleArray;
        },
        /**
         * Updates controls to their active/inactive state based on the command or
         * current state of the mixer.
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {object} command
         * @return  {void}
         */ updateControls: function(command) {
            var self = this, control = null, output = new mixitup.CommandMultimix(), i = -1;
            self.callActions("beforeUpdateControls", arguments);
            // Sanitise to defaults
            if (command.filter) output.filter = command.filter.selector;
            else output.filter = self.state.activeFilter.selector;
            if (command.sort) output.sort = self.buildSortString(command.sort);
            else output.sort = self.buildSortString(self.state.activeSort);
            if (output.filter === self.config.selectors.target) output.filter = "all";
            if (output.filter === "") output.filter = "none";
            h.freeze(output);
            for(i = 0; control = self.controls[i]; i++)control.update(output, self.toggleArray);
            self.callActions("afterUpdateControls", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.CommandSort}   command
         * @return  {string}
         */ buildSortString: function(command) {
            var self = this;
            var output = "";
            output += command.sortString;
            if (command.next) output += " " + self.buildSortString(command.next);
            return output;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {object}        command
         * @param   {Operation}     operation
         * @return  {Promise.<mixitup.State>}
         */ insertTargets: function(command, operation) {
            var self = this, nextSibling = null, insertionIndex = -1, frag = null, target = null, el = null, i = -1;
            self.callActions("beforeInsertTargets", arguments);
            if (typeof command.index === "undefined") command.index = 0;
            nextSibling = self.getNextSibling(command.index, command.sibling, command.position);
            frag = self.dom.document.createDocumentFragment();
            if (nextSibling) insertionIndex = h.index(nextSibling, self.config.selectors.target);
            else insertionIndex = self.targets.length;
            if (command.collection) {
                for(i = 0; el = command.collection[i]; i++){
                    if (self.dom.targets.indexOf(el) > -1) throw new Error(mixitup.messages.errorInsertPreexistingElement());
                    // Ensure elements are hidden when they are added to the DOM, so they can
                    // be animated in gracefully
                    el.style.display = "none";
                    frag.appendChild(el);
                    frag.appendChild(self.dom.document.createTextNode(" "));
                    if (!h.isElement(el, self.dom.document) || !el.matches(self.config.selectors.target)) continue;
                    target = new mixitup.Target();
                    target.init(el, self);
                    target.isInDom = true;
                    self.targets.splice(insertionIndex, 0, target);
                    insertionIndex++;
                }
                self.dom.parent.insertBefore(frag, nextSibling);
            }
            // Since targets have been added, the original order must be updated
            operation.startOrder = self.origOrder = self.targets;
            self.callActions("afterInsertTargets", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Number}      [index]
         * @param   {Element}     [sibling]
         * @param   {string}      [position]
         * @return  {Element}
         */ getNextSibling: function(index, sibling, position) {
            var self = this, element = null;
            index = Math.max(index, 0);
            if (sibling && position === "before") // Explicit sibling
            element = sibling;
            else if (sibling && position === "after") // Explicit sibling
            element = sibling.nextElementSibling || null;
            else if (self.targets.length > 0 && typeof index !== "undefined") // Index and targets exist
            element = index < self.targets.length || !self.targets.length ? self.targets[index].dom.el : self.targets[self.targets.length - 1].dom.el.nextElementSibling;
            else if (self.targets.length === 0 && self.dom.parent.children.length > 0) {
                // No targets but other siblings
                if (self.config.layout.siblingAfter) element = self.config.layout.siblingAfter;
                else if (self.config.layout.siblingBefore) element = self.config.layout.siblingBefore.nextElementSibling;
                else self.dom.parent.children[0];
            } else element;
            return self.callFilters("elementGetNextSibling", element, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ filterOperation: function(operation) {
            var self = this, testResult = false, index = -1, action = "", target = null, i = -1;
            self.callActions("beforeFilterOperation", arguments);
            action = operation.newFilter.action;
            for(i = 0; target = operation.newOrder[i]; i++){
                if (operation.newFilter.collection) // show via collection
                testResult = operation.newFilter.collection.indexOf(target.dom.el) > -1;
                else // show via selector
                if (operation.newFilter.selector === "") testResult = false;
                else testResult = target.dom.el.matches(operation.newFilter.selector);
                self.evaluateHideShow(testResult, target, action, operation);
            }
            if (operation.toRemove.length) {
                for(i = 0; target = operation.show[i]; i++)if (operation.toRemove.indexOf(target) > -1) {
                    // If any shown targets should be removed, move them into the toHide array
                    operation.show.splice(i, 1);
                    if ((index = operation.toShow.indexOf(target)) > -1) operation.toShow.splice(index, 1);
                    operation.toHide.push(target);
                    operation.hide.push(target);
                    i--;
                }
            }
            operation.matching = operation.show.slice();
            if (operation.show.length === 0 && operation.newFilter.selector !== "" && self.targets.length !== 0) operation.hasFailed = true;
            self.callActions("afterFilterOperation", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {boolean}   testResult
         * @param   {Element}   target
         * @param   {string}    action
         * @param   {Operation} operation
         * @return  {void}
         */ evaluateHideShow: function(testResult, target, action, operation) {
            var self = this, filteredTestResult = false, args = Array.prototype.slice.call(arguments, 1);
            filteredTestResult = self.callFilters("testResultEvaluateHideShow", testResult, args);
            self.callActions("beforeEvaluateHideShow", arguments);
            if (filteredTestResult === true && action === "show" || filteredTestResult === false && action === "hide") {
                operation.show.push(target);
                !target.isShown && operation.toShow.push(target);
            } else {
                operation.hide.push(target);
                target.isShown && operation.toHide.push(target);
            }
            self.callActions("afterEvaluateHideShow", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ sortOperation: function(operation) {
            var self = this, newOrder = [], target = null, el = null, i = -1;
            self.callActions("beforeSortOperation", arguments);
            operation.startOrder = self.targets;
            if (operation.newSort.collection) {
                // Sort by collection
                newOrder = [];
                for(i = 0; el = operation.newSort.collection[i]; i++){
                    if (self.dom.targets.indexOf(el) < 0) throw new Error(mixitup.messages.errorSortNonExistentElement());
                    target = new mixitup.Target();
                    target.init(el, self);
                    target.isInDom = true;
                    newOrder.push(target);
                }
                operation.newOrder = newOrder;
            } else if (operation.newSort.order === "random") // Sort random
            operation.newOrder = h.arrayShuffle(operation.startOrder);
            else if (operation.newSort.attribute === "") {
                // Sort by default
                operation.newOrder = self.origOrder.slice();
                if (operation.newSort.order === "desc") operation.newOrder.reverse();
            } else {
                // Sort by attribute
                operation.newOrder = operation.startOrder.slice();
                operation.newOrder.sort(function(a, b) {
                    return self.compare(a, b, operation.newSort);
                });
            }
            if (h.isEqualArray(operation.newOrder, operation.startOrder)) operation.willSort = false;
            self.callActions("afterSortOperation", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {mixitup.Target}        a
         * @param   {mixitup.Target}        b
         * @param   {mixitup.CommandSort}   command
         * @return  {Number}
         */ compare: function(a, b, command) {
            var self = this, order = command.order, attrA = self.getAttributeValue(a, command.attribute), attrB = self.getAttributeValue(b, command.attribute);
            if (isNaN(attrA * 1) || isNaN(attrB * 1)) {
                attrA = attrA.toLowerCase();
                attrB = attrB.toLowerCase();
            } else {
                attrA = attrA * 1;
                attrB = attrB * 1;
            }
            if (attrA < attrB) return order === "asc" ? -1 : 1;
            if (attrA > attrB) return order === "asc" ? 1 : -1;
            if (attrA === attrB && command.next) return self.compare(a, b, command.next);
            return 0;
        },
        /**
         * Reads the values of any data attributes present the provided target element
         * which match the current sort command.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.Target}    target
         * @param   {string}            [attribute]
         * @return  {(String|Number)}
         */ getAttributeValue: function(target, attribute) {
            var self = this, value = "";
            value = target.dom.el.getAttribute("data-" + attribute);
            if (value === null) {
                if (self.config.debug.showWarnings) // Encourage users to assign values to all targets to avoid erroneous sorting
                // when types are mixed
                console.warn(mixitup.messages.warningInconsistentSortingAttributes({
                    attribute: "data-" + attribute
                }));
            }
            // If an attribute is not present, return 0 as a safety value
            return self.callFilters("valueGetAttributeValue", value || 0, arguments);
        },
        /**
         * Inserts elements into the DOM in the appropriate
         * order using a document fragment for minimal
         * DOM thrashing
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {boolean}   isResetting
         * @param   {Operation} operation
         * @return  {void}
         */ printSort: function(isResetting, operation) {
            var self = this, startOrder = isResetting ? operation.newOrder : operation.startOrder, newOrder = isResetting ? operation.startOrder : operation.newOrder, nextSibling = startOrder.length ? startOrder[startOrder.length - 1].dom.el.nextElementSibling : null, frag = window1.document.createDocumentFragment(), whitespace = null, target = null, el = null, i = -1;
            self.callActions("beforePrintSort", arguments);
            // Empty the container
            for(i = 0; target = startOrder[i]; i++){
                el = target.dom.el;
                if (el.style.position === "absolute") continue;
                h.removeWhitespace(el.previousSibling);
                el.parentElement.removeChild(el);
            }
            whitespace = nextSibling ? nextSibling.previousSibling : self.dom.parent.lastChild;
            if (whitespace && whitespace.nodeName === "#text") h.removeWhitespace(whitespace);
            for(i = 0; target = newOrder[i]; i++){
                // Add targets into a document fragment
                el = target.dom.el;
                if (h.isElement(frag.lastChild)) frag.appendChild(window1.document.createTextNode(" "));
                frag.appendChild(el);
            }
            // Insert the document fragment into the container
            // before any other non-target elements
            if (self.dom.parent.firstChild && self.dom.parent.firstChild !== nextSibling) frag.insertBefore(window1.document.createTextNode(" "), frag.childNodes[0]);
            if (nextSibling) {
                frag.appendChild(window1.document.createTextNode(" "));
                self.dom.parent.insertBefore(frag, nextSibling);
            } else self.dom.parent.appendChild(frag);
            self.callActions("afterPrintSort", arguments);
        },
        /**
         * Parses user-defined sort strings (i.e. `default:asc`) into sort commands objects.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}                sortString
         * @param   {mixitup.CommandSort}   command
         * @return  {mixitup.CommandSort}
         */ parseSortString: function(sortString, command) {
            var self = this, rules = sortString.split(" "), current = command, rule = [], i = -1;
            // command.sortString = sortString;
            for(i = 0; i < rules.length; i++){
                rule = rules[i].split(":");
                current.sortString = rules[i];
                current.attribute = h.dashCase(rule[0]);
                current.order = rule[1] || "asc";
                switch(current.attribute){
                    case "default":
                        // treat "default" as sorting by no attribute
                        current.attribute = "";
                        break;
                    case "random":
                        // treat "random" as an order not an attribute
                        current.attribute = "";
                        current.order = "random";
                        break;
                }
                if (!current.attribute || current.order === "random") break;
                if (i < rules.length - 1) {
                    // Embed reference to the next command
                    current.next = new mixitup.CommandSort();
                    h.freeze(current);
                    current = current.next;
                }
            }
            return self.callFilters("commandsParseSort", command, arguments);
        },
        /**
         * Parses all effects out of the user-defined `animation.effects` string into
         * their respective properties and units.
         *
         * @private
         * @instance
         * @since   2.0.0
         * @return  {void}
         */ parseEffects: function() {
            var self = this, transformName = "", effectsIn = self.config.animation.effectsIn || self.config.animation.effects, effectsOut = self.config.animation.effectsOut || self.config.animation.effects;
            self.callActions("beforeParseEffects", arguments);
            self.effectsIn = new mixitup.StyleData();
            self.effectsOut = new mixitup.StyleData();
            self.transformIn = [];
            self.transformOut = [];
            self.effectsIn.opacity = self.effectsOut.opacity = 1;
            self.parseEffect("fade", effectsIn, self.effectsIn, self.transformIn);
            self.parseEffect("fade", effectsOut, self.effectsOut, self.transformOut, true);
            for(transformName in mixitup.transformDefaults){
                if (!(mixitup.transformDefaults[transformName] instanceof mixitup.TransformData)) continue;
                self.parseEffect(transformName, effectsIn, self.effectsIn, self.transformIn);
                self.parseEffect(transformName, effectsOut, self.effectsOut, self.transformOut, true);
            }
            self.parseEffect("stagger", effectsIn, self.effectsIn, self.transformIn);
            self.parseEffect("stagger", effectsOut, self.effectsOut, self.transformOut, true);
            self.callActions("afterParseEffects", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {string}    effectName
         * @param   {string}    effectString
         * @param   {StyleData} effects
         * @param   {String[]}  transform
         * @param   {boolean}   [isOut]
         */ parseEffect: function(effectName, effectString, effects, transform, isOut) {
            var self = this, re = /\(([^)]+)\)/, propIndex = -1, str = "", match = [], val = "", units = [
                "%",
                "px",
                "em",
                "rem",
                "vh",
                "vw",
                "deg"
            ], unit = "", i = -1;
            self.callActions("beforeParseEffect", arguments);
            if (typeof effectString !== "string") throw new TypeError(mixitup.messages.errorConfigInvalidAnimationEffects());
            if (effectString.indexOf(effectName) < 0) {
                // The effect is not present in the effects string
                if (effectName === "stagger") // Reset stagger to 0
                self.staggerDuration = 0;
                return;
            }
            // The effect is present
            propIndex = effectString.indexOf(effectName + "(");
            if (propIndex > -1) {
                // The effect has a user defined value in parentheses
                // Extract from the first parenthesis to the end of string
                str = effectString.substring(propIndex);
                // Match any number of characters between "(" and ")"
                match = re.exec(str);
                val = match[1];
            }
            switch(effectName){
                case "fade":
                    effects.opacity = val ? parseFloat(val) : 0;
                    break;
                case "stagger":
                    self.staggerDuration = val ? parseFloat(val) : 100;
                    break;
                default:
                    // All other effects are transforms following the same structure
                    if (isOut && self.config.animation.reverseOut && effectName !== "scale") effects[effectName].value = (val ? parseFloat(val) : mixitup.transformDefaults[effectName].value) * -1;
                    else effects[effectName].value = val ? parseFloat(val) : mixitup.transformDefaults[effectName].value;
                    if (val) {
                        for(i = 0; unit = units[i]; i++)if (val.indexOf(unit) > -1) {
                            effects[effectName].unit = unit;
                            break;
                        }
                    } else effects[effectName].unit = mixitup.transformDefaults[effectName].unit;
                    transform.push(effectName + "(" + effects[effectName].value + effects[effectName].unit + ")");
            }
            self.callActions("afterParseEffect", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {State}
         */ buildState: function(operation) {
            var self = this, state = new mixitup.State(), target = null, i = -1;
            self.callActions("beforeBuildState", arguments);
            // Map target elements into state arrays.
            // the real target objects should never be exposed
            for(i = 0; target = self.targets[i]; i++)if (!operation.toRemove.length || operation.toRemove.indexOf(target) < 0) state.targets.push(target.dom.el);
            for(i = 0; target = operation.matching[i]; i++)state.matching.push(target.dom.el);
            for(i = 0; target = operation.show[i]; i++)state.show.push(target.dom.el);
            for(i = 0; target = operation.hide[i]; i++)if (!operation.toRemove.length || operation.toRemove.indexOf(target) < 0) state.hide.push(target.dom.el);
            state.id = self.id;
            state.container = self.dom.container;
            state.activeFilter = operation.newFilter;
            state.activeSort = operation.newSort;
            state.activeDataset = operation.newDataset;
            state.activeContainerClassName = operation.newContainerClassName;
            state.hasFailed = operation.hasFailed;
            state.totalTargets = self.targets.length;
            state.totalShow = operation.show.length;
            state.totalHide = operation.hide.length;
            state.totalMatching = operation.matching.length;
            state.triggerElement = operation.triggerElement;
            return self.callFilters("stateBuildState", state, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {boolean}   shouldAnimate
         * @param   {Operation} operation
         * @return  {void}
         */ goMix: function(shouldAnimate, operation) {
            var self = this, deferred = null;
            self.callActions("beforeGoMix", arguments);
            // If the animation duration is set to 0ms,
            // or no effects specified,
            // or the container is hidden
            // then abort animation
            if (!self.config.animation.duration || !self.config.animation.effects || !h.isVisible(self.dom.container)) shouldAnimate = false;
            if (!operation.toShow.length && !operation.toHide.length && !operation.willSort && !operation.willChangeLayout) // If nothing to show or hide, and not sorting or
            // changing layout
            shouldAnimate = false;
            if (!operation.startState.show.length && !operation.show.length) // If nothing currently shown, nothing to show
            shouldAnimate = false;
            mixitup.events.fire("mixStart", self.dom.container, {
                state: operation.startState,
                futureState: operation.newState,
                instance: self
            }, self.dom.document);
            if (typeof self.config.callbacks.onMixStart === "function") self.config.callbacks.onMixStart.call(self.dom.container, operation.startState, operation.newState, self);
            h.removeClass(self.dom.container, h.getClassname(self.config.classNames, "container", self.config.classNames.modifierFailed));
            if (!self.userDeferred) // Queue empty, no pending operations
            deferred = self.userDeferred = h.defer(mixitup.libraries);
            else // Use existing deferred
            deferred = self.userDeferred;
            self.isBusy = true;
            if (!shouldAnimate || !mixitup.features.has.transitions) {
                // Abort
                if (self.config.debug.fauxAsync) setTimeout(function() {
                    self.cleanUp(operation);
                }, self.config.animation.duration);
                else self.cleanUp(operation);
                return self.callFilters("promiseGoMix", deferred.promise, arguments);
            }
            // If we should animate and the platform supports transitions, go for it
            if (window1.pageYOffset !== operation.docState.scrollTop) window1.scrollTo(operation.docState.scrollLeft, operation.docState.scrollTop);
            if (self.config.animation.applyPerspective) {
                self.dom.parent.style[mixitup.features.perspectiveProp] = self.config.animation.perspectiveDistance;
                self.dom.parent.style[mixitup.features.perspectiveOriginProp] = self.config.animation.perspectiveOrigin;
            }
            if (self.config.animation.animateResizeContainer && operation.startHeight !== operation.newHeight && operation.viewportDeltaY !== operation.startHeight - operation.newHeight) self.dom.parent.style.height = operation.startHeight + "px";
            if (self.config.animation.animateResizeContainer && operation.startWidth !== operation.newWidth && operation.viewportDeltaX !== operation.startWidth - operation.newWidth) self.dom.parent.style.width = operation.startWidth + "px";
            if (operation.startHeight === operation.newHeight) self.dom.parent.style.height = operation.startHeight + "px";
            if (operation.startWidth === operation.newWidth) self.dom.parent.style.width = operation.startWidth + "px";
            if (operation.startHeight === operation.newHeight && operation.startWidth === operation.newWidth) self.dom.parent.style.overflow = "hidden";
            requestAnimationFrame(function() {
                self.moveTargets(operation);
            });
            return self.callFilters("promiseGoMix", deferred.promise, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ getStartMixData: function(operation) {
            var self = this, parentStyle = window1.getComputedStyle(self.dom.parent), parentRect = self.dom.parent.getBoundingClientRect(), target = null, data = {}, i = -1, boxSizing = parentStyle[mixitup.features.boxSizingProp];
            self.incPadding = boxSizing === "border-box";
            self.callActions("beforeGetStartMixData", arguments);
            for(i = 0; target = operation.show[i]; i++){
                data = target.getPosData();
                operation.showPosData[i] = {
                    startPosData: data
                };
            }
            for(i = 0; target = operation.toHide[i]; i++){
                data = target.getPosData();
                operation.toHidePosData[i] = {
                    startPosData: data
                };
            }
            operation.startX = parentRect.left;
            operation.startY = parentRect.top;
            operation.startHeight = self.incPadding ? parentRect.height : parentRect.height - parseFloat(parentStyle.paddingTop) - parseFloat(parentStyle.paddingBottom) - parseFloat(parentStyle.borderTop) - parseFloat(parentStyle.borderBottom);
            operation.startWidth = self.incPadding ? parentRect.width : parentRect.width - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight) - parseFloat(parentStyle.borderLeft) - parseFloat(parentStyle.borderRight);
            self.callActions("afterGetStartMixData", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ setInter: function(operation) {
            var self = this, target = null, i = -1;
            self.callActions("beforeSetInter", arguments);
            // Prevent scrollbar flicker on non-inertial scroll platforms by clamping height/width
            if (self.config.animation.clampHeight) {
                self.dom.parent.style.height = operation.startHeight + "px";
                self.dom.parent.style.overflow = "hidden";
            }
            if (self.config.animation.clampWidth) {
                self.dom.parent.style.width = operation.startWidth + "px";
                self.dom.parent.style.overflow = "hidden";
            }
            for(i = 0; target = operation.toShow[i]; i++)target.show();
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, operation.startContainerClassName);
                h.addClass(self.dom.container, operation.newContainerClassName);
            }
            self.callActions("afterSetInter", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ getInterMixData: function(operation) {
            var self = this, target = null, i = -1;
            self.callActions("beforeGetInterMixData", arguments);
            for(i = 0; target = operation.show[i]; i++)operation.showPosData[i].interPosData = target.getPosData();
            for(i = 0; target = operation.toHide[i]; i++)operation.toHidePosData[i].interPosData = target.getPosData();
            self.callActions("afterGetInterMixData", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ setFinal: function(operation) {
            var self = this, target = null, i = -1;
            self.callActions("beforeSetFinal", arguments);
            operation.willSort && self.printSort(false, operation);
            for(i = 0; target = operation.toHide[i]; i++)target.hide();
            self.callActions("afterSetFinal", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ getFinalMixData: function(operation) {
            var self = this, parentStyle = null, parentRect = null, target = null, i = -1;
            self.callActions("beforeGetFinalMixData", arguments);
            for(i = 0; target = operation.show[i]; i++)operation.showPosData[i].finalPosData = target.getPosData();
            for(i = 0; target = operation.toHide[i]; i++)operation.toHidePosData[i].finalPosData = target.getPosData();
            // Remove clamping
            if (self.config.animation.clampHeight || self.config.animation.clampWidth) self.dom.parent.style.height = self.dom.parent.style.width = self.dom.parent.style.overflow = "";
            if (!self.incPadding) parentStyle = window1.getComputedStyle(self.dom.parent);
            parentRect = self.dom.parent.getBoundingClientRect();
            operation.newX = parentRect.left;
            operation.newY = parentRect.top;
            operation.newHeight = self.incPadding ? parentRect.height : parentRect.height - parseFloat(parentStyle.paddingTop) - parseFloat(parentStyle.paddingBottom) - parseFloat(parentStyle.borderTop) - parseFloat(parentStyle.borderBottom);
            operation.newWidth = self.incPadding ? parentRect.width : parentRect.width - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight) - parseFloat(parentStyle.borderLeft) - parseFloat(parentStyle.borderRight);
            operation.viewportDeltaX = operation.docState.viewportWidth - this.dom.document.documentElement.clientWidth;
            operation.viewportDeltaY = operation.docState.viewportHeight - this.dom.document.documentElement.clientHeight;
            if (operation.willSort) self.printSort(true, operation);
            for(i = 0; target = operation.toShow[i]; i++)target.hide();
            for(i = 0; target = operation.toHide[i]; i++)target.show();
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, operation.newContainerClassName);
                h.addClass(self.dom.container, self.config.layout.containerClassName);
            }
            self.callActions("afterGetFinalMixData", arguments);
        },
        /**
         * @private
         * @instance
         * @since    3.0.0
         * @param    {Operation}     operation
         */ getTweenData: function(operation) {
            var self = this, target = null, posData = null, effectNames = Object.getOwnPropertyNames(self.effectsIn), effectName = "", effect = null, widthChange = -1, heightChange = -1, i = -1, j = -1;
            self.callActions("beforeGetTweenData", arguments);
            for(i = 0; target = operation.show[i]; i++){
                posData = operation.showPosData[i];
                posData.posIn = new mixitup.StyleData();
                posData.posOut = new mixitup.StyleData();
                posData.tweenData = new mixitup.StyleData();
                // Process x and y
                if (target.isShown) {
                    posData.posIn.x = posData.startPosData.x - posData.interPosData.x;
                    posData.posIn.y = posData.startPosData.y - posData.interPosData.y;
                } else posData.posIn.x = posData.posIn.y = 0;
                posData.posOut.x = posData.finalPosData.x - posData.interPosData.x;
                posData.posOut.y = posData.finalPosData.y - posData.interPosData.y;
                // Process opacity
                posData.posIn.opacity = target.isShown ? 1 : self.effectsIn.opacity;
                posData.posOut.opacity = 1;
                posData.tweenData.opacity = posData.posOut.opacity - posData.posIn.opacity;
                // Adjust x and y if not nudging
                if (!target.isShown && !self.config.animation.nudge) {
                    posData.posIn.x = posData.posOut.x;
                    posData.posIn.y = posData.posOut.y;
                }
                posData.tweenData.x = posData.posOut.x - posData.posIn.x;
                posData.tweenData.y = posData.posOut.y - posData.posIn.y;
                // Process width, height, and margins
                if (self.config.animation.animateResizeTargets) {
                    posData.posIn.width = posData.startPosData.width;
                    posData.posIn.height = posData.startPosData.height;
                    // "||" Prevents width/height change from including 0 width/height if hiding or showing
                    widthChange = (posData.startPosData.width || posData.finalPosData.width) - posData.interPosData.width;
                    posData.posIn.marginRight = posData.startPosData.marginRight - widthChange;
                    heightChange = (posData.startPosData.height || posData.finalPosData.height) - posData.interPosData.height;
                    posData.posIn.marginBottom = posData.startPosData.marginBottom - heightChange;
                    posData.posOut.width = posData.finalPosData.width;
                    posData.posOut.height = posData.finalPosData.height;
                    widthChange = (posData.finalPosData.width || posData.startPosData.width) - posData.interPosData.width;
                    posData.posOut.marginRight = posData.finalPosData.marginRight - widthChange;
                    heightChange = (posData.finalPosData.height || posData.startPosData.height) - posData.interPosData.height;
                    posData.posOut.marginBottom = posData.finalPosData.marginBottom - heightChange;
                    posData.tweenData.width = posData.posOut.width - posData.posIn.width;
                    posData.tweenData.height = posData.posOut.height - posData.posIn.height;
                    posData.tweenData.marginRight = posData.posOut.marginRight - posData.posIn.marginRight;
                    posData.tweenData.marginBottom = posData.posOut.marginBottom - posData.posIn.marginBottom;
                }
                // Process transforms
                for(j = 0; effectName = effectNames[j]; j++){
                    effect = self.effectsIn[effectName];
                    if (!(effect instanceof mixitup.TransformData) || !effect.value) continue;
                    posData.posIn[effectName].value = effect.value;
                    posData.posOut[effectName].value = 0;
                    posData.tweenData[effectName].value = posData.posOut[effectName].value - posData.posIn[effectName].value;
                    posData.posIn[effectName].unit = posData.posOut[effectName].unit = posData.tweenData[effectName].unit = effect.unit;
                }
            }
            for(i = 0; target = operation.toHide[i]; i++){
                posData = operation.toHidePosData[i];
                posData.posIn = new mixitup.StyleData();
                posData.posOut = new mixitup.StyleData();
                posData.tweenData = new mixitup.StyleData();
                // Process x and y
                posData.posIn.x = target.isShown ? posData.startPosData.x - posData.interPosData.x : 0;
                posData.posIn.y = target.isShown ? posData.startPosData.y - posData.interPosData.y : 0;
                posData.posOut.x = self.config.animation.nudge ? 0 : posData.posIn.x;
                posData.posOut.y = self.config.animation.nudge ? 0 : posData.posIn.y;
                posData.tweenData.x = posData.posOut.x - posData.posIn.x;
                posData.tweenData.y = posData.posOut.y - posData.posIn.y;
                // Process width, height, and margins
                if (self.config.animation.animateResizeTargets) {
                    posData.posIn.width = posData.startPosData.width;
                    posData.posIn.height = posData.startPosData.height;
                    widthChange = posData.startPosData.width - posData.interPosData.width;
                    posData.posIn.marginRight = posData.startPosData.marginRight - widthChange;
                    heightChange = posData.startPosData.height - posData.interPosData.height;
                    posData.posIn.marginBottom = posData.startPosData.marginBottom - heightChange;
                }
                // Process opacity
                posData.posIn.opacity = 1;
                posData.posOut.opacity = self.effectsOut.opacity;
                posData.tweenData.opacity = posData.posOut.opacity - posData.posIn.opacity;
                // Process transforms
                for(j = 0; effectName = effectNames[j]; j++){
                    effect = self.effectsOut[effectName];
                    if (!(effect instanceof mixitup.TransformData) || !effect.value) continue;
                    posData.posIn[effectName].value = 0;
                    posData.posOut[effectName].value = effect.value;
                    posData.tweenData[effectName].value = posData.posOut[effectName].value - posData.posIn[effectName].value;
                    posData.posIn[effectName].unit = posData.posOut[effectName].unit = posData.tweenData[effectName].unit = effect.unit;
                }
            }
            self.callActions("afterGetTweenData", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ moveTargets: function(operation) {
            var self = this, target = null, moveData = null, posData = null, statusChange = "", willTransition = false, staggerIndex = -1, i = -1, checkProgress = self.checkProgress.bind(self);
            self.callActions("beforeMoveTargets", arguments);
            // TODO: this is an extra loop in addition to the calcs
            // done in getOperation, could some of this be done there?
            for(i = 0; target = operation.show[i]; i++){
                moveData = new mixitup.IMoveData();
                posData = operation.showPosData[i];
                statusChange = target.isShown ? "none" : "show";
                willTransition = self.willTransition(statusChange, operation.hasEffect, posData.posIn, posData.posOut);
                if (willTransition) // Prevent non-transitioning targets from incrementing the staggerIndex
                staggerIndex++;
                target.show();
                moveData.posIn = posData.posIn;
                moveData.posOut = posData.posOut;
                moveData.statusChange = statusChange;
                moveData.staggerIndex = staggerIndex;
                moveData.operation = operation;
                moveData.callback = willTransition ? checkProgress : null;
                target.move(moveData);
            }
            for(i = 0; target = operation.toHide[i]; i++){
                posData = operation.toHidePosData[i];
                moveData = new mixitup.IMoveData();
                statusChange = "hide";
                willTransition = self.willTransition(statusChange, posData.posIn, posData.posOut);
                moveData.posIn = posData.posIn;
                moveData.posOut = posData.posOut;
                moveData.statusChange = statusChange;
                moveData.staggerIndex = i;
                moveData.operation = operation;
                moveData.callback = willTransition ? checkProgress : null;
                target.move(moveData);
            }
            if (self.config.animation.animateResizeContainer) {
                self.dom.parent.style[mixitup.features.transitionProp] = "height " + self.config.animation.duration + "ms ease, " + "width " + self.config.animation.duration + "ms ease ";
                requestAnimationFrame(function() {
                    if (operation.startHeight !== operation.newHeight && operation.viewportDeltaY !== operation.startHeight - operation.newHeight) self.dom.parent.style.height = operation.newHeight + "px";
                    if (operation.startWidth !== operation.newWidth && operation.viewportDeltaX !== operation.startWidth - operation.newWidth) self.dom.parent.style.width = operation.newWidth + "px";
                });
            }
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, self.config.layout.ContainerClassName);
                h.addClass(self.dom.container, operation.newContainerClassName);
            }
            self.callActions("afterMoveTargets", arguments);
        },
        /**
         * @private
         * @instance
         * @return  {boolean}
         */ hasEffect: function() {
            var self = this, EFFECTABLES = [
                "scale",
                "translateX",
                "translateY",
                "translateZ",
                "rotateX",
                "rotateY",
                "rotateZ"
            ], effectName = "", effect = null, result = false, value = -1, i = -1;
            if (self.effectsIn.opacity !== 1) return self.callFilters("resultHasEffect", true, arguments);
            for(i = 0; effectName = EFFECTABLES[i]; i++){
                effect = self.effectsIn[effectName];
                value = typeof effect && effect.value !== "undefined" ? effect.value : effect;
                if (value !== 0) {
                    result = true;
                    break;
                }
            }
            return self.callFilters("resultHasEffect", result, arguments);
        },
        /**
         * Determines if a target element will transition in
         * some fasion and therefore requires binding of
         * transitionEnd
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}        statusChange
         * @param   {boolean}       hasEffect
         * @param   {StyleData}     posIn
         * @param   {StyleData}     posOut
         * @return  {boolean}
         */ willTransition: function(statusChange, hasEffect, posIn, posOut) {
            var self = this, result = false;
            if (!h.isVisible(self.dom.container)) // If the container is not visible, the transitionEnd
            // event will not occur and MixItUp will hang
            result = false;
            else if (statusChange !== "none" && hasEffect || posIn.x !== posOut.x || posIn.y !== posOut.y) // If opacity and/or translate will change
            result = true;
            else if (self.config.animation.animateResizeTargets) // Check if width, height or margins will change
            result = posIn.width !== posOut.width || posIn.height !== posOut.height || posIn.marginRight !== posOut.marginRight || posIn.marginTop !== posOut.marginTop;
            else result = false;
            return self.callFilters("resultWillTransition", result, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ checkProgress: function(operation) {
            var self = this;
            self.targetsDone++;
            if (self.targetsBound === self.targetsDone) self.cleanUp(operation);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ cleanUp: function(operation) {
            var self = this, target = null, whitespaceBefore = null, whitespaceAfter = null, nextInQueue = null, i = -1;
            self.callActions("beforeCleanUp", arguments);
            self.targetsMoved = self.targetsImmovable = self.targetsBound = self.targetsDone = 0;
            for(i = 0; target = operation.show[i]; i++){
                target.cleanUp();
                target.show();
            }
            for(i = 0; target = operation.toHide[i]; i++){
                target.cleanUp();
                target.hide();
            }
            if (operation.willSort) self.printSort(false, operation);
            // Remove any styles applied to the parent container
            self.dom.parent.style[mixitup.features.transitionProp] = self.dom.parent.style.height = self.dom.parent.style.width = self.dom.parent.style.overflow = self.dom.parent.style[mixitup.features.perspectiveProp] = self.dom.parent.style[mixitup.features.perspectiveOriginProp] = "";
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, operation.startContainerClassName);
                h.addClass(self.dom.container, operation.newContainerClassName);
            }
            if (operation.toRemove.length) {
                for(i = 0; target = self.targets[i]; i++)if (operation.toRemove.indexOf(target) > -1) {
                    if ((whitespaceBefore = target.dom.el.previousSibling) && whitespaceBefore.nodeName === "#text" && (whitespaceAfter = target.dom.el.nextSibling) && whitespaceAfter.nodeName === "#text") h.removeWhitespace(whitespaceBefore);
                    if (!operation.willSort) // NB: Sorting will remove targets as a bi-product of `printSort()`
                    self.dom.parent.removeChild(target.dom.el);
                    self.targets.splice(i, 1);
                    target.isInDom = false;
                    i--;
                }
                // Since targets have been removed, the original order must be updated
                self.origOrder = self.targets;
            }
            if (operation.willSort) self.targets = operation.newOrder;
            self.state = operation.newState;
            self.lastOperation = operation;
            self.dom.targets = self.state.targets;
            // mixEnd
            mixitup.events.fire("mixEnd", self.dom.container, {
                state: self.state,
                instance: self
            }, self.dom.document);
            if (typeof self.config.callbacks.onMixEnd === "function") self.config.callbacks.onMixEnd.call(self.dom.container, self.state, self);
            if (operation.hasFailed) {
                // mixFail
                mixitup.events.fire("mixFail", self.dom.container, {
                    state: self.state,
                    instance: self
                }, self.dom.document);
                if (typeof self.config.callbacks.onMixFail === "function") self.config.callbacks.onMixFail.call(self.dom.container, self.state, self);
                h.addClass(self.dom.container, h.getClassname(self.config.classNames, "container", self.config.classNames.modifierFailed));
            }
            // User-defined callback function
            if (typeof self.userCallback === "function") self.userCallback.call(self.dom.container, self.state, self);
            if (typeof self.userDeferred.resolve === "function") self.userDeferred.resolve(self.state);
            self.userCallback = null;
            self.userDeferred = null;
            self.lastClicked = null;
            self.isToggling = false;
            self.isBusy = false;
            if (self.queue.length) {
                self.callActions("beforeReadQueueCleanUp", arguments);
                nextInQueue = self.queue.shift();
                // Update non-public API properties stored in queue
                self.userDeferred = nextInQueue.deferred;
                self.isToggling = nextInQueue.isToggling;
                self.lastClicked = nextInQueue.triggerElement;
                if (nextInQueue.instruction.command instanceof mixitup.CommandMultimix) self.multimix.apply(self, nextInQueue.args);
                else self.dataset.apply(self, nextInQueue.args);
            }
            self.callActions("afterCleanUp", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseMultimixArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandMultimix();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                if (typeof arg === "object") h.extend(instruction.command, arg);
                else if (typeof arg === "boolean") instruction.animate = arg;
                else if (typeof arg === "function") instruction.callback = arg;
            }
            // Coerce arbitrary command arguments into typed command objects
            if (instruction.command.insert && !(instruction.command.insert instanceof mixitup.CommandInsert)) instruction.command.insert = self.parseInsertArgs([
                instruction.command.insert
            ]).command;
            if (instruction.command.remove && !(instruction.command.remove instanceof mixitup.CommandRemove)) instruction.command.remove = self.parseRemoveArgs([
                instruction.command.remove
            ]).command;
            if (instruction.command.filter && !(instruction.command.filter instanceof mixitup.CommandFilter)) instruction.command.filter = self.parseFilterArgs([
                instruction.command.filter
            ]).command;
            if (instruction.command.sort && !(instruction.command.sort instanceof mixitup.CommandSort)) instruction.command.sort = self.parseSortArgs([
                instruction.command.sort
            ]).command;
            if (instruction.command.changeLayout && !(instruction.command.changeLayout instanceof mixitup.CommandChangeLayout)) instruction.command.changeLayout = self.parseChangeLayoutArgs([
                instruction.command.changeLayout
            ]).command;
            instruction = self.callFilters("instructionParseMultimixArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseFilterArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandFilter();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (typeof arg === "string") // Selector
                instruction.command.selector = arg;
                else if (arg === null) instruction.command.collection = [];
                else if (typeof arg === "object" && h.isElement(arg, self.dom.document)) // Single element
                instruction.command.collection = [
                    arg
                ];
                else if (typeof arg === "object" && typeof arg.length !== "undefined") // Multiple elements in array, NodeList or jQuery collection
                instruction.command.collection = h.arrayFromList(arg);
                else if (typeof arg === "object") // Filter command
                h.extend(instruction.command, arg);
                else if (typeof arg === "boolean") instruction.animate = arg;
                else if (typeof arg === "function") instruction.callback = arg;
            }
            if (instruction.command.selector && instruction.command.collection) throw new Error(mixitup.messages.errorFilterInvalidArguments());
            instruction = self.callFilters("instructionParseFilterArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        parseSortArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, sortString = "", i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandSort();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "string":
                        // Sort string
                        sortString = arg;
                        break;
                    case "object":
                        // Array of element references
                        if (arg.length) instruction.command.collection = h.arrayFromList(arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            if (sortString) instruction.command = self.parseSortString(sortString, instruction.command);
            instruction = self.callFilters("instructionParseSortArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseInsertArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandInsert();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                if (typeof arg === "number") // Insert index
                instruction.command.index = arg;
                else if (typeof arg === "string" && [
                    "before",
                    "after"
                ].indexOf(arg) > -1) // 'before'/'after'
                instruction.command.position = arg;
                else if (typeof arg === "string") // Markup
                instruction.command.collection = h.arrayFromList(h.createElement(arg).childNodes);
                else if (typeof arg === "object" && h.isElement(arg, self.dom.document)) // Single element
                !instruction.command.collection.length ? instruction.command.collection = [
                    arg
                ] : instruction.command.sibling = arg;
                else if (typeof arg === "object" && arg.length) // Multiple elements in array or jQuery collection
                !instruction.command.collection.length ? instruction.command.collection = arg : instruction.command.sibling = arg[0];
                else if (typeof arg === "object" && arg.childNodes && arg.childNodes.length) // Document fragment
                !instruction.command.collection.length ? instruction.command.collection = h.arrayFromList(arg.childNodes) : instruction.command.sibling = arg.childNodes[0];
                else if (typeof arg === "object") // Insert command
                h.extend(instruction.command, arg);
                else if (typeof arg === "boolean") instruction.animate = arg;
                else if (typeof arg === "function") instruction.callback = arg;
            }
            if (instruction.command.index && instruction.command.sibling) throw new Error(mixitup.messages.errorInsertInvalidArguments());
            if (!instruction.command.collection.length && self.config.debug.showWarnings) console.warn(mixitup.messages.warningInsertNoElements());
            instruction = self.callFilters("instructionParseInsertArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseRemoveArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), target = null, arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandRemove();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "number":
                        if (self.targets[arg]) instruction.command.targets[0] = self.targets[arg];
                        break;
                    case "string":
                        instruction.command.collection = h.arrayFromList(self.dom.parent.querySelectorAll(arg));
                        break;
                    case "object":
                        if (arg && arg.length) instruction.command.collection = arg;
                        else if (h.isElement(arg, self.dom.document)) instruction.command.collection = [
                            arg
                        ];
                        else // Remove command
                        h.extend(instruction.command, arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            if (instruction.command.collection.length) {
                for(i = 0; target = self.targets[i]; i++)if (instruction.command.collection.indexOf(target.dom.el) > -1) instruction.command.targets.push(target);
            }
            if (!instruction.command.targets.length && self.config.debug.showWarnings) console.warn(mixitup.messages.warningRemoveNoElements());
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseDatasetArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandDataset();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "object":
                        if (Array.isArray(arg) || typeof arg.length === "number") instruction.command.dataset = arg;
                        else // Change layout command
                        h.extend(instruction.command, arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseChangeLayoutArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandChangeLayout();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "string":
                        instruction.command.containerClassName = arg;
                        break;
                    case "object":
                        // Change layout command
                        h.extend(instruction.command, arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since       3.0.0
         * @param       {mixitup.QueueItem}         queueItem
         * @return      {Promise.<mixitup.State>}
         */ queueMix: function(queueItem) {
            var self = this, deferred = null, toggleSelector = "";
            self.callActions("beforeQueueMix", arguments);
            deferred = h.defer(mixitup.libraries);
            if (self.config.animation.queue && self.queue.length < self.config.animation.queueLimit) {
                queueItem.deferred = deferred;
                self.queue.push(queueItem);
                // Keep controls in sync with user interactions. Mixer will catch up as it drains the queue.
                if (self.config.controls.enable) {
                    if (self.isToggling) {
                        self.buildToggleArray(queueItem.instruction.command);
                        toggleSelector = self.getToggleSelector();
                        self.updateControls({
                            filter: {
                                selector: toggleSelector
                            }
                        });
                    } else self.updateControls(queueItem.instruction.command);
                }
            } else {
                if (self.config.debug.showWarnings) console.warn(mixitup.messages.warningMultimixInstanceQueueFull());
                deferred.resolve(self.state);
                mixitup.events.fire("mixBusy", self.dom.container, {
                    state: self.state,
                    instance: self
                }, self.dom.document);
                if (typeof self.config.callbacks.onMixBusy === "function") self.config.callbacks.onMixBusy.call(self.dom.container, self.state, self);
            }
            return self.callFilters("promiseQueueMix", deferred.promise, arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array.<object>}    newDataset
         * @return  {Operation}
         */ getDataOperation: function(newDataset) {
            var self = this, operation = new mixitup.Operation(), startDataset = [];
            operation = self.callFilters("operationUnmappedGetDataOperation", operation, arguments);
            if (self.dom.targets.length && !(startDataset = self.state.activeDataset || []).length) throw new Error(mixitup.messages.errorDatasetNotSet());
            operation.id = h.randomHex();
            operation.startState = self.state;
            operation.startDataset = startDataset;
            operation.newDataset = newDataset.slice();
            self.diffDatasets(operation);
            operation.startOrder = self.targets;
            operation.newOrder = operation.show;
            if (self.config.animation.enable) {
                self.getStartMixData(operation);
                self.setInter(operation);
                operation.docState = h.getDocumentState(self.dom.document);
                self.getInterMixData(operation);
                self.setFinal(operation);
                self.getFinalMixData(operation);
                self.parseEffects();
                operation.hasEffect = self.hasEffect();
                self.getTweenData(operation);
            }
            self.targets = operation.show.slice();
            operation.newState = self.buildState(operation);
            // NB: Targets to be removed must be included in `self.targets` for removal during clean up,
            // but are added after state is built so that state is accurate
            Array.prototype.push.apply(self.targets, operation.toRemove);
            operation = self.callFilters("operationMappedGetDataOperation", operation, arguments);
            return operation;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.Operation} operation
         * @return  {void}
         */ diffDatasets: function(operation) {
            var self = this, persistantStartIds = [], persistantNewIds = [], insertedTargets = [], data = null, target = null, el = null, frag = null, nextEl = null, uids = {}, id = "", i = -1;
            self.callActions("beforeDiffDatasets", arguments);
            for(i = 0; data = operation.newDataset[i]; i++){
                if (typeof (id = data[self.config.data.uidKey]) === "undefined" || id.toString().length < 1) throw new TypeError(mixitup.messages.errorDatasetInvalidUidKey({
                    uidKey: self.config.data.uidKey
                }));
                if (!uids[id]) uids[id] = true;
                else throw new Error(mixitup.messages.errorDatasetDuplicateUid({
                    uid: id
                }));
                if ((target = self.cache[id]) instanceof mixitup.Target) {
                    // Already in cache
                    if (self.config.data.dirtyCheck && !h.deepEquals(data, target.data)) {
                        // change detected
                        el = target.render(data);
                        target.data = data;
                        if (el !== target.dom.el) {
                            // Update target element reference
                            if (target.isInDom) {
                                target.unbindEvents();
                                self.dom.parent.replaceChild(el, target.dom.el);
                            }
                            if (!target.isShown) el.style.display = "none";
                            target.dom.el = el;
                            if (target.isInDom) target.bindEvents();
                        }
                    }
                    el = target.dom.el;
                } else {
                    // New target
                    target = new mixitup.Target();
                    target.init(null, self, data);
                    target.hide();
                }
                if (!target.isInDom) {
                    // Adding to DOM
                    if (!frag) // Open frag
                    frag = self.dom.document.createDocumentFragment();
                    if (frag.lastElementChild) frag.appendChild(self.dom.document.createTextNode(" "));
                    frag.appendChild(target.dom.el);
                    target.isInDom = true;
                    target.unbindEvents();
                    target.bindEvents();
                    target.hide();
                    operation.toShow.push(target);
                    insertedTargets.push(target);
                } else {
                    // Already in DOM
                    nextEl = target.dom.el.nextElementSibling;
                    persistantNewIds.push(id);
                    if (frag) {
                        // Close and insert previously opened frag
                        if (frag.lastElementChild) frag.appendChild(self.dom.document.createTextNode(" "));
                        self.insertDatasetFrag(frag, target.dom.el, insertedTargets);
                        frag = null;
                    }
                }
                operation.show.push(target);
            }
            if (frag) {
                // Unclosed frag remaining
                nextEl = nextEl || self.config.layout.siblingAfter;
                if (nextEl) frag.appendChild(self.dom.document.createTextNode(" "));
                self.insertDatasetFrag(frag, nextEl, insertedTargets);
            }
            for(i = 0; data = operation.startDataset[i]; i++){
                id = data[self.config.data.uidKey];
                target = self.cache[id];
                if (operation.show.indexOf(target) < 0) {
                    // Previously shown but now absent
                    operation.hide.push(target);
                    operation.toHide.push(target);
                    operation.toRemove.push(target);
                } else persistantStartIds.push(id);
            }
            if (!h.isEqualArray(persistantStartIds, persistantNewIds)) operation.willSort = true;
            self.callActions("afterDiffDatasets", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.1.5
         * @param   {DocumentFragment}          frag
         * @param   {(HTMLElement|null)}        nextEl
         * @param   {Array.<mixitup.Target>}    targets
         * @return  {void}
         */ insertDatasetFrag: function(frag, nextEl, targets) {
            var self = this;
            var insertAt = nextEl ? h.arrayFromList(self.dom.parent.children).indexOf(nextEl) : self.targets.length;
            self.dom.parent.insertBefore(frag, nextEl);
            while(targets.length){
                self.targets.splice(insertAt, 0, targets.shift());
                insertAt++;
            }
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.CommandSort} sortCommandA
         * @param   {mixitup.CommandSort} sortCommandB
         * @return  {boolean}
         */ willSort: function(sortCommandA, sortCommandB) {
            var self = this, result = false;
            if (self.config.behavior.liveSort || sortCommandA.order === "random" || sortCommandA.attribute !== sortCommandB.attribute || sortCommandA.order !== sortCommandB.order || sortCommandA.collection !== sortCommandB.collection || sortCommandA.next === null && sortCommandB.next || sortCommandA.next && sortCommandB.next === null) result = true;
            else if (sortCommandA.next && sortCommandB.next) result = self.willSort(sortCommandA.next, sortCommandB.next);
            else result = false;
            return self.callFilters("resultWillSort", result, arguments);
        },
        /**
         * A shorthand method for `.filter('all')`. Shows all targets in the container.
         *
         * @example
         *
         * .show()
         *
         * @example <caption>Example: Showing all targets</caption>
         *
         * mixer.show()
         *     .then(function(state) {
         *         console.log(state.totalShow === state.totalTargets); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @return      {Promise.<mixitup.State>}
         */ show: function() {
            var self = this;
            return self.filter("all");
        },
        /**
         * A shorthand method for `.filter('none')`. Hides all targets in the container.
         *
         * @example
         *
         * .hide()
         *
         * @example <caption>Example: Hiding all targets</caption>
         *
         * mixer.hide()
         *     .then(function(state) {
         *         console.log(state.totalShow === 0); // true
         *         console.log(state.totalHide === state.totalTargets); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @return      {Promise.<mixitup.State>}
         */ hide: function() {
            var self = this;
            return self.filter("none");
        },
        /**
         * Returns a boolean indicating whether or not a MixItUp operation is
         * currently in progress.
         *
         * @example
         *
         * .isMixing()
         *
         * @example <caption>Example: Checking the status of a mixer</caption>
         *
         * mixer.sort('random', function() {
         *     console.log(mixer.isMixing()) // false
         * });
         *
         * console.log(mixer.isMixing()) // true
         *
         * @public
         * @instance
         * @since   2.0.0
         * @return  {boolean}
         */ isMixing: function() {
            var self = this;
            return self.isBusy;
        },
        /**
         * Filters all targets in the container by a provided selector string, or the values `'all'`
         * or `'none'`. Only targets matching the selector will be shown.
         *
         * @example
         *
         * .filter(selector [, animate] [, callback])
         *
         * @example <caption>Example 1: Filtering targets by a class selector</caption>
         *
         * mixer.filter('.category-a')
         *     .then(function(state) {
         *         console.log(state.totalShow === containerEl.querySelectorAll('.category-a').length); // true
         *     });
         *
         * @example <caption>Example 2: Filtering targets by an attribute selector</caption>
         *
         * mixer.filter('[data-category~="a"]')
         *     .then(function(state) {
         *         console.log(state.totalShow === containerEl.querySelectorAll('[data-category~="a"]').length); // true
         *     });
         *
         * @example <caption>Example 3: Filtering targets by a compound selector</caption>
         *
         * // Show only those targets with the classes 'category-a' AND 'category-b'
         *
         * mixer.filter('.category-a.category-c')
         *     .then(function(state) {
         *         console.log(state.totalShow === containerEl.querySelectorAll('.category-a.category-c').length); // true
         *     });
         *
         * @example <caption>Example 4: Filtering via an element collection</caption>
         *
         * var collection = Array.from(container.querySelectorAll('.mix'));
         *
         * console.log(collection.length); // 34
         *
         * // Filter the collection manually using Array.prototype.filter
         *
         * var filtered = collection.filter(function(target) {
         *    return parseInt(target.getAttribute('data-price')) > 10;
         * });
         *
         * console.log(filtered.length); // 22
         *
         * // Pass the filtered collection to MixItUp
         *
         * mixer.filter(filtered)
         *    .then(function(state) {
         *        console.log(state.activeFilter.collection.length === 22); // true
         *    });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {(string|HTMLElement|Array.<HTMLElement>)} selector
         *      Any valid CSS selector (i.e. `'.category-a'`), or the values `'all'` or `'none'`. The filter method also accepts a reference to single target element or a collection of target elements to show.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ filter: function() {
            var self = this, instruction = self.parseFilterArgs(arguments);
            return self.multimix({
                filter: instruction.command
            }, instruction.animate, instruction.callback);
        },
        /**
         * Adds an additional selector to the currently active filter selector, concatenating
         * as per the logic defined in `controls.toggleLogic`.
         *
         * @example
         *
         * .toggleOn(selector [, animate] [, callback])
         *
         * @example <caption>Example: Toggling on a filter selector</caption>
         *
         * console.log(mixer.getState().activeFilter.selector); // '.category-a'
         *
         * mixer.toggleOn('.category-b')
         *     .then(function(state) {
         *         console.log(state.activeFilter.selector); // '.category-a, .category-b'
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {string}    selector
         *      Any valid CSS selector (i.e. `'.category-a'`)
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ toggleOn: function() {
            var self = this, instruction = self.parseFilterArgs(arguments), selector = instruction.command.selector, toggleSelector = "";
            self.isToggling = true;
            if (self.toggleArray.indexOf(selector) < 0) self.toggleArray.push(selector);
            toggleSelector = self.getToggleSelector();
            return self.multimix({
                filter: toggleSelector
            }, instruction.animate, instruction.callback);
        },
        /**
         * Removes a selector from the active filter selector.
         *
         * @example
         *
         * .toggleOff(selector [, animate] [, callback])
         *
         * @example <caption>Example: Toggling off a filter selector</caption>
         *
         * console.log(mixer.getState().activeFilter.selector); // '.category-a, .category-b'
         *
         * mixer.toggleOff('.category-b')
         *     .then(function(state) {
         *         console.log(state.activeFilter.selector); // '.category-a'
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {string}    selector
         *      Any valid CSS selector (i.e. `'.category-a'`)
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ toggleOff: function() {
            var self = this, instruction = self.parseFilterArgs(arguments), selector = instruction.command.selector, selectorIndex = self.toggleArray.indexOf(selector), toggleSelector = "";
            self.isToggling = true;
            if (selectorIndex > -1) self.toggleArray.splice(selectorIndex, 1);
            toggleSelector = self.getToggleSelector();
            return self.multimix({
                filter: toggleSelector
            }, instruction.animate, instruction.callback);
        },
        /**
         * Sorts all targets in the container according to a provided sort string.
         *
         * @example
         *
         * .sort(sortString [, animate] [, callback])
         *
         * @example <caption>Example 1: Sorting by the default DOM order</caption>
         *
         * // Reverse the default order of the targets
         *
         * mixer.sort('default:desc')
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'default'); // true
         *         console.log(state.activeSort.order === 'desc'); // true
         *     });
         *
         * @example <caption>Example 2: Sorting by a custom data-attribute</caption>
         *
         * // Sort the targets by the value of a `data-published-date` attribute
         *
         * mixer.sort('published-date:asc')
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *         console.log(state.activeSort.order === 'asc'); // true
         *     });
         *
         * @example <caption>Example 3: Sorting by multiple attributes</caption>
         *
         * // Sort the targets by the value of a `data-published-date` attribute, then by `data-title`
         *
         * mixer.sort('published-date:desc data-title:asc')
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *         console.log(state.activeSort.order === 'desc'); // true
         *
         *         console.log(state.activeSort.next.attribute === 'title'); // true
         *         console.log(state.activeSort.next.order === 'asc'); // true
         *     });
         *
         * @example <caption>Example 4: Sorting by random</caption>
         *
         * mixer.sort('random')
         *     .then(function(state) {
         *         console.log(state.activeSort.order === 'random') // true
         *     });
         *
         * @example <caption>Example 5: Sorting via an element collection</caption>
         *
         * var collection = Array.from(container.querySelectorAll('.mix'));
         *
         * // Swap the position of two elements in the collection:
         *
         * var temp = collection[1];
         *
         * collection[1] = collection[0];
         * collection[0] = temp;
         *
         * // Pass the sorted collection to MixItUp
         *
         * mixer.sort(collection)
         *     .then(function(state) {
         *         console.log(state.targets[0] === collection[0]); // true
         *     });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {(string|Array.<HTMLElement>)}    sortString
         *      A valid sort string (e.g. `'default'`, `'published-date:asc'`, or `'random'`). The sort method also accepts an array of all target elements in a user-defined order.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ sort: function() {
            var self = this, instruction = self.parseSortArgs(arguments);
            return self.multimix({
                sort: instruction.command
            }, instruction.animate, instruction.callback);
        },
        /**
         * Changes the layout of the container by adding, removing or updating a
         * layout-specific class name. If `animation.animateResizetargets` is
         * enabled, MixItUp will attempt to gracefully animate the width, height,
         * and position of targets between layout states.
         *
         * @example
         *
         * .changeLayout(containerClassName [, animate] [, callback])
         *
         * @example <caption>Example 1: Adding a new class name to the container</caption>
         *
         * mixer.changeLayout('container-list')
         *      .then(function(state) {
         *          console.log(state.activeContainerClass === 'container-list'); // true
         *      });
         *
         * @example <caption>Example 2: Removing a previously added class name from the container</caption>
         *
         * mixer.changeLayout('')
         *      .then(function(state) {
         *          console.log(state.activeContainerClass === ''); // true
         *      });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {string}    containerClassName
         *      A layout-specific class name to add to the container.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ changeLayout: function() {
            var self = this, instruction = self.parseChangeLayoutArgs(arguments);
            return self.multimix({
                changeLayout: instruction.command
            }, instruction.animate, instruction.callback);
        },
        /**
         * Updates the contents and order of the container to reflect the provided dataset,
         * if the dataset API is in use.
         *
         * The dataset API is designed for use in API-driven JavaScript applications, and
         * can be used instead of DOM-based methods such as `.filter()`, `.sort()`,
         * `.insert()`, etc. When used, insertion, removal, sorting and pagination can be
         * achieved purely via changes to your data model, without the uglyness of having
         * to interact with or query the DOM directly.
         *
         * @example
         *
         * .dataset(dataset [, animate] [, callback])
         *
         * @example <caption>Example 1: Rendering a dataset</caption>
         *
         * var myDataset = [
         *     {id: 1, ...},
         *     {id: 2, ...},
         *     {id: 3, ...}
         * ];
         *
         * mixer.dataset(myDataset)
         *     .then(function(state) {
         *         console.log(state.totalShow === 3); // true
         *     });
         *
         * @example <caption>Example 2: Sorting a dataset</caption>
         *
         * // Create a new dataset in reverse order
         *
         * var newDataset = myDataset.slice().reverse();
         *
         * mixer.dataset(newDataset)
         *     .then(function(state) {
         *         console.log(state.activeDataset[0] === myDataset[2]); // true
         *     });
         *
         * @example <caption>Example 3: Removing an item from the dataset</caption>
         *
         * console.log(myDataset.length); // 3
         *
         * // Create a new dataset with the last item removed.
         *
         * var newDataset = myDataset.slice().pop();
         *
         * mixer.dataset(newDataset)
         *     .then(function(state) {
         *         console.log(state.totalShow === 2); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {Array.<object>}    dataset
         *      An array of objects, each one representing the underlying data model of a target to be rendered.
         * @param       {boolean}           [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}          [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ dataset: function() {
            var self = this, instruction = self.parseDatasetArgs(arguments), operation = null, queueItem = null, animate = false;
            self.callActions("beforeDataset", arguments);
            if (!self.isBusy) {
                if (instruction.callback) self.userCallback = instruction.callback;
                animate = instruction.animate ^ self.config.animation.enable ? instruction.animate : self.config.animation.enable;
                operation = self.getDataOperation(instruction.command.dataset);
                return self.goMix(animate, operation);
            } else {
                queueItem = new mixitup.QueueItem();
                queueItem.args = arguments;
                queueItem.instruction = instruction;
                return self.queueMix(queueItem);
            }
        },
        /**
         * Performs simultaneous `filter`, `sort`, `insert`, `remove` and `changeLayout`
         * operations as requested.
         *
         * @example
         *
         * .multimix(multimixCommand [, animate] [, callback])
         *
         * @example <caption>Example 1: Performing simultaneous filtering and sorting</caption>
         *
         * mixer.multimix({
         *     filter: '.category-b',
         *     sort: 'published-date:desc'
         * })
         *     .then(function(state) {
         *         console.log(state.activeFilter.selector === '.category-b'); // true
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *     });
         *
         * @example <caption>Example 2: Performing simultaneous sorting, insertion, and removal</caption>
         *
         * console.log(mixer.getState().totalShow); // 6
         *
         * // NB: When inserting via `multimix()`, an object should be provided as the value
         * // for the `insert` portion of the command, allowing for a collection of elements
         * // and an insertion index to be specified.
         *
         * mixer.multimix({
         *     sort: 'published-date:desc', // Sort the container, including any new elements
         *     insert: {
         *         collection: [newElementReferenceA, newElementReferenceB], // Add 2 new elements at index 5
         *         index: 5
         *     },
         *     remove: existingElementReference // Remove 1 existing element
         * })
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *         console.log(state.totalShow === 7); // true
         *     });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {object}    multimixCommand
         *      An object containing one or more things to do
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ multimix: function() {
            var self = this, operation = null, animate = false, queueItem = null, instruction = self.parseMultimixArgs(arguments);
            self.callActions("beforeMultimix", arguments);
            if (!self.isBusy) {
                operation = self.getOperation(instruction.command);
                if (self.config.controls.enable) {
                    // Update controls for API calls
                    if (instruction.command.filter && !self.isToggling) {
                        // As we are not toggling, reset the toggle array
                        // so new filter overrides existing toggles
                        self.toggleArray.length = 0;
                        self.buildToggleArray(operation.command);
                    }
                    if (self.queue.length < 1) self.updateControls(operation.command);
                }
                if (instruction.callback) self.userCallback = instruction.callback;
                // Always allow the instruction to override the instance setting
                animate = instruction.animate ^ self.config.animation.enable ? instruction.animate : self.config.animation.enable;
                self.callFilters("operationMultimix", operation, arguments);
                return self.goMix(animate, operation);
            } else {
                queueItem = new mixitup.QueueItem();
                queueItem.args = arguments;
                queueItem.instruction = instruction;
                queueItem.triggerElement = self.lastClicked;
                queueItem.isToggling = self.isToggling;
                return self.queueMix(queueItem);
            }
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {object}            multimixCommand
         * @param   {boolean}           [isPreFetch]
         *      An optional boolean indicating that the operation is being pre-fetched for execution at a later time.
         * @return  {Operation|null}
         */ getOperation: function(multimixCommand) {
            var self = this, sortCommand = multimixCommand.sort, filterCommand = multimixCommand.filter, changeLayoutCommand = multimixCommand.changeLayout, removeCommand = multimixCommand.remove, insertCommand = multimixCommand.insert, operation = new mixitup.Operation();
            operation = self.callFilters("operationUnmappedGetOperation", operation, arguments);
            operation.id = h.randomHex();
            operation.command = multimixCommand;
            operation.startState = self.state;
            operation.triggerElement = self.lastClicked;
            if (self.isBusy) {
                if (self.config.debug.showWarnings) console.warn(mixitup.messages.warningGetOperationInstanceBusy());
                return null;
            }
            if (insertCommand) self.insertTargets(insertCommand, operation);
            if (removeCommand) operation.toRemove = removeCommand.targets;
            operation.startSort = operation.newSort = operation.startState.activeSort;
            operation.startOrder = operation.newOrder = self.targets;
            if (sortCommand) {
                operation.startSort = operation.startState.activeSort;
                operation.newSort = sortCommand;
                operation.willSort = self.willSort(sortCommand, operation.startState.activeSort);
                if (operation.willSort) self.sortOperation(operation);
            }
            operation.startFilter = operation.startState.activeFilter;
            if (filterCommand) operation.newFilter = filterCommand;
            else operation.newFilter = h.extend(new mixitup.CommandFilter(), operation.startFilter);
            if (operation.newFilter.selector === "all") operation.newFilter.selector = self.config.selectors.target;
            else if (operation.newFilter.selector === "none") operation.newFilter.selector = "";
            self.filterOperation(operation);
            operation.startContainerClassName = operation.startState.activeContainerClassName;
            if (changeLayoutCommand) {
                operation.newContainerClassName = changeLayoutCommand.containerClassName;
                if (operation.newContainerClassName !== operation.startContainerClassName) operation.willChangeLayout = true;
            } else operation.newContainerClassName = operation.startContainerClassName;
            if (self.config.animation.enable) {
                // Populate the operation's position data
                self.getStartMixData(operation);
                self.setInter(operation);
                operation.docState = h.getDocumentState(self.dom.document);
                self.getInterMixData(operation);
                self.setFinal(operation);
                self.getFinalMixData(operation);
                self.parseEffects();
                operation.hasEffect = self.hasEffect();
                self.getTweenData(operation);
            }
            if (operation.willSort) self.targets = operation.newOrder;
            operation.newState = self.buildState(operation);
            return self.callFilters("operationMappedGetOperation", operation, arguments);
        },
        /**
         * Renders a previously created operation at a specific point in its path, as
         * determined by a multiplier between 0 and 1.
         *
         * @example
         * .tween(operation, multiplier)
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.Operation}     operation
         *      An operation object created via the `getOperation` method
         *
         * @param   {Float}                 multiplier
         *      Any number between 0 and 1 representing the percentage complete of the operation
         * @return  {void}
         */ tween: function(operation, multiplier) {
            var target = null, posData = null, toHideIndex = -1, i = -1;
            multiplier = Math.min(multiplier, 1);
            multiplier = Math.max(multiplier, 0);
            for(i = 0; target = operation.show[i]; i++){
                posData = operation.showPosData[i];
                target.applyTween(posData, multiplier);
            }
            for(i = 0; target = operation.hide[i]; i++){
                if (target.isShown) target.hide();
                if ((toHideIndex = operation.toHide.indexOf(target)) > -1) {
                    posData = operation.toHidePosData[toHideIndex];
                    if (!target.isShown) target.show();
                    target.applyTween(posData, multiplier);
                }
            }
        },
        /**
         * Inserts one or more new target elements into the container at a specified
         * index.
         *
         * To be indexed as targets, new elements must match the `selectors.target`
         * selector (`'.mix'` by default).
         *
         * @example
         *
         * .insert(newElements [, index] [, animate], [, callback])
         *
         * @example <caption>Example 1: Inserting a single element via reference</caption>
         *
         * console.log(mixer.getState().totalShow); // 0
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * mixer.insert(newElement)
         *     .then(function(state) {
         *         console.log(state.totalShow === 1); // true
         *     });
         *
         * @example <caption>Example 2: Inserting a single element via HTML string</caption>
         *
         * console.log(mixer.getState().totalShow); // 1
         *
         * // Create a new element via reference
         *
         * var newElementHtml = '&lt;div class="mix"&gt;&lt;/div&gt;';
         *
         * // Create and insert the new element at index 1
         *
         * mixer.insert(newElementHtml, 1)
         *     .then(function(state) {
         *         console.log(state.totalShow === 2); // true
         *         console.log(state.show[1].outerHTML === newElementHtml); // true
         *     });
         *
         * @example <caption>Example 3: Inserting multiple elements via reference</caption>
         *
         * console.log(mixer.getState().totalShow); // 2
         *
         * // Create an array of new elements to insert.
         *
         * var newElement1 = document.createElement('div');
         * var newElement2 = document.createElement('div');
         *
         * newElement1.classList.add('mix');
         * newElement2.classList.add('mix');
         *
         * var newElementsCollection = [newElement1, newElement2];
         *
         * // Insert the new elements starting at index 1
         *
         * mixer.insert(newElementsCollection, 1)
         *     .then(function(state) {
         *         console.log(state.totalShow === 4); // true
         *         console.log(state.show[1] === newElement1); // true
         *         console.log(state.show[2] === newElement2); // true
         *     });
         *
         * @example <caption>Example 4: Inserting a jQuery collection object containing one or more elements</caption>
         *
         * console.log(mixer.getState().totalShow); // 4
         *
         * var $newElement = $('&lt;div class="mix"&gt;&lt;/div&gt;');
         *
         * // Insert the new elements starting at index 3
         *
         * mixer.insert($newElement, 3)
         *     .then(function(state) {
         *         console.log(state.totalShow === 5); // true
         *         console.log(state.show[3] === $newElement[0]); // true
         *     });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {number}    index=0
         *      The index at which to insert the new element(s). `0` by default.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ insert: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.multimix({
                insert: args.command
            }, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements before a provided reference element.
         *
         * @example
         *
         * .insertBefore(newElements, referenceElement [, animate] [, callback])
         *
         * @example <caption>Example: Inserting a new element before a reference element</caption>
         *
         * // An existing reference element is chosen at index 2
         *
         * var referenceElement = mixer.getState().show[2];
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * mixer.insertBefore(newElement, referenceElement)
         *     .then(function(state) {
         *         // The new element is inserted into the container at index 2, before the reference element
         *
         *         console.log(state.show[2] === newElement); // true
         *
         *         // The reference element is now at index 3
         *
         *         console.log(state.show[3] === referenceElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {HTMLElement}    referenceElement
         *      A reference to an existing element in the container to insert new elements before.
         *@param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ insertBefore: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(args.command.collection, "before", args.command.sibling, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements after a provided reference element.
         *
         * @example
         *
         * .insertAfter(newElements, referenceElement [, animate] [, callback])
         *
         * @example <caption>Example: Inserting a new element after a reference element</caption>
         *
         * // An existing reference element is chosen at index 2
         *
         * var referenceElement = mixer.getState().show[2];
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * mixer.insertAfter(newElement, referenceElement)
         *     .then(function(state) {
         *         // The new element is inserted into the container at index 3, after the reference element
         *
         *         console.log(state.show[3] === newElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {HTMLElement}    referenceElement
         *      A reference to an existing element in the container to insert new elements after.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ insertAfter: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(args.command.collection, "after", args.command.sibling, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements into the container before all existing targets.
         *
         * @example
         *
         * .prepend(newElements [,animate] [,callback])
         *
         * @example <caption>Example: Prepending a new element</caption>
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * // Insert the element into the container
         *
         * mixer.prepend(newElement)
         *     .then(function(state) {
         *         console.log(state.show[0] === newElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ prepend: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(0, args.command.collection, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements into the container after all existing targets.
         *
         * @example
         *
         * .append(newElements [,animate] [,callback])
         *
         * @example <caption>Example: Appending a new element</caption>
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * // Insert the element into the container
         *
         * mixer.append(newElement)
         *     .then(function(state) {
         *         console.log(state.show[state.show.length - 1] === newElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ append: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(self.state.totalTargets, args.command.collection, args.animate, args.callback);
        },
        /**
         * Removes one or more existing target elements from the container.
         *
         * @example
         *
         * .remove(elements [, animate] [, callback])
         *
         * @example <caption>Example 1: Removing an element by reference</caption>
         *
         * var elementToRemove = containerEl.firstElementChild;
         *
         * mixer.remove(elementToRemove)
         *      .then(function(state) {
         *          console.log(state.targets.indexOf(elementToRemove) === -1); // true
         *      });
         *
         * @example <caption>Example 2: Removing a collection of elements by reference</caption>
         *
         * var elementsToRemove = containerEl.querySelectorAll('.category-a');
         *
         * console.log(elementsToRemove.length) // 3
         *
         * mixer.remove(elementsToRemove)
         *      .then(function() {
         *          console.log(containerEl.querySelectorAll('.category-a').length); // 0
         *      });
         *
         * @example <caption>Example 3: Removing one or more elements by selector</caption>
         *
         * mixer.remove('.category-a')
         *      .then(function() {
         *          console.log(containerEl.querySelectorAll('.category-a').length); // 0
         *      });
         *
         * @example <caption>Example 4: Removing an element by index</caption>
         *
         * console.log(mixer.getState.totalShow); // 4
         *
         * // Remove the element at index 3
         *
         * mixer.remove(3)
         *      .then(function(state) {
         *          console.log(state.totalShow); // 3
         *          console.log(state.show[3]); // undefined
         *      });
         *
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string|number)}    elements
         *      A reference to a single element to remove, an array-like collection of elements, a selector string, or the index of an element to remove.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ remove: function() {
            var self = this, args = self.parseRemoveArgs(arguments);
            return self.multimix({
                remove: args.command
            }, args.animate, args.callback);
        },
        /**
         * Retrieves the the value of any property or sub-object within the current
         * mixitup configuration, or the whole configuration object.
         *
         * @example
         *
         * .getConfig([stringKey])
         *
         * @example <caption>Example 1: retrieve the entire configuration object</caption>
         *
         * var config = mixer.getConfig(); // Config { ... }
         *
         * @example <caption>Example 2: retrieve a named sub-object of configuration object</caption>
         *
         * var animation = mixer.getConfig('animation'); // ConfigAnimation { ... }
         *
         * @example <caption>Example 3: retrieve a value of configuration object via a dot-notation string key</caption>
         *
         * var effects = mixer.getConfig('animation.effects'); // 'fade scale'
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {string}    [stringKey]    A "dot-notation" string key
         * @return      {*}
         */ getConfig: function(stringKey) {
            var self = this, value = null;
            if (!stringKey) value = self.config;
            else value = h.getProperty(self.config, stringKey);
            return self.callFilters("valueGetConfig", value, arguments);
        },
        /**
         * Updates the configuration of the mixer, after it has been instantiated.
         *
         * See the Configuration Object documentation for a full list of avilable
         * configuration options.
         *
         * @example
         *
         * .configure(config)
         *
         * @example <caption>Example 1: Updating animation options</caption>
         *
         * mixer.configure({
         *     animation: {
         *         effects: 'fade translateX(-100%)',
         *         duration: 300
         *     }
         * });
         *
         * @example <caption>Example 2: Removing a callback after it has been set</caption>
         *
         * var mixer;
         *
         * function handleMixEndOnce() {
         *     // Do something ..
         *
         *     // Then nullify the callback
         *
         *     mixer.configure({
         *         callbacks: {
         *             onMixEnd: null
         *         }
         *     });
         * };
         *
         * // Instantiate a mixer with a callback defined
         *
         * mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixEnd: handleMixEndOnce
         *     }
         * });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {object}    config
         *      An object containing one of more configuration options.
         * @return      {void}
         */ configure: function(config) {
            var self = this;
            self.callActions("beforeConfigure", arguments);
            h.extend(self.config, config, true, true);
            self.callActions("afterConfigure", arguments);
        },
        /**
         * Returns an object containing information about the current state of the
         * mixer. See the State Object documentation for more information.
         *
         * NB: State objects are immutable and should therefore be regenerated
         * after any operation.
         *
         * @example
         *
         * .getState();
         *
         * @example <caption>Example: Retrieving a state object</caption>
         *
         * var state = mixer.getState();
         *
         * console.log(state.totalShow + 'targets are currently shown');
         *
         * @public
         * @instance
         * @since       2.0.0
         * @return      {mixitup.State} An object reflecting the current state of the mixer.
         */ getState: function() {
            var self = this, state = null;
            state = new mixitup.State();
            h.extend(state, self.state);
            h.freeze(state);
            return self.callFilters("stateGetState", state, arguments);
        },
        /**
         * Forces the re-indexing all targets within the container.
         *
         * This should only be used if some other piece of code in your application
         * has manipulated the contents of your container, which should be avoided.
         *
         * If you need to add or remove target elements from the container, use
         * the built-in `.insert()` or `.remove()` methods, and MixItUp will keep
         * itself up to date.
         *
         * @example
         *
         * .forceRefresh()
         *
         * @example <caption>Example: Force refreshing the mixer after external DOM manipulation</caption>
         *
         * console.log(mixer.getState().totalShow); // 3
         *
         * // An element is removed from the container via some external DOM manipulation code:
         *
         * containerEl.removeChild(containerEl.firstElementChild);
         *
         * // The mixer does not know that the number of targets has changed:
         *
         * console.log(mixer.getState().totalShow); // 3
         *
         * mixer.forceRefresh();
         *
         * // After forceRefresh, the mixer is in sync again:
         *
         * console.log(mixer.getState().totalShow); // 2
         *
         * @public
         * @instance
         * @since 2.1.2
         * @return {void}
         */ forceRefresh: function() {
            var self = this;
            self.indexTargets();
        },
        /**
         * Forces the re-rendering of all targets when using the Dataset API.
         *
         * By default, targets are only re-rendered when `data.dirtyCheck` is
         * enabled, and an item's data has changed when `dataset()` is called.
         *
         * The `forceRender()` method allows for the re-rendering of all targets
         * in response to some arbitrary event, such as the changing of the target
         * render function.
         *
         * Targets are rendered against their existing data.
         *
         * @example
         *
         * .forceRender()
         *
         * @example <caption>Example: Force render targets after changing the target render function</caption>
         *
         * console.log(container.innerHTML); // ... &lt;span class="mix"&gt;Foo&lt;/span&gt; ...
         *
         * mixer.configure({
         *     render: {
         *         target: (item) => `&lt;a href="/${item.slug}/" class="mix"&gt;${item.title}&lt;/a&gt;`
         *     }
         * });
         *
         * mixer.forceRender();
         *
         * console.log(container.innerHTML); // ... &lt;a href="/foo/" class="mix"&gt;Foo&lt;/a&gt; ...
         *
         * @public
         * @instance
         * @since 3.2.1
         * @return {void}
         */ forceRender: function() {
            var self = this, target = null, el = null, id = "";
            for(id in self.cache){
                target = self.cache[id];
                el = target.render(target.data);
                if (el !== target.dom.el) {
                    // Update target element reference
                    if (target.isInDom) {
                        target.unbindEvents();
                        self.dom.parent.replaceChild(el, target.dom.el);
                    }
                    if (!target.isShown) el.style.display = "none";
                    target.dom.el = el;
                    if (target.isInDom) target.bindEvents();
                }
            }
            self.state = self.buildState(self.lastOperation);
        },
        /**
         * Removes mixitup functionality from the container, unbinds all control
         * event handlers, and deletes the mixer instance from MixItUp's internal
         * cache.
         *
         * This should be performed whenever a mixer's container is removed from
         * the DOM, such as during a page change in a single page application,
         * or React's `componentWillUnmount()`.
         *
         * @example
         *
         * .destroy([cleanUp])
         *
         * @example <caption>Example: Destroying the mixer before removing its container element</caption>
         *
         * mixer.destroy();
         *
         * containerEl.parentElement.removeChild(containerEl);
         *
         * @public
         * @instance
         * @since   2.0.0
         * @param   {boolean}   [cleanUp=false]
         *     An optional boolean dictating whether or not to clean up any inline `display: none;` styling applied to hidden targets.
         * @return  {void}
         */ destroy: function(cleanUp) {
            var self = this, control = null, target = null, i = 0;
            self.callActions("beforeDestroy", arguments);
            for(i = 0; control = self.controls[i]; i++)control.removeBinding(self);
            for(i = 0; target = self.targets[i]; i++){
                if (cleanUp) target.show();
                target.unbindEvents();
            }
            if (self.dom.container.id.match(/^MixItUp/)) self.dom.container.removeAttribute("id");
            delete mixitup.instances[self.id];
            self.callActions("afterDestroy", arguments);
        }
    });
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.IMoveData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.posIn = null;
        this.posOut = null;
        this.operation = null;
        this.callback = null;
        this.statusChange = "";
        this.duration = -1;
        this.staggerIndex = -1;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.IMoveData);
    mixitup.IMoveData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.IMoveData.prototype.constructor = mixitup.IMoveData;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.TargetDom = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.el = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.TargetDom);
    mixitup.TargetDom.prototype = Object.create(mixitup.Base.prototype);
    mixitup.TargetDom.prototype.constructor = mixitup.TargetDom;
    /**
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Target = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.id = "";
        this.sortString = "";
        this.mixer = null;
        this.callback = null;
        this.isShown = false;
        this.isBound = false;
        this.isExcluded = false;
        this.isInDom = false;
        this.handler = null;
        this.operation = null;
        this.data = null;
        this.dom = new mixitup.TargetDom();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Target);
    mixitup.Target.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Target.prototype, {
        constructor: mixitup.Target,
        /**
         * Initialises a newly instantiated Target.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {(Element|null)}    el
         * @param   {object}            mixer
         * @param   {object}            [data]
         * @return  {void}
         */ init: function(el, mixer, data) {
            var self = this, id = "";
            self.callActions("beforeInit", arguments);
            self.mixer = mixer;
            if (!el) // If no element is provided, render it
            el = self.render(data);
            self.cacheDom(el);
            self.bindEvents();
            if (self.dom.el.style.display !== "none") self.isShown = true;
            if (data && mixer.config.data.uidKey) {
                if (typeof (id = data[mixer.config.data.uidKey]) === "undefined" || id.toString().length < 1) throw new TypeError(mixitup.messages.errorDatasetInvalidUidKey({
                    uidKey: mixer.config.data.uidKey
                }));
                self.id = id;
                self.data = data;
                mixer.cache[id] = self;
            }
            self.callActions("afterInit", arguments);
        },
        /**
         * Renders the target element using a user-defined renderer function.
         *
         * @private
         * @instance
         * @since   3.1.4
         * @param   {object} data
         * @return  {void}
         */ render: function(data) {
            var self = this, render = null, el = null, temp = null, output = "";
            self.callActions("beforeRender", arguments);
            render = self.callFilters("renderRender", self.mixer.config.render.target, arguments);
            if (typeof render !== "function") throw new TypeError(mixitup.messages.errorDatasetRendererNotSet());
            output = render(data);
            if (output && typeof output === "object" && h.isElement(output)) el = output;
            else if (typeof output === "string") {
                temp = document.createElement("div");
                temp.innerHTML = output;
                el = temp.firstElementChild;
            }
            return self.callFilters("elRender", el, arguments);
        },
        /**
         * Caches references of DOM elements neccessary for the target's functionality.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Element} el
         * @return  {void}
         */ cacheDom: function(el) {
            var self = this;
            self.callActions("beforeCacheDom", arguments);
            self.dom.el = el;
            self.callActions("afterCacheDom", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}    attributeName
         * @return  {void}
         */ getSortString: function(attributeName) {
            var self = this, value = self.dom.el.getAttribute("data-" + attributeName) || "";
            self.callActions("beforeGetSortString", arguments);
            value = isNaN(value * 1) ? value.toLowerCase() : value * 1;
            self.sortString = value;
            self.callActions("afterGetSortString", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ show: function() {
            var self = this;
            self.callActions("beforeShow", arguments);
            if (!self.isShown) {
                self.dom.el.style.display = "";
                self.isShown = true;
            }
            self.callActions("afterShow", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ hide: function() {
            var self = this;
            self.callActions("beforeHide", arguments);
            if (self.isShown) {
                self.dom.el.style.display = "none";
                self.isShown = false;
            }
            self.callActions("afterHide", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.IMoveData} moveData
         * @return  {void}
         */ move: function(moveData) {
            var self = this;
            self.callActions("beforeMove", arguments);
            if (!self.isExcluded) self.mixer.targetsMoved++;
            self.applyStylesIn(moveData);
            requestAnimationFrame(function() {
                self.applyStylesOut(moveData);
            });
            self.callActions("afterMove", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {object}    posData
         * @param   {number}    multiplier
         * @return  {void}
         */ applyTween: function(posData, multiplier) {
            var self = this, propertyName = "", tweenData = null, posIn = posData.posIn, currentTransformValues = [], currentValues = new mixitup.StyleData(), i = -1;
            self.callActions("beforeApplyTween", arguments);
            currentValues.x = posIn.x;
            currentValues.y = posIn.y;
            if (multiplier === 0) self.hide();
            else if (!self.isShown) self.show();
            for(i = 0; propertyName = mixitup.features.TWEENABLE[i]; i++){
                tweenData = posData.tweenData[propertyName];
                if (propertyName === "x") {
                    if (!tweenData) continue;
                    currentValues.x = posIn.x + tweenData * multiplier;
                } else if (propertyName === "y") {
                    if (!tweenData) continue;
                    currentValues.y = posIn.y + tweenData * multiplier;
                } else if (tweenData instanceof mixitup.TransformData) {
                    if (!tweenData.value) continue;
                    currentValues[propertyName].value = posIn[propertyName].value + tweenData.value * multiplier;
                    currentValues[propertyName].unit = tweenData.unit;
                    currentTransformValues.push(propertyName + "(" + currentValues[propertyName].value + tweenData.unit + ")");
                } else {
                    if (!tweenData) continue;
                    currentValues[propertyName] = posIn[propertyName] + tweenData * multiplier;
                    self.dom.el.style[propertyName] = currentValues[propertyName];
                }
            }
            if (currentValues.x || currentValues.y) currentTransformValues.unshift("translate(" + currentValues.x + "px, " + currentValues.y + "px)");
            if (currentTransformValues.length) self.dom.el.style[mixitup.features.transformProp] = currentTransformValues.join(" ");
            self.callActions("afterApplyTween", arguments);
        },
        /**
         * Applies the initial styling to a target element before any transition
         * is applied.
         *
         * @private
         * @instance
         * @param   {mixitup.IMoveData} moveData
         * @return  {void}
         */ applyStylesIn: function(moveData) {
            var self = this, posIn = moveData.posIn, isFading = self.mixer.effectsIn.opacity !== 1, transformValues = [];
            self.callActions("beforeApplyStylesIn", arguments);
            transformValues.push("translate(" + posIn.x + "px, " + posIn.y + "px)");
            if (self.mixer.config.animation.animateResizeTargets) {
                if (moveData.statusChange !== "show") {
                    // Don't apply posIn width or height or showing, as will be 0
                    self.dom.el.style.width = posIn.width + "px";
                    self.dom.el.style.height = posIn.height + "px";
                }
                self.dom.el.style.marginRight = posIn.marginRight + "px";
                self.dom.el.style.marginBottom = posIn.marginBottom + "px";
            }
            isFading && (self.dom.el.style.opacity = posIn.opacity);
            if (moveData.statusChange === "show") transformValues = transformValues.concat(self.mixer.transformIn);
            self.dom.el.style[mixitup.features.transformProp] = transformValues.join(" ");
            self.callActions("afterApplyStylesIn", arguments);
        },
        /**
         * Applies a transition followed by the final styles for the element to
         * transition towards.
         *
         * @private
         * @instance
         * @param   {mixitup.IMoveData} moveData
         * @return  {void}
         */ applyStylesOut: function(moveData) {
            var self = this, transitionRules = [], transformValues = [], isResizing = self.mixer.config.animation.animateResizeTargets, isFading = typeof self.mixer.effectsIn.opacity !== "undefined";
            self.callActions("beforeApplyStylesOut", arguments);
            // Build the transition rules
            transitionRules.push(self.writeTransitionRule(mixitup.features.transformRule, moveData.staggerIndex));
            if (moveData.statusChange !== "none") transitionRules.push(self.writeTransitionRule("opacity", moveData.staggerIndex, moveData.duration));
            if (isResizing) {
                transitionRules.push(self.writeTransitionRule("width", moveData.staggerIndex, moveData.duration));
                transitionRules.push(self.writeTransitionRule("height", moveData.staggerIndex, moveData.duration));
                transitionRules.push(self.writeTransitionRule("margin", moveData.staggerIndex, moveData.duration));
            }
            // If no callback was provided, the element will
            // not transition in any way so tag it as "immovable"
            if (!moveData.callback) {
                self.mixer.targetsImmovable++;
                if (self.mixer.targetsMoved === self.mixer.targetsImmovable) // If the total targets moved is equal to the
                // number of immovable targets, the operation
                // should be considered finished
                self.mixer.cleanUp(moveData.operation);
                return;
            }
            // If the target will transition in some fasion,
            // assign a callback function
            self.operation = moveData.operation;
            self.callback = moveData.callback;
            // As long as the target is not excluded, increment
            // the total number of targets bound
            !self.isExcluded && self.mixer.targetsBound++;
            // Tag the target as bound to differentiate from transitionEnd
            // events that may come from stylesheet driven effects
            self.isBound = true;
            // Apply the transition
            self.applyTransition(transitionRules);
            // Apply width, height and margin negation
            if (isResizing && moveData.posOut.width > 0 && moveData.posOut.height > 0) {
                self.dom.el.style.width = moveData.posOut.width + "px";
                self.dom.el.style.height = moveData.posOut.height + "px";
                self.dom.el.style.marginRight = moveData.posOut.marginRight + "px";
                self.dom.el.style.marginBottom = moveData.posOut.marginBottom + "px";
            }
            if (!self.mixer.config.animation.nudge && moveData.statusChange === "hide") // If we're not nudging, the translation should be
            // applied before any other transforms to prevent
            // lateral movement
            transformValues.push("translate(" + moveData.posOut.x + "px, " + moveData.posOut.y + "px)");
            // Apply fade
            switch(moveData.statusChange){
                case "hide":
                    isFading && (self.dom.el.style.opacity = self.mixer.effectsOut.opacity);
                    transformValues = transformValues.concat(self.mixer.transformOut);
                    break;
                case "show":
                    isFading && (self.dom.el.style.opacity = 1);
            }
            if (self.mixer.config.animation.nudge || !self.mixer.config.animation.nudge && moveData.statusChange !== "hide") // Opposite of above - apply translate after
            // other transform
            transformValues.push("translate(" + moveData.posOut.x + "px, " + moveData.posOut.y + "px)");
            // Apply transforms
            self.dom.el.style[mixitup.features.transformProp] = transformValues.join(" ");
            self.callActions("afterApplyStylesOut", arguments);
        },
        /**
         * Combines the name of a CSS property with the appropriate duration and delay
         * values to created a valid transition rule.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}    property
         * @param   {number}    staggerIndex
         * @param   {number}    duration
         * @return  {string}
         */ writeTransitionRule: function(property, staggerIndex, duration) {
            var self = this, delay = self.getDelay(staggerIndex), rule = "";
            rule = property + " " + (duration > 0 ? duration : self.mixer.config.animation.duration) + "ms " + delay + "ms " + (property === "opacity" ? "linear" : self.mixer.config.animation.easing);
            return self.callFilters("ruleWriteTransitionRule", rule, arguments);
        },
        /**
         * Calculates the transition delay for each target element based on its index, if
         * staggering is applied. If defined, A custom `animation.staggerSeqeuence`
         * function can be used to manipulate the order of indices to produce custom
         * stagger effects (e.g. for use in a grid with irregular row lengths).
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {number}    index
         * @return  {number}
         */ getDelay: function(index) {
            var self = this, delay = -1;
            if (typeof self.mixer.config.animation.staggerSequence === "function") index = self.mixer.config.animation.staggerSequence.call(self, index, self.state);
            delay = !!self.mixer.staggerDuration ? index * self.mixer.staggerDuration : 0;
            return self.callFilters("delayGetDelay", delay, arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string[]}  rules
         * @return  {void}
         */ applyTransition: function(rules) {
            var self = this, transitionString = rules.join(", ");
            self.callActions("beforeApplyTransition", arguments);
            self.dom.el.style[mixitup.features.transitionProp] = transitionString;
            self.callActions("afterApplyTransition", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Event} e
         * @return  {void}
         */ handleTransitionEnd: function(e) {
            var self = this, propName = e.propertyName, canResize = self.mixer.config.animation.animateResizeTargets;
            self.callActions("beforeHandleTransitionEnd", arguments);
            if (self.isBound && e.target.matches(self.mixer.config.selectors.target) && (propName.indexOf("transform") > -1 || propName.indexOf("opacity") > -1 || canResize && propName.indexOf("height") > -1 || canResize && propName.indexOf("width") > -1 || canResize && propName.indexOf("margin") > -1)) {
                self.callback.call(self, self.operation);
                self.isBound = false;
                self.callback = null;
                self.operation = null;
            }
            self.callActions("afterHandleTransitionEnd", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Event}     e
         * @return  {void}
         */ eventBus: function(e) {
            var self = this;
            self.callActions("beforeEventBus", arguments);
            switch(e.type){
                case "webkitTransitionEnd":
                case "transitionend":
                    self.handleTransitionEnd(e);
            }
            self.callActions("afterEventBus", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ unbindEvents: function() {
            var self = this;
            self.callActions("beforeUnbindEvents", arguments);
            h.off(self.dom.el, "webkitTransitionEnd", self.handler);
            h.off(self.dom.el, "transitionend", self.handler);
            self.callActions("afterUnbindEvents", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ bindEvents: function() {
            var self = this, transitionEndEvent = "";
            self.callActions("beforeBindEvents", arguments);
            transitionEndEvent = mixitup.features.transitionPrefix === "webkit" ? "webkitTransitionEnd" : "transitionend";
            self.handler = function(e) {
                return self.eventBus(e);
            };
            h.on(self.dom.el, transitionEndEvent, self.handler);
            self.callActions("afterBindEvents", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {boolean}   [getBox]
         * @return  {PosData}
         */ getPosData: function(getBox) {
            var self = this, styles = {}, rect = null, posData = new mixitup.StyleData();
            self.callActions("beforeGetPosData", arguments);
            posData.x = self.dom.el.offsetLeft;
            posData.y = self.dom.el.offsetTop;
            if (self.mixer.config.animation.animateResizeTargets || getBox) {
                rect = self.dom.el.getBoundingClientRect();
                posData.top = rect.top;
                posData.right = rect.right;
                posData.bottom = rect.bottom;
                posData.left = rect.left;
                posData.width = rect.width;
                posData.height = rect.height;
            }
            if (self.mixer.config.animation.animateResizeTargets) {
                styles = window1.getComputedStyle(self.dom.el);
                posData.marginBottom = parseFloat(styles.marginBottom);
                posData.marginRight = parseFloat(styles.marginRight);
            }
            return self.callFilters("posDataGetPosData", posData, arguments);
        },
        /**
         * @private
         * @instance
         * @since       3.0.0
         * @return      {void}
         */ cleanUp: function() {
            var self = this;
            self.callActions("beforeCleanUp", arguments);
            self.dom.el.style[mixitup.features.transformProp] = "";
            self.dom.el.style[mixitup.features.transitionProp] = "";
            self.dom.el.style.opacity = "";
            if (self.mixer.config.animation.animateResizeTargets) {
                self.dom.el.style.width = "";
                self.dom.el.style.height = "";
                self.dom.el.style.marginRight = "";
                self.dom.el.style.marginBottom = "";
            }
            self.callActions("afterCleanUp", arguments);
        }
    });
    /**
     * A jQuery-collection-like wrapper around one or more `mixitup.Mixer` instances
     * allowing simultaneous control of said instances similar to the MixItUp 2 API.
     *
     * @example
     * new mixitup.Collection(instances)
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     * @param       {mixitup.Mixer[]}   instances
     */ mixitup.Collection = function(instances) {
        var instance = null, i = -1;
        this.callActions("beforeConstruct");
        for(i = 0; instance = instances[i]; i++)this[i] = instance;
        this.length = instances.length;
        this.callActions("afterConstruct");
        h.freeze(this);
    };
    mixitup.BaseStatic.call(mixitup.Collection);
    mixitup.Collection.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Collection.prototype, /** @lends mixitup.Collection */ {
        constructor: mixitup.Collection,
        /**
         * Calls a method on all instances in the collection by passing the method
         * name as a string followed by any applicable parameters to be curried into
         * to the method.
         *
         * @example
         * .mixitup(methodName[,arg1][,arg2..]);
         *
         * @example
         * var collection = new Collection([mixer1, mixer2]);
         *
         * return collection.mixitup('filter', '.category-a')
         *     .then(function(states) {
         *         state.forEach(function(state) {
         *             console.log(state.activeFilter.selector); // .category-a
         *         });
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {string}  methodName
         * @return      {Promise<Array<mixitup.State>>}
         */ mixitup: function(methodName) {
            var self = this, instance = null, args = Array.prototype.slice.call(arguments), tasks = [], i = -1;
            this.callActions("beforeMixitup");
            args.shift();
            for(i = 0; instance = self[i]; i++)tasks.push(instance[methodName].apply(instance, args));
            return self.callFilters("promiseMixitup", h.all(tasks, mixitup.libraries), arguments);
        }
    });
    /**
     * `mixitup.Operation` objects contain all data neccessary to describe the full
     * lifecycle of any MixItUp operation. They can be used to compute and store an
     * operation for use at a later time (e.g. programmatic tweening).
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Operation = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.id = "";
        this.args = [];
        this.command = null;
        this.showPosData = [];
        this.toHidePosData = [];
        this.startState = null;
        this.newState = null;
        this.docState = null;
        this.willSort = false;
        this.willChangeLayout = false;
        this.hasEffect = false;
        this.hasFailed = false;
        this.triggerElement = null;
        this.show = [];
        this.hide = [];
        this.matching = [];
        this.toShow = [];
        this.toHide = [];
        this.toMove = [];
        this.toRemove = [];
        this.startOrder = [];
        this.newOrder = [];
        this.startSort = null;
        this.newSort = null;
        this.startFilter = null;
        this.newFilter = null;
        this.startDataset = null;
        this.newDataset = null;
        this.viewportDeltaX = 0;
        this.viewportDeltaY = 0;
        this.startX = 0;
        this.startY = 0;
        this.startHeight = 0;
        this.startWidth = 0;
        this.newX = 0;
        this.newY = 0;
        this.newHeight = 0;
        this.newWidth = 0;
        this.startContainerClassName = "";
        this.startDisplay = "";
        this.newContainerClassName = "";
        this.newDisplay = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Operation);
    mixitup.Operation.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Operation.prototype.constructor = mixitup.Operation;
    /**
     * `mixitup.State` objects expose various pieces of data detailing the state of
     * a MixItUp instance. They are provided at the start and end of any operation via
     * callbacks and events, with the most recent state stored between operations
     * for retrieval at any time via the API.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @public
     * @since       3.0.0
     */ mixitup.State = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * The ID of the mixer instance.
         *
         * @name        id
         * @memberof    mixitup.State
         * @instance
         * @type        {string}
         * @default     ''
         */ this.id = "";
        /**
         * The currently active filter command as set by a control click or API call.
         *
         * @name        activeFilter
         * @memberof    mixitup.State
         * @instance
         * @type        {mixitup.CommandFilter}
         * @default     null
         */ this.activeFilter = null;
        /**
         * The currently active sort command as set by a control click or API call.
         *
         * @name        activeSort
         * @memberof    mixitup.State
         * @instance
         * @type        {mixitup.CommandSort}
         * @default     null
         */ this.activeSort = null;
        /**
         * The current layout-specific container class name, if applied.
         *
         * @name        activeContainerClassName
         * @memberof    mixitup.State
         * @instance
         * @type        {string}
         * @default     ''
         */ this.activeContainerClassName = "";
        /**
         * A reference to the container element that the mixer is instantiated on.
         *
         * @name        container
         * @memberof    mixitup.State
         * @instance
         * @type        {Element}
         * @default     null
         */ this.container = null;
        /**
         * An array of all target elements indexed by the mixer.
         *
         * @name        targets
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.targets = [];
        /**
         * An array of all target elements not matching the current filter.
         *
         * @name        hide
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.hide = [];
        /**
         * An array of all target elements matching the current filter and any additional
         * limits applied such as pagination.
         *
         * @name        show
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.show = [];
        /**
         * An array of all target elements matching the current filter irrespective of
         * any additional limits applied such as pagination.
         *
         * @name        matching
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.matching = [];
        /**
         * An integer representing the total number of target elements indexed by the
         * mixer. Equivalent to `state.targets.length`.
         *
         * @name        totalTargets
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalTargets = -1;
        /**
         * An integer representing the total number of target elements matching the
         * current filter and any additional limits applied such as pagination.
         * Equivalent to `state.show.length`.
         *
         * @name        totalShow
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalShow = -1;
        /**
         * An integer representing the total number of target elements not matching
         * the current filter. Equivalent to `state.hide.length`.
         *
         * @name        totalHide
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalHide = -1;
        /**
         * An integer representing the total number of target elements matching the
         * current filter irrespective of any other limits applied such as pagination.
         * Equivalent to `state.matching.length`.
         *
         * @name        totalMatching
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalMatching = -1;
        /**
         * A boolean indicating whether the last operation "failed", i.e. no targets
         * could be found matching the filter.
         *
         * @name        hasFailed
         * @memberof    mixitup.State
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.hasFailed = false;
        /**
         * The DOM element that was clicked if the last operation was triggered by the
         * clicking of a control and not an API call.
         *
         * @name        triggerElement
         * @memberof    mixitup.State
         * @instance
         * @type        {Element|null}
         * @default     null
         */ this.triggerElement = null;
        /**
         * The currently active dataset underlying the rendered targets, if the
         * dataset API is in use.
         *
         * @name        activeDataset
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<object>}
         * @default     null
         */ this.activeDataset = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.State);
    mixitup.State.prototype = Object.create(mixitup.Base.prototype);
    mixitup.State.prototype.constructor = mixitup.State;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.UserInstruction = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.command = {};
        this.animate = false;
        this.callback = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.UserInstruction);
    mixitup.UserInstruction.prototype = Object.create(mixitup.Base.prototype);
    mixitup.UserInstruction.prototype.constructor = mixitup.UserInstruction;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Messages = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /* Errors
        ----------------------------------------------------------------------------- */ this.ERROR_FACTORY_INVALID_CONTAINER = "[MixItUp] An invalid selector or element reference was passed to the mixitup factory function";
        this.ERROR_FACTORY_CONTAINER_NOT_FOUND = "[MixItUp] The provided selector yielded no container element";
        this.ERROR_CONFIG_INVALID_ANIMATION_EFFECTS = "[MixItUp] Invalid value for `animation.effects`";
        this.ERROR_CONFIG_INVALID_CONTROLS_SCOPE = "[MixItUp] Invalid value for `controls.scope`";
        this.ERROR_CONFIG_INVALID_PROPERTY = '[MixitUp] Invalid configuration object property "${erroneous}"${suggestion}';
        this.ERROR_CONFIG_INVALID_PROPERTY_SUGGESTION = '. Did you mean "${probableMatch}"?';
        this.ERROR_CONFIG_DATA_UID_KEY_NOT_SET = "[MixItUp] To use the dataset API, a UID key must be specified using `data.uidKey`";
        this.ERROR_DATASET_INVALID_UID_KEY = '[MixItUp] The specified UID key "${uidKey}" is not present on one or more dataset items';
        this.ERROR_DATASET_DUPLICATE_UID = '[MixItUp] The UID "${uid}" was found on two or more dataset items. UIDs must be unique.';
        this.ERROR_INSERT_INVALID_ARGUMENTS = "[MixItUp] Please provider either an index or a sibling and position to insert, not both";
        this.ERROR_INSERT_PREEXISTING_ELEMENT = "[MixItUp] An element to be inserted already exists in the container";
        this.ERROR_FILTER_INVALID_ARGUMENTS = "[MixItUp] Please provide either a selector or collection `.filter()`, not both";
        this.ERROR_DATASET_NOT_SET = "[MixItUp] To use the dataset API with pre-rendered targets, a starting dataset must be set using `load.dataset`";
        this.ERROR_DATASET_PRERENDERED_MISMATCH = "[MixItUp] `load.dataset` does not match pre-rendered targets";
        this.ERROR_DATASET_RENDERER_NOT_SET = "[MixItUp] To insert an element via the dataset API, a target renderer function must be provided to `render.target`";
        this.ERROR_SORT_NON_EXISTENT_ELEMENT = "[MixItUp] An element to be sorted does not already exist in the container";
        /* Warnings
        ----------------------------------------------------------------------------- */ this.WARNING_FACTORY_PREEXISTING_INSTANCE = "[MixItUp] WARNING: This element already has an active MixItUp instance. The provided configuration object will be ignored. If you wish to perform additional methods on this instance, please create a reference.";
        this.WARNING_INSERT_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.insert()`";
        this.WARNING_REMOVE_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.remove()`";
        this.WARNING_MULTIMIX_INSTANCE_QUEUE_FULL = "[MixItUp] WARNING: An operation was requested but the MixItUp instance was busy. The operation was rejected because the queue is full or queuing is disabled.";
        this.WARNING_GET_OPERATION_INSTANCE_BUSY = "[MixItUp] WARNING: Operations can be be created while the MixItUp instance is busy.";
        this.WARNING_NO_PROMISE_IMPLEMENTATION = "[MixItUp] WARNING: No Promise implementations could be found. If you wish to use promises with MixItUp please install an ES6 Promise polyfill.";
        this.WARNING_INCONSISTENT_SORTING_ATTRIBUTES = '[MixItUp] WARNING: The requested sorting data attribute "${attribute}" was not present on one or more target elements which may product unexpected sort output';
        this.callActions("afterConstruct");
        this.compileTemplates();
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Messages);
    mixitup.Messages.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Messages.prototype.constructor = mixitup.Messages;
    /**
     * @return {void}
     */ mixitup.Messages.prototype.compileTemplates = function() {
        var errorKey = "";
        var errorMessage = "";
        for(errorKey in this){
            if (typeof (errorMessage = this[errorKey]) !== "string") continue;
            this[h.camelCase(errorKey)] = h.template(errorMessage);
        }
    };
    mixitup.messages = new mixitup.Messages();
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     * @param       {mixitup.Mixer} mixer
     */ mixitup.Facade = function Mixer(mixer) {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct", arguments);
        this.configure = mixer.configure.bind(mixer);
        this.show = mixer.show.bind(mixer);
        this.hide = mixer.hide.bind(mixer);
        this.filter = mixer.filter.bind(mixer);
        this.toggleOn = mixer.toggleOn.bind(mixer);
        this.toggleOff = mixer.toggleOff.bind(mixer);
        this.sort = mixer.sort.bind(mixer);
        this.changeLayout = mixer.changeLayout.bind(mixer);
        this.multimix = mixer.multimix.bind(mixer);
        this.dataset = mixer.dataset.bind(mixer);
        this.tween = mixer.tween.bind(mixer);
        this.insert = mixer.insert.bind(mixer);
        this.insertBefore = mixer.insertBefore.bind(mixer);
        this.insertAfter = mixer.insertAfter.bind(mixer);
        this.prepend = mixer.prepend.bind(mixer);
        this.append = mixer.append.bind(mixer);
        this.remove = mixer.remove.bind(mixer);
        this.destroy = mixer.destroy.bind(mixer);
        this.forceRefresh = mixer.forceRefresh.bind(mixer);
        this.forceRender = mixer.forceRender.bind(mixer);
        this.isMixing = mixer.isMixing.bind(mixer);
        this.getOperation = mixer.getOperation.bind(mixer);
        this.getConfig = mixer.getConfig.bind(mixer);
        this.getState = mixer.getState.bind(mixer);
        this.callActions("afterConstruct", arguments);
        h.freeze(this);
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Facade);
    mixitup.Facade.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Facade.prototype.constructor = mixitup.Facade;
    $8399e4e9dca8c987$exports = mixitup;
    mixitup.BaseStatic.call(mixitup.constructor);
    mixitup.NAME = "mixitup";
    mixitup.CORE_VERSION = "3.3.1";
})(window);


var $a81e3cadb6aea6f7$exports = {};
/**!
 * MixItUp MultiFilter v3.3.6
 * A UI-builder for powerful multidimensional filtering
 * Build 293e0dda-087e-4a76-aadf-e3e8b311b81f
 *
 * Requires mixitup.js >= v^3.1.2
 *
 * @copyright Copyright 2014-2020 KunkaLabs Limited.
 * @author    KunkaLabs Limited.
 * @link      https://www.kunkalabs.com/mixitup-multifilter/
 *
 * @license   Commercial use requires a commercial license.
 *            https://www.kunkalabs.com/mixitup-multifilter/licenses/
 *
 *            Non-commercial use permitted under same terms as  license.
 *            http://creativecommons.org/licenses/by-nc/3.0/
 */ !function(u) {
    "use strict";
    var e = function(u) {
        var t, i = u.h;
        if (t = [
            [
                "A",
                /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
            ],
            [
                "AA",
                /[\uA732]/g
            ],
            [
                "AE",
                /[\u00C6\u01FC\u01E2]/g
            ],
            [
                "AO",
                /[\uA734]/g
            ],
            [
                "AU",
                /[\uA736]/g
            ],
            [
                "AV",
                /[\uA738\uA73A]/g
            ],
            [
                "AY",
                /[\uA73C]/g
            ],
            [
                "B",
                /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
            ],
            [
                "C",
                /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
            ],
            [
                "D",
                /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
            ],
            [
                "DZ",
                /[\u01F1\u01C4]/g
            ],
            [
                "Dz",
                /[\u01F2\u01C5]/g
            ],
            [
                "E",
                /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
            ],
            [
                "F",
                /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
            ],
            [
                "G",
                /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
            ],
            [
                "H",
                /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
            ],
            [
                "I",
                /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
            ],
            [
                "J",
                /[\u004A\u24BF\uFF2A\u0134\u0248]/g
            ],
            [
                "K",
                /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
            ],
            [
                "L",
                /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
            ],
            [
                "LJ",
                /[\u01C7]/g
            ],
            [
                "Lj",
                /[\u01C8]/g
            ],
            [
                "M",
                /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
            ],
            [
                "N",
                /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
            ],
            [
                "NJ",
                /[\u01CA]/g
            ],
            [
                "Nj",
                /[\u01CB]/g
            ],
            [
                "O",
                /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
            ],
            [
                "OI",
                /[\u01A2]/g
            ],
            [
                "OO",
                /[\uA74E]/g
            ],
            [
                "OU",
                /[\u0222]/g
            ],
            [
                "P",
                /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
            ],
            [
                "Q",
                /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
            ],
            [
                "R",
                /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
            ],
            [
                "S",
                /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
            ],
            [
                "T",
                /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
            ],
            [
                "TZ",
                /[\uA728]/g
            ],
            [
                "U",
                /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
            ],
            [
                "V",
                /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
            ],
            [
                "VY",
                /[\uA760]/g
            ],
            [
                "W",
                /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
            ],
            [
                "X",
                /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
            ],
            [
                "Y",
                /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
            ],
            [
                "Z",
                /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
            ],
            [
                "a",
                /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
            ],
            [
                "aa",
                /[\uA733]/g
            ],
            [
                "ae",
                /[\u00E6\u01FD\u01E3]/g
            ],
            [
                "ao",
                /[\uA735]/g
            ],
            [
                "au",
                /[\uA737]/g
            ],
            [
                "av",
                /[\uA739\uA73B]/g
            ],
            [
                "ay",
                /[\uA73D]/g
            ],
            [
                "b",
                /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
            ],
            [
                "c",
                /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
            ],
            [
                "d",
                /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
            ],
            [
                "dz",
                /[\u01F3\u01C6]/g
            ],
            [
                "e",
                /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
            ],
            [
                "f",
                /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
            ],
            [
                "g",
                /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
            ],
            [
                "h",
                /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
            ],
            [
                "hv",
                /[\u0195]/g
            ],
            [
                "i",
                /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
            ],
            [
                "j",
                /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
            ],
            [
                "k",
                /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
            ],
            [
                "l",
                /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
            ],
            [
                "lj",
                /[\u01C9]/g
            ],
            [
                "m",
                /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
            ],
            [
                "n",
                /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
            ],
            [
                "nj",
                /[\u01CC]/g
            ],
            [
                "o",
                /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
            ],
            [
                "oi",
                /[\u01A3]/g
            ],
            [
                "ou",
                /[\u0223]/g
            ],
            [
                "oo",
                /[\uA74F]/g
            ],
            [
                "p",
                /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
            ],
            [
                "q",
                /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
            ],
            [
                "r",
                /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
            ],
            [
                "s",
                /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
            ],
            [
                "t",
                /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
            ],
            [
                "tz",
                /[\uA729]/g
            ],
            [
                "u",
                /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
            ],
            [
                "v",
                /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
            ],
            [
                "vy",
                /[\uA761]/g
            ],
            [
                "w",
                /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
            ],
            [
                "x",
                /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
            ],
            [
                "y",
                /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
            ],
            [
                "z",
                /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
            ]
        ], !u.CORE_VERSION || !i.compareVersions(e.REQUIRE_CORE_VERSION, u.CORE_VERSION)) throw new Error("[MixItUp Multifilter] MixItUp Multifilter v" + e.EXTENSION_VERSION + " requires at least MixItUp v" + e.REQUIRE_CORE_VERSION);
        u.ConfigCallbacks.registerAction("afterConstruct", "multifilter", function() {
            this.onParseFilterGroups = null;
        }), u.ConfigMultifilter = function() {
            this.enable = !1, this.logicWithinGroup = "or", this.logicBetweenGroups = "and", this.minSearchLength = 3, this.parseOn = "change", this.keyupThrottleDuration = 350, i.seal(this);
        }, u.Config.registerAction("beforeConstruct", "multifilter", function() {
            this.multifilter = new u.ConfigMultifilter;
        }), u.MultifilterFormEventTracker = function() {
            this.form = null, this.totalBound = 0, this.totalHandled = 0, i.seal(this);
        }, u.FilterGroupDom = function() {
            this.el = null, this.form = null, i.seal(this);
        }, u.FilterGroup = function() {
            this.name = "", this.dom = new u.FilterGroupDom, this.activeSelectors = [], this.activeFilters = [], this.activeToggles = [], this.handler = null, this.mixer = null, this.logic = "or", this.parseOn = "change", this.keyupTimeout = -1, i.seal(this);
        }, i.extend(u.FilterGroup.prototype, {
            init: function(u, e) {
                var t = this, i = u.getAttribute("data-logic");
                t.dom.el = u, this.name = t.dom.el.getAttribute("data-filter-group") || "", t.cacheDom(), t.dom.form && t.enableButtons(), t.mixer = e, (i && "and" === i.toLowerCase() || "and" === e.config.multifilter.logicWithinGroup) && (t.logic = "and"), t.bindEvents();
            },
            cacheDom: function() {
                var u = this;
                u.dom.form = i.closestParent(u.dom.el, "form", !0);
            },
            enableButtons: function() {
                var u = this, e = u.dom.form.querySelectorAll('button[type="submit"]:disabled'), t = null, i = -1;
                for(i = 0; t = e[i]; i++)t.disabled && (t.disabled = !1);
            },
            bindEvents: function() {
                var u = this;
                u.handler = function(e) {
                    switch(e.type){
                        case "reset":
                        case "submit":
                            u.handleFormEvent(e);
                            break;
                        default:
                            u["handle" + i.pascalCase(e.type)](e);
                    }
                }, i.on(u.dom.el, "click", u.handler), i.on(u.dom.el, "change", u.handler), i.on(u.dom.el, "keyup", u.handler), u.dom.form && (i.on(u.dom.form, "reset", u.handler), i.on(u.dom.form, "submit", u.handler));
            },
            unbindEvents: function() {
                var u = this;
                i.off(u.dom.el, "click", u.handler), i.off(u.dom.el, "change", u.handler), i.off(u.dom.el, "keyup", u.handler), u.dom.form && (i.off(u.dom.form, "reset", u.handler), i.off(u.dom.form, "submit", u.handler)), u.handler = null;
            },
            handleClick: function(u) {
                var e = this, t = e.mixer, r = null, l = i.closestParent(u.target, "[data-filter], [data-toggle]", !0), o = "", n = -1, E = "";
                l && ((o = e.mixer.config.selectors.control) && !l.matches(o) || (u.stopPropagation(), t.lastClicked || (t.lastClicked = l), "function" == typeof t.config.callbacks.onMixClick && (r = t.config.callbacks.onMixClick.call(t.lastClicked, t.state, u, e), r === !1) || (l.matches("[data-filter]") ? (E = l.getAttribute("data-filter"), e.activeToggles = [], e.activeSelectors = e.activeFilters = [
                    E
                ]) : l.matches("[data-toggle]") && (E = l.getAttribute("data-toggle"), e.activeFilters = [], (n = e.activeToggles.indexOf(E)) > -1 ? e.activeToggles.splice(n, 1) : e.activeToggles.push(E), "and" === e.logic ? e.activeSelectors = [
                    e.activeToggles
                ] : e.activeSelectors = e.activeToggles), e.updateControls(), "change" === e.mixer.config.multifilter.parseOn && e.mixer.parseFilterGroups())));
            },
            handleChange: function(u) {
                var e = this, t = u.target;
                switch(u.stopPropagation(), t.type){
                    case "text":
                    case "search":
                    case "email":
                    case "select-one":
                    case "radio":
                        e.getSingleValue(t);
                        break;
                    case "checkbox":
                    case "select-multiple":
                        e.getMultipleValues(t);
                }
                "change" === e.mixer.config.multifilter.parseOn && e.mixer.parseFilterGroups();
            },
            handleKeyup: function(u) {
                var e = this, t = u.target;
                if (!([
                    "text",
                    "search",
                    "email"
                ].indexOf(t.type) < 0)) {
                    if ("change" !== e.mixer.config.multifilter.parseOn) return void e.mixer.getSingleValue(t);
                    clearTimeout(e.keyupTimeout), e.keyupTimeout = setTimeout(function() {
                        e.getSingleValue(t), e.mixer.parseFilterGroups();
                    }, e.mixer.config.multifilter.keyupThrottleDuration);
                }
            },
            handleFormEvent: function(e) {
                var t = this, i = null, r = null, l = -1;
                if ("submit" === e.type && e.preventDefault(), "reset" === e.type && (t.activeFilters = t.activeToggles = t.activeSelectors = [], t.updateControls()), t.mixer.multifilterFormEventTracker) i = t.mixer.multifilterFormEventTracker;
                else for(i = t.mixer.multifilterFormEventTracker = new u.MultifilterFormEventTracker, i.form = e.target, l = 0; r = t.mixer.filterGroups[l]; l++)r.dom.form === e.target && i.totalBound++;
                e.target === i.form && (i.totalHandled++, i.totalHandled === i.totalBound && (t.mixer.multifilterFormEventTracker = null, "submit" !== e.type && "change" !== t.mixer.config.multifilter.parseOn || t.mixer.parseFilterGroups()));
            },
            getSingleValue: function(u) {
                var e = this, i = null, r = "", l = "", o = "", n = -1;
                if (u.type.match(/text|search|email/g)) {
                    if (r = u.getAttribute("data-search-attribute"), !r) throw new Error("[MixItUp MultiFilter] A valid `data-search-attribute` must be present on text inputs");
                    if (u.value.length < e.mixer.config.multifilter.minSearchLength) return void (e.activeSelectors = e.activeFilters = e.activeToggles = [
                        ""
                    ]);
                    for(o = u.value.toLowerCase().trim(), n = 0; i = t[n]; n++)o = o.replace(i[1], i[0]);
                    o = o.replace(/\W+/g, " "), l = "[" + r + '*="' + o + '"]';
                } else l = u.value;
                "string" == typeof u.value && (e.activeSelectors = e.activeToggles = e.activeFilters = l ? [
                    l
                ] : []);
            },
            getMultipleValues: function(u) {
                var e = this, t = [], i = "", r = null, l = null, o = -1;
                switch(u.type){
                    case "checkbox":
                        i = 'input[type="checkbox"]';
                        break;
                    case "select-multiple":
                        i = "option";
                }
                for(l = e.dom.el.querySelectorAll(i), o = 0; r = l[o]; o++)(r.checked || r.selected) && r.value && t.push(r.value);
                e.activeFilters = [], e.activeToggles = t, "and" === e.logic ? e.activeSelectors = [
                    t
                ] : e.activeSelectors = t;
            },
            updateControls: function(u) {
                var e = this, t = null, i = "", r = "", l = "", o = -1;
                for(i = e.mixer.config.selectors.control.trim(), r = [
                    "[data-filter]" + i,
                    "[data-toggle]" + i
                ].join(", "), u = u || e.dom.el.querySelectorAll(r), o = 0; t = u[o]; o++)l = Boolean(t.getAttribute("data-toggle")) ? "toggle" : "filter", e.updateControl(t, l);
            },
            updateControl: function(u, e) {
                var t = this, r = u.getAttribute("data-" + e), l = t.activeToggles.concat(t.activeFilters), o = "";
                o = i.getClassname(t.mixer.config.classNames, e, t.mixer.config.classNames.modifierActive), l.indexOf(r) > -1 ? i.addClass(u, o) : i.removeClass(u, o);
            },
            updateUi: function() {
                var u = this, e = u.dom.el.querySelectorAll("[data-filter], [data-toggle]"), t = u.dom.el.querySelectorAll('input[type="radio"], input[type="checkbox"], option'), i = u.activeToggles.concat(u.activeFilters), r = !1, l = null, o = -1;
                for(e.length && u.updateControls(e, !0), o = 0; l = t[o]; o++)switch(r = i.indexOf(l.value) > -1, l.tagName.toLowerCase()){
                    case "option":
                        l.selected = r;
                        break;
                    case "input":
                        l.checked = r;
                }
            }
        }), u.MixerDom.registerAction("afterConstruct", "multifilter", function() {
            this.filterGroups = [];
        }), u.Mixer.registerAction("afterConstruct", "multifilter", function() {
            this.filterGroups = [], this.filterGroupsHash = {}, this.multifilterFormEventTracker = null;
        }), u.Mixer.registerAction("afterCacheDom", "multifilter", function() {
            var e = this, t = null;
            if (e.config.multifilter.enable) {
                switch(e.config.controls.scope){
                    case "local":
                        t = e.dom.container;
                        break;
                    case "global":
                        t = e.dom.document;
                        break;
                    default:
                        throw new Error(u.messages.ERROR_CONFIG_INVALID_CONTROLS_SCOPE);
                }
                e.dom.filterGroups = t.querySelectorAll("[data-filter-group]");
            }
        }), u.Mixer.registerAction("beforeInitControls", "multifilter", function() {
            var u = this;
            u.config.multifilter.enable && (u.config.controls.live = !0);
        }), u.Mixer.registerAction("afterSanitizeConfig", "multifilter", function() {
            var u = this;
            u.config.multifilter.logicBetweenGroups = u.config.multifilter.logicBetweenGroups.toLowerCase().trim(), u.config.multifilter.logicWithinGroup = u.config.multifilter.logicWithinGroup.toLowerCase().trim();
        }), u.Mixer.registerAction("afterAttach", "multifilter", function() {
            var u = this;
            u.dom.filterGroups.length && u.indexFilterGroups();
        }), u.Mixer.registerAction("afterUpdateControls", "multifilter", function() {
            var u = this, e = null, t = -1;
            for(t = 0; e = u.filterGroups[t]; t++)e.updateControls();
        }), u.Mixer.registerAction("beforeDestroy", "multifilter", function() {
            var u = this, e = null, t = -1;
            for(t = 0; e = u.filterGroups[t]; t++)e.unbindEvents();
        }), u.Mixer.extend({
            indexFilterGroups: function() {
                var e = this, t = null, i = null, r = -1;
                for(r = 0; i = e.dom.filterGroups[r]; r++)if (t = new u.FilterGroup, t.init(i, e), e.filterGroups.push(t), t.name) {
                    if ("undefined" != typeof e.filterGroupsHash[t.name]) throw new Error('[MixItUp MultiFilter] A filter group with name "' + t.name + '" already exists');
                    e.filterGroupsHash[t.name] = t;
                }
            },
            parseParseFilterGroupsArgs: function(e) {
                var t = this, r = new u.UserInstruction, l = null, o = -1;
                for(r.animate = t.config.animation.enable, r.command = new u.CommandFilter, o = 0; o < e.length; o++)l = e[o], "boolean" == typeof l ? r.animate = l : "function" == typeof l && (r.callback = l);
                return i.freeze(r), r;
            },
            getFilterGroupPaths: function() {
                var u = this, e = null, t = null, r = null, l = [], o = [], n = [], E = -1;
                for(E = 0; E < u.filterGroups.length; E++)(r = u.filterGroups[E].activeSelectors).length && (l.push(r), n.push(0));
                return e = function() {
                    var u = null, e = [], t = -1;
                    for(t = 0; t < l.length; t++)u = l[t][n[t]], Array.isArray(u) && (u = u.join("")), e.push(u);
                    e = i.clean(e), o.push(e);
                }, t = function(u) {
                    u = u || 0;
                    for(var i = l[u]; n[u] < i.length;)u < l.length - 1 ? t(u + 1) : e(), n[u]++;
                    n[u] = 0;
                }, l.length ? (t(), o) : "";
            },
            buildSelectorFromPaths: function(u) {
                var e = this, t = null, i = [], r = "", l = "", o = -1;
                if (!u.length) return "";
                if ("or" === e.config.multifilter.logicBetweenGroups && (l = ", "), u.length > 1) {
                    for(o = 0; o < u.length; o++)t = u[o], r = t.join(l), i.indexOf(r) < 0 && i.push(r);
                    return i.join(", ");
                }
                return u[0].join(l);
            },
            parseFilterGroups: function() {
                var u = this, e = u.parseFilterArgs(arguments), t = u.getFilterGroupPaths(), i = u.buildSelectorFromPaths(t), r = null, l = {};
                return "" === i && (i = u.config.controls.toggleDefault), e.command.selector = i, l.filter = e.command, "function" == typeof (r = u.config.callbacks.onParseFilterGroups) && (l = r(l)), u.multimix(l, e.animate, e.callback);
            },
            setFilterGroupSelectors: function(u, e) {
                var t = this, i = null;
                if (e = Array.isArray(e) ? e : [
                    e
                ], "undefined" == typeof (i = t.filterGroupsHash[u])) throw new Error('[MixItUp MultiFilter] No filter group could be found with the name "' + u + '"');
                i.activeToggles = e.slice(), "and" === i.logic ? i.activeSelectors = [
                    i.activeToggles
                ] : i.activeSelectors = i.activeToggles, i.updateUi(i.activeToggles);
            },
            getFilterGroupSelectors: function(u) {
                var e = this, t = null;
                if ("undefined" == typeof (t = e.filterGroupsHash[u])) throw new Error('[MixItUp MultiFilter] No filter group could be found with the name "' + u + '"');
                return t.activeSelectors.slice();
            }
        }), u.Facade.registerAction("afterConstruct", "multifilter", function(u) {
            this.parseFilterGroups = u.parseFilterGroups.bind(u), this.setFilterGroupSelectors = u.setFilterGroupSelectors.bind(u), this.getFilterGroupSelectors = u.getFilterGroupSelectors.bind(u);
        });
    };
    e.TYPE = "mixitup-extension", e.NAME = "mixitup-multifilter", e.EXTENSION_VERSION = "3.3.6", e.REQUIRE_CORE_VERSION = "^3.1.2";
    $a81e3cadb6aea6f7$exports = e;
}(window);


(0, (/*@__PURE__*/$parcel$interopDefault($8399e4e9dca8c987$exports))).use((0, (/*@__PURE__*/$parcel$interopDefault($a81e3cadb6aea6f7$exports))));
const $efd80cb101e43b76$export$376097161d664db1 = ()=>{
    const filterContainer = document.querySelector(".filter-container");
    const locationQuery = filterContainer.getAttribute("data-location-query").toLowerCase();
    const areaQuery = filterContainer.getAttribute("data-area-query").toLowerCase();
    let loadFilter = "";
    if (locationQuery.length > 0) {
        loadFilter += `[data-location~=${locationQuery}]`;
        const selector = document.querySelector(`#${locationQuery}`);
        if (selector) $efd80cb101e43b76$var$selectElement("location-filter-select", `[data-location~=${locationQuery}]`);
    }
    if (areaQuery.length > 0) {
        loadFilter += `[data-area~=${areaQuery}]`;
        const selector = document.querySelector(`#${areaQuery}`);
        if (selector) $efd80cb101e43b76$var$selectElement("area-filter-select", `[data-area~=${areaQuery}]`);
    }
    if (loadFilter.length === 0) loadFilter = ".mix";
    const mixer = (0, (/*@__PURE__*/$parcel$interopDefault($8399e4e9dca8c987$exports)))(".employees", {
        selectors: {
            target: ".employee"
        },
        load: {
            filter: loadFilter
        },
        multifilter: {
            enable: true
        }
    });
};
const $efd80cb101e43b76$var$selectElement = (id, valueToSelect)=>{
    const element = document.getElementById(id);
    element.value = valueToSelect;
};




class $10e3ed61ca1986bb$var$RemoveFilter extends HTMLElement {
    connectedCallback() {
        const targetsAttribute = this.getAttribute("data-targets").split(",");
        const targets = targetsAttribute.map((item)=>{
            return document.getElementsByName(item);
        });
        let value = this.getAttribute("target-value");
        this.firstElementChild.addEventListener("click", (e)=>{
            targets.forEach((array)=>{
                array.forEach((item)=>{
                    if (item.tagName == "SELECT") {
                        const select = item;
                        select.selectedIndex = 0;
                    }
                    if (item.tagName == "INPUT") {
                        const input = item;
                        if (input.type == "radio" && input.value == value) input.checked = false;
                        if (input.type == "text") input.value = "";
                        if (input.type == "range") {
                            var index = Array.from(input.parentNode.children).indexOf(input);
                            var resetValue = index == 0 ? input.min : input.max;
                            input.value = resetValue;
                        }
                    }
                });
            });
            setTimeout(()=>this.closest("form").requestSubmit(), 120); // set timout
        });
    }
}
customElements.define("remove-filter", $10e3ed61ca1986bb$var$RemoveFilter);


class $5d7baf9ba2f92e62$var$AutoSubmit extends HTMLElement {
    connectedCallback() {
        let disabled = this.hasAttribute("disabled");
        let scrollTop = this.hasAttribute("scroll-top");
        if (!disabled) this.addEventListener("change", (e)=>{
            e.target.form.requestSubmit();
            if (scrollTop) window.scrollTo({
                top: 0
            });
        });
    }
}
customElements.define("auto-submit", $5d7baf9ba2f92e62$var$AutoSubmit);


class $9dbd464c9b56f167$var$CutOff extends HTMLElement {
    connectedCallback() {
        const content = this.firstElementChild;
        const toggle = document.getElementById(this.getAttribute("toggle"));
        const toggleOpenText = this.getAttribute("toggle-open-text");
        const toggleDefaultText = toggle.innerText;
        toggle.addEventListener("click", ()=>{
            this.toggleAttribute("open");
            if (toggle.innerText == toggleDefaultText) toggle.innerText = toggleOpenText;
            else toggle.innerText = toggleDefaultText;
        });
    }
}
customElements.define("cut-off", $9dbd464c9b56f167$var$CutOff);



class $bb918dc707ab6100$var$CarCarousel extends HTMLElement {
    connectedCallback() {
        new (0, $02e68f8ca5696f61$export$24494c7438c070bf)(this, {
            type: "loop",
            perPage: 3,
            perMove: 1,
            gap: "2rem",
            autoplay: true,
            speed: 500,
            interval: 5000,
            pagination: false,
            breakpoints: {
                1400: {
                    perPage: 3
                },
                1200: {
                    perPage: 2
                },
                700: {
                    perPage: 1
                }
            }
        }).mount();
    }
}
customElements.define("car-carousel", $bb918dc707ab6100$var$CarCarousel);


class $e53ee4aa506ad697$export$476e5a0ddaefc29b extends HTMLElement {
    connectedCallback() {
        const sliderColor = getComputedStyle(document.documentElement).getPropertyValue("--slider-track-color");
        const rangeColor = getComputedStyle(document.documentElement).getPropertyValue("--slider-range-color");
        const fromSlider = this.children.length > 1 ? this.firstElementChild : null;
        const toSlider = this.lastElementChild;
        const fromInput = document.getElementById(this.getAttribute("fromInput"));
        const toInput = document.getElementById(this.getAttribute("toInput"));
        const fromText = document.getElementById(this.getAttribute("fromText"));
        const toText = document.getElementById(this.getAttribute("toText"));
        const isDual = fromSlider != null;
        function controlFromInput() {
            const [from, to] = getParsed(fromInput, toInput);
            if (from > to) {
                fromSlider.value = to;
                setFromInput(to);
            } else fromSlider.value = from;
            updateText();
            fillSlider(fromSlider, toSlider, toSlider);
        }
        function updateText() {
            if (toText != null) toText.innerText = toSlider.value;
            if (isDual && fromText != null) fromText.innerText = fromSlider.value;
        }
        function controlToInput() {
            if (isDual) {
                const [from, to] = getParsed(fromInput, toInput);
                setToggleAccessible(toInput);
                if (from <= to) {
                    toSlider.value = to;
                    setToInput(to);
                } else setToInput(from);
            } else toSlider.value = toInput.value;
            updateText();
            fillSlider(fromInput, toInput, toSlider);
        }
        function controlFromSlider() {
            if (isDual) {
                const [from, to] = getParsed(fromSlider, toSlider);
                if (from > to) {
                    fromSlider.value = to;
                    fromInput.value = to;
                } else setFromInput(from);
                updateText();
                fillSlider(fromSlider, toSlider, toSlider);
            }
        }
        function controlToSlider() {
            if (isDual) {
                const [from, to] = getParsed(fromSlider, toSlider);
                setToggleAccessible(toSlider);
                if (from <= to) {
                    toSlider.value = to;
                    setToInput(to);
                } else {
                    setToInput(from);
                    toSlider.value = from;
                }
            } else setToInput(toSlider.value);
            updateText();
            fillSlider(fromSlider, toSlider, toSlider);
        }
        function setToInput(value) {
            if (toInput != null) toInput.value = value;
        }
        function setFromInput(value) {
            if (fromInput != null) fromInput.value = value;
        }
        function getParsed(currentFrom, currentTo) {
            const from = parseInt(currentFrom.value, 10);
            const to = parseInt(currentTo.value, 10);
            return [
                from,
                to
            ];
        }
        function fillSlider(from, to, controlSlider) {
            const rangeDistance = to.max - to.min;
            if (isDual) {
                const fromPosition = from.value - to.min;
                const toPosition = to.value - to.min;
                controlSlider.style.background = `linear-gradient(
                to right,
                ${sliderColor} 0%,
                ${sliderColor} ${fromPosition / rangeDistance * 100}%,
                ${rangeColor} ${fromPosition / rangeDistance * 100}%,
                ${rangeColor} ${toPosition / rangeDistance * 100}%, 
                ${sliderColor} ${toPosition / rangeDistance * 100}%, 
                ${sliderColor} 100%)`;
            } else {
                const toPosition = to.value - to.min;
                controlSlider.style.background = `linear-gradient(
                to right,
                ${rangeColor} 0%,
                ${rangeColor} ${toPosition / rangeDistance * 100}%,
                ${sliderColor} ${toPosition / rangeDistance * 100}%,
                ${sliderColor} 100%)`;
            }
        }
        function setToggleAccessible(currentTarget) {
            if (Number(currentTarget.value) <= 0) toSlider.style.zIndex = 2;
            else toSlider.style.zIndex = 0;
        }
        fillSlider(fromSlider, toSlider, toSlider);
        setToggleAccessible(toSlider);
        if (fromSlider) fromSlider.addEventListener("input", ()=>{
            controlFromSlider();
        });
        toSlider.addEventListener("input", ()=>{
            controlToSlider();
        });
        if (fromInput) fromInput.addEventListener("input", ()=>{
            controlFromInput();
        });
        if (toInput) toInput.addEventListener("input", ()=>{
            controlToInput();
        });
        updateText();
    }
}
customElements.define("flex-slider", $e53ee4aa506ad697$export$476e5a0ddaefc29b);


class $da573d6fef69c7f9$var$FormatMoney extends HTMLElement {
    connectedCallback() {
        const currency = this.getAttribute("currency");
        const culture = this.getAttribute("culture");
        const formatter = new Intl.NumberFormat(culture, {
            style: "currency",
            currency: currency
        });
        const targetNode = this;
        this.innerText = formatter.format(this.innerText);
        const callback = (mutationList, observer)=>{
            if (!isNaN(this.innerText)) this.innerText = formatter.format(this.innerText);
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, {
            childList: true
        });
    }
}
customElements.define("format-money", $da573d6fef69c7f9$var$FormatMoney);



class $302e4292ed98fc0e$var$CarImageCarousel extends HTMLElement {
    connectedCallback() {
        const currentIndexElement = document.getElementById("currentIndex");
        const splide = new (0, $02e68f8ca5696f61$export$24494c7438c070bf)(this, {
            type: "loop",
            perPage: 1,
            perMove: 1,
            autoplay: true,
            speed: 500,
            interval: 5000,
            pagination: false
        }).mount();
        setIndex(splide.index);
        splide.on("mounted move", function() {
            setIndex(splide.index);
        });
        function setIndex(value) {
            currentIndexElement.innerText = (value + 1).toString();
        }
    }
}
customElements.define("car-image-carousel", $302e4292ed98fc0e$var$CarImageCarousel);



class $fcce2be712fd6ecf$var$HeroCarousel extends HTMLElement {
    connectedCallback() {
        const splide = new (0, $02e68f8ca5696f61$export$24494c7438c070bf)(this, {
            type: "loop",
            interval: 5000,
            autoplay: true,
            arrows: false
        }).mount();
    }
}
customElements.define("hero-carousel", $fcce2be712fd6ecf$var$HeroCarousel);


class $372817ba66a20afe$var$DetailsCloser extends HTMLElement {
    connectedCallback() {
        const details = this.querySelectorAll("details");
        details.forEach((el1)=>{
            el1.addEventListener("toggle", (e)=>{
                if (el1.hasAttribute("open")) details.forEach((el2)=>{
                    if (el1 !== el2) el2.removeAttribute("open");
                });
            });
        });
    }
}
customElements.define("details-closer", $372817ba66a20afe$var$DetailsCloser);


(0, $f111f945f972b324$export$2e2bcd8739ae039).start();
document.addEventListener("turbo:before-cache", function() {
    var cookieConsent = document.getElementById("CookieConsent");
    if (cookieConsent) cookieConsent.remove();
    document.querySelectorAll("details").forEach((d)=>{
        d.removeAttribute("open");
    });
});
document.addEventListener("turbo:load", function() {
    const burgerClose = document.querySelector("figure.close");
    const mobileMenu = document.querySelector("#burgerNavigationDetails");
    burgerClose.addEventListener("click", ()=>{
        mobileMenu.removeAttribute("open");
    });
    if (document.querySelector("#iframe-block")) {
        var iframe = document.createElement("iframe");
        iframe.src = document.querySelector("#iframe-block").getAttribute("data-src");
        iframe.frameBorder = "0";
        document.querySelector("#iframe-block").appendChild(iframe);
    }
    if (document.querySelector("#location-page")) (0, $ec1ca42a27246f5f$export$11492d885e5574aa)();
    if (document.querySelector("#employees-page")) (0, $efd80cb101e43b76$export$376097161d664db1)();
    if (document.querySelector("#kontakt-formular")) document.querySelector("#kontakt-formular").scrollIntoView();
    if (document.querySelector("#car-contact-form-dialog")) {
        var contactButton = document.querySelector("#car-contact-form-button");
        var closeButton = document.querySelector("#car-modal-close");
        var dialog = document.querySelector("#car-contact-form-dialog");
        contactButton.addEventListener("click", ()=>{
            dialog.open = true;
        });
        closeButton.addEventListener("click", ()=>{
            dialog.open = false;
        });
    }
    const modalButtons = document.getElementsByClassName("call-button");
    for(let i = 0; i < modalButtons.length; i++)modalButtons[i].addEventListener("click", ()=>{
        const locationId = modalButtons[i].getAttribute("data-location-id");
        const modal = document.getElementById(`phone-modal-${locationId}`);
        modal.showModal();
    });
    const closeModalButtons = document.getElementsByClassName("close-modal-button");
    for(let i = 0; i < closeModalButtons.length; i++)closeModalButtons[i].addEventListener("click", ()=>{
        const locationId = modalButtons[i].getAttribute("data-location-id");
        const modal = document.getElementById(`phone-modal-${locationId}`);
        modal.close();
    });
});

})();
//# sourceMappingURL=main.js.map
